export const TRANSLATION_KZ = {
	more: 'еще',
	resend: 'Қайта жіберу',
	about_projects: {
		title_1: 'Жоба туралы',
		text_1:
			'<p><strong>«hr.enbek.kz»</strong> еңбек ресурстары порталы – бұл <strong>«Электрондық еңбек биржасы»</strong> экожүйесінің негізгі элементі, еңбек шарттарына байланысты процестерді автоматтандыру үшін құрылған. Еңбек шарттарын жасау және тоқтату, өзгерістер мен толықтырулар енгізу, сондай-ақ әлеуметтік демалыстарды есепке алу сияқты міндеттерді ыңғайлы және ашық басқаруды қамтамасыз етеді.</p>' +
			'<p>Портал кадрлық іс жүргізуді оңайлатып, автоматтандыруға ықпал етіп, жұмыс берушілерге еңбек заңнамасын сақтауға көмектеседі, сондай-ақ жұмыскерлердің құқықтарын қорғайды. Еңбек шарттарын есепке алудың бірыңғай жүйесімен (ЕШЕБЖ) толық синхрондалуы оны еңбек қатынастары туралы сенімді ақпарат көзіне айналдырады.</p>' +
			'<p>Порталдың артықшылықтарының бірі – <strong>Жұмыспен қамтудың бірыңғай цифрлық платформасы</strong> аясында бірыңғай авторизациялау мүмкіндігі, бұл пайдаланушыларға қосымша тіркеу жазбаларын жасамай, экожүйенің басқа порталдарын пайдаланып жұмыс істеуге мүмкіндік береді. Авторизациядан кейін пайдаланушылар Порталда Жұмыс беруші ретінде де,  Жұмыскер ретінде де әрекет ете алады.</p>' +
			'<p><strong>«hr.enbek.kz»</strong> порталы – бұл қазіргі цифрлық Қазақстанда еңбек қатынастарына барлық қатысушыларға арналған  сенімді көмекші.</p>',
		title_2: 'Порталдың кәсіпорындарға арналған мүмкіндіктері',
		text_2:
			'<ul>' +
			'<li>Жұмыс істеп жатқан жұмыскерлермен еңбек шарттарын тіркеу және оларды өзгерту;</li>' +
			'<li>Жұмыскерден еңбек шарттарын түзету туралы өтініштерді қарау (бұзу, жою, түзету туралы өтініштерді қарау);</li>' +
			'<li>Электрондық еңбек шартын eGov Mobile Business қосымшасы арқылы ЭЦҚ немесе QR-қолтаңба көмегімен қашықтан жасасу;</li>' +
			'<li>Штаттық кестені жүргізу (құрылымын, штат құрамын жүргізу, жұмыскерлер саны, жұмыс орындарын есепке алу және т.б.);</li>' +
			'<li>Еңбек заңнамасының сақталуын онлайн тексеру (жұмыс берушінің қызметіндегі бұзушылықтарды анықтау);</li>' +
			'<li>Еңбек шартын бұзу немесе қосымша келісімді тіркеу арқылы зиянды еңбек жағдайында жұмыс істейтін жұмыскерлер үшін кәсіби төлемді тағайындау бойынша проактивті қызметті ресімдеу;</li>' +
			'<li>Жүктілік және босануға байланысты әлеуметтік демалысты тіркеу арқылы проактивті қызмет көрсету;</li>' +
			'<li>Жұмыскердің келісімімен жұмыскердің жеке ісін сұрату (жұмысқа орналасуға қажет электрондық құжаттар пакеті);</li>' +
			'<li>Жұмыскер туралы пікір қалдыру;</li>' +
			'<li>Алғашқы және жергілікті кәсіподақтарды құру және оның мүшелерін есепке алу;</li>' +
			'<li>Электрондық ұжымдық шарт жасау және оны еңбек инспекциясымен келісу;</li>' +
			'<li>Мемлекеттік органдардың ақпараттық жүйелерінен кәсіпорын туралы ақпарат, жұмыскерлердің жағдайы және кәсіпорындағы бұзушылықтар туралы деректер көрсетілген Цифрлық картаға қолжетімділік;</li>' +
			'<li>Өндірістегі жазатайым оқиға туралы хабарламаны тіркеу;</li>' +
			'<li>Еңбек шарттары, жаңартулар мен қызметтердің мәртебесі туралы хабарламаларды нақты уақыт режимінде алу.</li>' +
			'</ul>',
		title_3: 'Порталдың жұмыскерлерге арналған мүмкіндіктері',
		text_3:
			'<ul>' +
			'<li>Жұмыс берушілер тіркеген еңбек шарттарын қарау;</li>' +
			'<li>eGov Mobile қосымшалары арқылы ЭЦҚ немесе QR-қолтаңбаның көмегімен жұмыс берушімен электрондық еңбек шартын қашықтан жасасу;</li>' +
			'<li>Мәліметтерді өзектендіру үшін еңбек шартын түзетуге сұрау жіберу;</li>' +
			'<li>Электрондық еңбек кітапшасын жүктеп алу;</li>' +
			'<li>Жұмыс орнынан анықтама алу;</li>' +
			'<li>Жұмыс берушіге жеке деректерді жинап, өңдеуге келісімін беру;</li>' +
			'<li>Өзінің Жеке ісін қарау;</li>' +
			'<li>Жұмыс беруші туралы пікір қалдыру;</li>' +
			'<li>Зиянды еңбек жағдайында жұмыс істейтін жұмыскерлер үшін арнайы әлеуметтік төлемді алуға құқығының бар-жоғы мен оның мөлшерін тексеруге арналған арнайы әлеуметтік төлем калькуляторы;</li>' +
			'<li>Электрондық сырқаттану парақтарын қарау және оларды жұмыс берушіге жіберу мүмкіндігі;</li>' +
			'<li>Кәсіподақтарды қарау және оларға кіру мүмкіндігі;</li>' +
			'<li>Еңбек шарттары, жаңартулар мен қызметтердің мәртебесі туралы хабарламаларды нақты уақыт режимінде алу.</li>' +
			'</ul>',
		text_4:
			'<p>Жұмыскерлерге арналған функциялар App Store және Google Play-дағы Enbek HR мобильдік қосымшасында  да қолжетімді.</p>' +
			'<p>Біз порталды пайдаланушылар үшін  ыңғайлы және тиімді етуге ұмтыламыз. Жақын арада пайдалы болатын көптеген жаңарту мен жаңа функцияларды енгізу жоспарланып отыр. Жаңа мүмкіндіктер туралы бірінші болып білу үшін портал хабарламалары мен ресми Instagram парақшасына жазылыңыз!</p>',
	},
	join_prof_unions: 'Мен кәсіподаққа дербес деректерді жинауға және өңдеуге келісім беремін',
	term_etd_requests: 'ЭЕШ бұзуға сұрау салу',
	voice_robot: '(дауыстық Робот сұрағына "еңбек ресурстары порталы" деп айтыңыз)',
	has_error: 'Қате пайда болды, кейінірек қайталап көріңіз',
	no_data: 'Сұрауға сәйкес деректер табылған жоқ',
	no_contract: 'Сіз әлі бірде-бір шартты тіркеген жоқсыз!',
	specification: 'Сипаттамасы',
	every_employer_is_given_the_opportunity_to: 'Әрбір жұмыс берушіге еңбек заңнамасы талаптарының сақталуын',
	self_check_yourself: 'ӨЗ БЕТІНШЕ ТЕКСЕРУДЕН ӨТУ',
	compliance_requirements_labor_legislation: 'мүмкіндігі беріледі.',
	self_check_performs: 'Өзін-өзі тексеру',
	auxiliary: 'КӨМЕКШІ',
	tool_and_provides: 'құрал болып табылады және цифрлық құралдарды енгізу арқылы еңбек',
	assistance_for_improvement: 'ЖАҒДАЙЛАРЫН ЖАҚСАРТУҒА КӨМЕКТЕСЕДІ',
	working_conditions_due_introduction_digital_tools: '.',
	the_service_is: 'Сервис',
	anonymous: 'АНОНИМДІ',
	name_organization_personal_data_not_requested_no_pre_registration_required:
		'болып табылады, ұйымның атауы, Жеке деректер сұратылмайды және алдын ала тіркелу талап етілмейді.',
	start_self_test_you_need_fill_out_preliminary_questionnaire:
		'Өзін-өзі тексеруді бастау үшін алдын-ала сауалнаманы толтыру қажет.',
	questionnaire: 'Сауалнама',
	category_entrepreneurship: 'Кәсіпкерлік санаты (қажеттісін таңдау)',
	small: 'Шағын',
	medium: 'Орташа',
	large: 'Ірі',
	choose_topic_self_test: 'Тақырыпты таңдаңыз',
	count_employee: 'Қызметкерлер саны',
	topic_not_selected: 'Тақырып таңдалмаған',
	you_employees_disabilities_groups: 'Сізде 1 және 2 топтағы мүгедектігі бар қызметкерлер бар ма?',
	people_under_age_eighteen_work: 'Сізде он сегіз жасқа толмаған адам жұмыс істей ме?',
	pregnant_women_work_you: 'Сізде жүкті әйелдер жұмыс істей ме?',
	shift_method_work: 'Сізде вахталық жұмыс әдісі қолданылады ма?',
	harmful_dangerous_working_conditions: 'Сізде зиянды, қауіпті еңбек жағдайлары бар ма?',
	yes: 'Иә',
	no: 'Жоқ',
	pass_self_test: 'Өзін-өзі тексеруден өту',
	be_tested: 'Тексеруді өту',
	history_passing: 'Тексеріс өту тарихы',
	history_check: {
		check_date: 'Тексеру күні',
		result: ' Нәтижесі',
		action: 'Әрекет',
		watch_action: 'Қарау',
		no_data: 'Сізде тексеруден өту тарихы жоқ',
		has_error: 'Қате пайда болды, кейінірек қайталап көріңіз',
		check_history: 'Сүзгіні жасыру',
		filter: 'Сүзгі',
		total_checks: 'Барлық тексерулер: ',
		check_subject: 'Тексеру тақырыбы',
		loading: 'Жүктеу',
		checklist: 'Тексеру парағы',
		business_name: 'Кәсіпорынның атауы',
		answers_questions: 'Сұрақтарға жауаптар',
		replay: 'Қайта өту',
	},

	how_service_works: 'Қызмет қалай жұмыс істейді?',
	find_topic_you_need_using_search_category: 'Іздеу немесе санатты қолдана отырып, қажетті тақырыпты табыңыз',
	choose_topic_start_answering_questions:
		'Тақырыпты таңдап, ұйымдағы ағымдағы күйіңізді ескере отырып, сұрақтарға жауап бере бастаңыз',
	complete_self_test: 'Өзін-өзі тексеруді аяқтаңыз',
	system_will_analyze_responses_form_conclusion:
		'Жүйе жауаптарды талдайды және бұзушылықтардың тізбесі немесе олардың болмауы, ұсынымдар көрсетілетін қорытынды жасайды.',
	violations_are_detected_employer_will_offered_recommendations:
		'Бұзушылықтар анықталған жағдайда, жұмыс берушіге оларды жою мақсатында қабылдануы тиіс ұсынымдар мен нақты іс-қимылдар ұсынылатын болады',
	after_violations_eliminated_you_can_re_check_yourself:
		'Бұзушылықтарды жойғаннан кейін қайта өзін-өзі тексеруден өтуге болады',
	how_will_help: '«Онлайн еңбек кеңесшісі» қалай көмектеседі?',
	independently: 'Еңбек заңнамасының талаптарын өз бетінше',
	sort_out: ' ',
	irequirements_labor_legislation: 'түсіну',
	understand: 'Алдын ала бұзушылықтарды түсіну',
	estimate: 'бағалау',
	preliminary_violations: ' ',
	get: 'Бұзушылықтарды жою бойынша',
	recommendations: 'ұсынымдар',
	methods: 'тәсілдерді',
	eliminate_violations: 'алу',
	improve: '',
	working_conditions: 'Еңбек жағдайын жақсарту',
	independentlyUtil: 'Бұзушылықтарды өз бетінше',
	correct: 'жою',
	violations: '',
	avoid: '',
	regulations_fines_real_check: 'Нақты тексеру жағдайында ұйғарымдар мен айыппұлдарды аулақ болдырмау',
	save_money: '',
	time_means_real_verification: 'Нақты тексеру кезінде уақыт пен ақшаны үнемдеу',
	service: 'Сервис ',
	online_labor: '"Еңбек кеңесшісі"',
	checksTab: 'ТЕКСЕРУЛЕР',
	historyChecksTab: 'ТЕКСЕРУ ТАРИХЫ',
	consultant: ' кеңесшісі',
	start_self_test: 'Өзін-өзі тексеруді бастау үшін',
	must_select_topic: 'тақырыпты таңдау керек',
	question_number: 'Сұрақ ',
	next_question: 'Келесі сұрақ',
	complete_self_test_button: 'Өзін-өзі тексеруді аяқтау',
	result: ' Нәтижесі',
	service_online_labor_consultant_check: '«Еңбек кеңесшісі» сервисі еңбек заңнамасы талаптарының сақталуын тексерді.',
	self_test_date: 'Өзін-өзі тексеру күні:',
	chapter: 'Бөлім: ',
	self_test_duration: 'Өзін-өзі тексеру ұзақтығы: ',
	following_violations_identified: 'Келесі бұзушылықтар анықталды:',
	no_violations_found: 'Бұзушылықтар анықталған жоқ',
	recommendationsTest: 'Ұсынымдар',
	download_result: 'Нәтижені жүктеп алу',
	year: ' ж.',
	workforce_portal: 'Еңбек ресурстары порталы келесі кадрлық іс жүргізу процестерін жеңілдетеді:',
	providing_access:
		'•\tҚызметкерлердің бірыңғай бейініне және еңбек тарихына қол жеткізуді ұсыну (қызметкердің қатар жұмыспен қамтылуы туралы хабардар болу);',
	reducing_risks:
		'•\tДеректерді бұрмалау қауіпін қысқарту (еңбек өтілі, еңбекке жарамсыздық парақтары, соттылықтар, шектеулер мен тыйым салулар);',
	simplification_personal: '•\tҚызметкерлердің жеке істерін жүргізуді оңайлату;',
	reducing_cost: '•\tЕңбек шарттарын ресімдеу құнын төмендету (қағаз шарттардан бас тарту жолымен).',
	convenience: 'Жұмыс берушілерге ыңғайлы болу үшін порталда қызметкердің жеке ісін ұсыну сервисі іске асырылады.',
	when_hiring: 'Жұмысқа қабылдау кезінде жұмыс беруші портал арқылы қызметкердің',
	personal_file: ' жеке ісін ',
	employee_electronic_format:
		'электрондық форматта алуға Еңбек шарттарын есепке алудың бірыңғай жүйесіне (бұдан әрі - ЕШЕБЖ) сұрау салуды жүзеге асыра алады. Жеке істегі мәліметтерді ескере отырып, жұмыс беруші қызметкерді жұмысқа қабылдау және онымен еңбек шартын жасасу туралы шешім қабылдайды. Сондай-ақ, жұмыс беруші электрондық еңбек шартының жобасын қалыптастыра алады. Бұл қызмет құжаттарды қолдан жасау қаупін жояды және еңбек шарттарын жасасу кезінде қағаз құжаттарды ұсынудан бас тарту арқылы жұмысқа орналастыруды жеделдетуге мүмкіндік береді.',
	part_of_service_providing:
		'Қызметкердің жеке ісін ұсыну сервисі шеңберінде ЕШЕБЖ ҚР Әділет министрлігі, ҚР Ғылым және білім министрлігі, ҚР Бас прокуратурасының Құқықтық статистика және арнайы есепке алу комитеті (бұдан әрі - ҚР БП ҚСжАЕК), ҚР Денсаулық сақтау министрлігі (бұдан әрі-ҚР ДСМ), ҚР Еңбек және халықты әлеуметтік қорғау министрлігі Мемлекеттік органдардың ақпараттық жүйелерімен интеграцияланған.',
	the_employer_opportunity: 'Осылайша, жұмыс беруші жеке істен келесі мәліметтерді алдын ала алу мүмкіндігіне ие:',
	information_about: '•\tЖеке куәліктен жеке тұлға туралы ақпарат;',
	photo_image: '•\t Фотосурет;',
	information_about_family: '•\t Отбасы мүшелері туралы ақпарат;',
	information_about_education: '•\t Білім туралы ақпарат;',
	electronic_certificate: '•\t Соттылықтың болмауы/болуы туралы электрондық анықтама;',
	information_about_status: '•\t Психо, нарко және туб. диспансерлерде есепте тұрғаны туралы ақпарат;',
	electronic_medical: '•\t Электрондық медициналық анықтама 0/75у;',
	electronic_certificate_disability: '•\t Мүгедектік туралы электрондық анықтама;',
	information_from: '•	 ЕШЕБЖ-дан жұмыс тәжірибесі туралы ақпарат',
	availability_vaccinations: '•\t Вакцинацияның болуы туралы ақпарат.',
	employer_right:
		'Жұмыс беруші таңдау үшін әлеуметті қызметкер туралы Еңбек кодексінде сипатталған шарттар аясында кез келген ақпаратты сұратуға құқылы. Қызметкердің жеке ісін үшінші тұлғаға беру "Дербес деректер және оларды қорғау туралы" Қазақстан Республикасының 2013 жылғы 21 мамырдағы №94-V Заңына және Қазақстан Республикасының өзге де нормативтік құқықтық актілеріне сәйкес қызметкердің дербес деректерді өңдеуге келісімімен ғана беріледі. Келісімде деректерді сұратушы ұйым туралы ақпарат міндетті түрде қамтылуға тиіс.',
	service_will_be_available:
		'Сервис еңбек ресурстары порталында және кәсіпорынның кадрлық есебі АЖ және басқа порталдар арқылы интеграциялау үшін қолжетімді болады. Жұмыс беруші сұрауды дереу келісіммен немесе онсыз жібере алады. Мұндай жағдайда келісімді ЕШЕБЖ жүйесінің өзі сұрайды. Қызметкердің келісімі еңбек ресурстары порталында, кадрлық есепке алу АЖ-да және смс арқылы қол қоя алады. ЕСУТД қызметкердің жауабын 7 күнтізбелік күн күтеді. Бас тартылған немесе жауап болмаған жағдайда, жұмыс берушіге деректерді ұсынудан бас тартылады. Келісім ақпарат сұраған ұйымдағы барлық жұмыс мерзіміне жарамды болады. Егер келісім жасалмаса немесе бұзылмаса, келісім автоматты түрде заңсыз болып саналады.',
	addition_registering:
		'Еңбек шарттарын тіркеу және жеке іс алумен қатар, порталды одан әрі дамыту перспективасында жұмыс беруші үшін:',
	conclusion_electronic: '- электрондық еңбек шарттарын жасасу;',
	obtaining_electronic: '- есепке алу үшін электрондық аурухана парақтарын алу;',
	submission_reports:
		'- еңбек инспекциясына және басқа қалаларға есептілікті тапсыру бойынша қызметтерді іске асыру жоспарлануда.',
	on_the_basis:
		'Еңбек шарттары бойынша енгізілген деректер негізінде қызметкердің электрондық еңбек кітапшасы қалыптастырылады. Бұл қағаз нұсқасын жүргізу қажеттілігін жояды. Қызметкер өзінің еңбек қызметін кез келген уақытта растай алады.',
	first_of_all:
		'Ең алдымен, қызметкердің Еңбек шарттарын есепке алудың бірыңғай жүйесінде тіркелген еңбек шарттарын көруге және оның еңбек шарттарымен жасалған барлық әрекеттер туралы хабарламалар алуға мүмкіндігі бар.',
	in_the_near_future:
		'Жақын арада жұмысқа қабылдау кезінде жұмыс беруші Портал арқылы қызметкердің жеке ісін электрондық форматта алуға Еңбек шарттарын есепке алудың бірыңғай жүйесіне (бұдан әрі - ЕШЕБЖ) сұрау салуды жүзеге асыра алады. Сондай-ақ, қызметкер жеке деректерді өңдеуге келісімге қол қойып, жұмыс берушінің жеке ісін қарап, өмірбаян толтыра алады. Осы мәліметтер негізінде жұмыс беруші еңбек шартының жобасын жасайды. Сондай-ақ порталда ЭЦҚ көмегімен электрондық еңбек шартына қашықтықтан қол қою қолжетімді болады.',
	ESUTD_is_reference_base:
		'ЕШЕБЖ қызметкерлердің еңбек қызметі бойынша эталондық база болып табылады және кредиттік ұйымдар, сондай-ақ басқа да коммерциялық ұйымдар мен мемлекеттік органдар үшін «Дербес деректерді қорғау туралы» заңға сәйкес қызметкердің еңбек қызметін растау көзі болып табылады.',
	link_to_rules: 'Қағидаларға сілтеме',
	file: 'Файл',
	download_rules:
		'Еңбек шарттарын есепке алудың бірыңғай жүйесінде еңбек шарты туралы мәліметтерді ұсыну және алу қағидаларын жүктеу (*pdf)',
	download_rules_harmful:
		'Жұмыс берушінің қаражаты есебінен кәсіби төлемді жүзеге асыру, тоқтата тұру, қайта бастау және тоқтату қағидаларын жүктеу (*pdf)',
	download_methodology:
		'Қызметкерді жазатайым оқиғалардан міндетті сақтандыру шарты бойынша төлемдер бойынша әдістемелік құралдарын жүктеу (*docx)',
	download_instruct: 'Нұсқаулықты жүктеу (*.pdf)',
	integration_unified_system: 'Еңбек шарттарын тіркеу',
	the_service_is_intended_registration:
		'Сервис еңбек шарттарының, қосымша келісімдердің және бұзылулардың есептік деректерін тіркеуге арналған',
	service_assignment: 'Сервистің мақсаты',
	link_service_smartbridge: 'Smartbridge платформасындағы сервиске сілтеме',
	download_archive_service: 'Сервис сипаттамасы бар мұрағатты жүктеу (*rar)',
	the_service_is_designed_batch_loading: 'Сервис еңбек шарттарын пакеттік жүктеу үшін арналған',
	integration_unified_system_recording_fastening: 'Синхронды тіркеу',
	the_service_is_designed_to_synchronize:
		'Сервис клиенттен еңбек шарттары туралы деректерді еңбек шарттарын есепке алудың бірыңғай жүйесінің деректерімен үндестіруге арналған',
	service_description: 'Сервистің сипаттамасы',
	question1: 'Нr.enbek.kz порталында жаңа пайдаланушы ретінде қалай тіркелуге болады?',
	question46: 'Неліктен менде "еңбек шарттары"бөлімі ашылмайды?',
	answer46:
		'"Еңбек шарттары" бөлімі профильде кемінде бір кәсіпорын қосылған "жұмыс беруші" рөлі бар пайдаланушылар үшін, сондай-ақ тексеруден өткен "Қызметкер" рөлі бар пайдаланушы үшін ғана қол жетімді.',
	question48:
		'Жаңа еңбек шартын қосқан кезде сәтті сақталғаны туралы хабарлама шығады, бірақ қол қою үшін тізімінен еңбек шартын таба алмаймын, қалай табуға болады?',
	answer48:
		'Сақталған (жергілікті)  ЕШ табу үшін, кеңейтілген іздеу жүйесінде «Қолтаңбаны күтуде» күйін таңдау керек. Әдепкі бойынша, ЕШ тізімінде тек ЕШЕБЖ-да тіркелген  (қол қойылған және ЕШЕБЖ-ға жіберілген) ЕШ ғана көрсетіледі.',
	answer1:
		'Кіру «Еnbek.kz» авторизацияның бірыңғай терезесі арқылы жүзеге асады. Порталда жұмыс беруші ретінде тіркелу үшін басты беттің жоғарғы оң жақ бұрышындағы «Кіру» батырмасын басу қажет. Ашылған терезеде «Тіркеу» түймесін басып, содан кейін тіркеу нысаны ашылады, онда:',
	answer1_1: '1.\tТіркеу формасын толтырыңыз. Кеңестерде көрсетілген ақпаратқа назар аударыңыз.',
	answer1_2: '2.\tТіркеу формасын толтырғаннан кейін «Тіркелгі жасау» түймесін басыңыз.',
	answer1_3:
		'3.\tӘрі қарай, тіркелгіні іске қосу үшін сілтеме көрсетілген электрондық пошта мекенжайына жіберіледі. Тіркелу кезінде көрсетілген электрондық поштаны тексеріп, хатта көрсетілген сілтемеге өту керек, есептік жазба сәтті іске қосылады. Маңызды! Тіркеу кезінде көрсетілген электрондық пошта мекенжайы мен құпия сөзді есте сақтаңыз! Олар Сізге порталға кіру үшін қажет.',
	question2: 'Құпия сөзді ұмытқан жағдайда не істеу қажет?',
	answer2:
		'Егер сіз өзіңіздің тіркелгі жазбаңыздан парольді ұмытып қалсаңыз, парольді қалпына келтіру функциясын қолданыңыз. Бұл функцияға сілтеме авторизация түрінде қол жетімді және «Құпия сөзді ұмыттыңыз ба?» - деп аталады.',
	question3:
		'Мен жұмыс берушімін, осы порталға қызметкерлердің еңбек шарттары және еңбек шартын тоқтату жайлы ақпаратты еңгізбеуіме болады ма?',
	answer3:
		'Қазақстан Республикасының қолданыстағы Еңбек кодексінің 23 -бабы 2 -тармағының 27 -тармақшасына сәйкес жұмыс беруші қызметкермен еңбек шартын жасасу және бұзу, оған өзгерістер және (немесе) толықтырулар енгізу туралы ақпаратты енгізуге міндетті.\n' +
		'Оны осы портал немесе еңбек шарттарын есепке алудың бірыңғай жүйесіне қосылған кез келген басқа жүйе арқылы жасауға болады.\n',
	question4: 'Осы Порталда қызметтер ақылы түрде көрсетіледі ме? Солай болса, қайсысы?',
	answer4: 'Еңбек ресурстары порталында (hr.enbek.kz) барлық ағымдағы қызметтер тегін көрсетіледі.',
	question5: 'Егер қызметкер жұмыстан шығып, еңбек шарты бұзылса, келісімшартты жою керек пе?',
	answer5:
		'«Еңбек шарттарын есепке алудың бірыңғай жүйесінде еңбек шарты туралы мәліметтерді ұсыну және алу қағидаларына» (бұдан әрі-қағидалар) сәйкес жұмыс беруші қажет болған жағдайда бастапқы мәліметтерді енгізген күннен бастап күнтізбелік 30 күн ішінде:',
	answer5_1:
		'1) осы қағидалардың 3 және 6-тармақтарында көрсетілген мәліметтер дұрыс енгізілмеген кезде қателерді түзетеді;',
	answer5_2: '2) қызметкердің және (немесе) жұмыс берушінің деректемелері дұрыс енгізілмеген кезде мәліметтерді жояды.',
	answer5_3:
		'Осыған байланысты еңбек шартын (бұдан әрі- ЕШ) жою қате тіркелген шарттар болған жағдайда ғана қолданылады. ЕШ бұзған жағдайда, ЕШ бұзу функционалын пайдалану қажет. Ережеге сәйкес ЕШ бұзу, бұзылған күннен бастап 3 жұмыс күні ішінде енгізіледі.',
	question6: 'Қате жасалған еңбек шарттарын қалай жоюға болады?',
	answer6:
		'Еңбек шартын жою үшін шарттар тізімінде шартты таңдау қажет, осы шартқа қарама-қарсы «Әрекет» батырмасын басу және ашылмалы мәзірден «Шартты жою» әрекетін таңдау қажет.',
	question7:
		'Негізгі компанияға қабылданған қызметкерлер бар, ал аударымды филиал жасайды. Бұл жағдайда қалай болу керек? Еңбек шартын кім тіркеуі керек?',
	answer7:
		'Еңбек кодексінің 1-бабы 1-тармағының 39-тармақшасына сәйкес жұмыс беруші - бұл қызметкермен еңбек қатынастарында болатын жеке немесе заңды тұлға.\n' +
		'ҚР Азаматтық кодексінің (бұдан әрі – ҚР АК) 33-бабына сәйкес меншік, шаруашылық жүргізу немесе жедел басқару құқығында оқшауланған мүлкі бар және осы мүлікпен өз міндеттемелері бойынша жауап беретін, өз атынан мүліктік және жеке мүліктік емес құқықтар мен міндеттерді сатып ала алатын және жүзеге асыра алатын, сотта талапкер және жауапкер бола алатын ұйым заңды тұлға деп танылады.\n' +
		'Сонымен қатар, филиалдар мен өкілдіктер заңды тұлға болып табылмайтынын атап өтеміз. Оларға өздерін құрған заңды тұлға мүлік береді және олар бекіткен Ережелер негізінде әрекет етеді (ҚР АК 43-бабының 3-тармағы).\n' +
		'Осылайша, қызметкермен еңбек шарты заңды тұлғамен, яғни бас кәсіпорынмен жасалады және бас кәсіпорын ЕШЕБЖ-ға ақпарат енгізеді.\n',
	question8:
		'Салық төлеушінің ЖК-не ай сайын тіркелген ЕШ мен МЗЖ және ӘА бар қызметкерлер саны арасындағы айырмашылықтар туралы хабарлама келеді, осы хабарлама үшін айыппұл көзделген бе?',
	answer8:
		'Бұл хабарлама ақпараттық сипатта (жауап талап етілмейді). ҚР Еңбек және халықты әлеуметтік қорғау министрлігі айына бір рет жұмыс берушілер ЕШЕБЖ-дағы еңбек шарттарының санын бақылай алатындай  және МЗЖ/ӘА туралы мәліметтерден айырмашылықтар болған жағдайда барлығын сәйкестендіре алатындай хабарлама таратуды орындайды.\n' +
		'Осы хабарламадағы ұсынымдарды орындамағаны үшін қылмыстық және әкімшілік жауапкершілік көзделмеген.\n',
	question9:
		'Қызметкер жалақысы сақталмайтын демалыста болған жағдайда зейнетақы жарналары болмайды, ал ол бойынша еңбек шарты ЕШЕБЖ-да тіркеледі, бұл айыпмашылық болады ма?',
	answer9:
		'Егер қызметкердің жалақысы сақталмайтын демалыста болуы жүктілікке және босануға, жаңа туған баланы (балаларды) асырап алуға байланысты болса, онда ол МЗЖ бойынша айырмашылыққа берілмейді. \n' +
		'Басқа жағдайларда сәйкессіздікке берілетін болады, бірақ ол негізді себеп болып табылады және осы хабарлама тек ақпараттық сипатта болатындығын еске саламыз.\n',
	question10:
		'Жұмыс беруші қызметкердің ЕШ туралы ақпаратты енгізбестен бұрын жеке деректерді өңдеуге келісімге қол қоюы керек пе?',
	answer10: 'Жұмыс берушінің қалауы бойынша.',
	question11: 'Мен жеке кәсіпкермін. Маған өзім туралы мәліметтерді енгізуім керек пе?',
	answer11:
		'Мәліметтер тек еңбек шарттары бойынша енгізіледі. Жеке кәсіпкер жағдайында еңбек шарты жасалмайды. Сондықтан жеке кәсіпкерлер өздеріне ақпарат енгізбейді.',
	question12: 'Бейрезиденттер бойынша мәліметтерді енгізу керек пе?',
	answer12: 'Иә. Барлық жалдамалы қызметкерлердің еңбек шарттары бойынша мәліметтер енгізіледі.',
	question13: 'Егер бейрезидентте ЖСН болмаса (немесе ЖСН бойынша қате шықса) не істеу керек?',
	answer13: '-ҚР-да тұруға ықтиярхаты жоқ шетел азаматтары келесі жағдайларда ЖСН алуы тиіс:',
	answer13_1:
		'- егер банкте шот ашу қажет болса;\n' +
		'- егер шетелдік азамат Қазақстанда орналасқан көздерден табыс алатын болса;\n' +
		'- салық салынатын мүлікті сатып алу кезінде (авто, жылжымайтын мүлік);\n' +
		'- ҚР резиденті –заңды тұлғаның басшысы немесе бейрезидент-заңды тұлға филиалының басшысы болып тағайындалған кезде.',
	answer13_2:
		'ЖСН алудан бұрын шетелдіктер Қазақстанның көші-қон полициясынан уақытша тіркеуден өтуге міндетті. Содан кейін ҚР ҚМ КХД-ға (салық органы) немесе ХҚКО-ға жүгіну қажет.\n' +
		'Еңбек шартын қосу кезінде ЖСН болмаған жағдайда (ЖСН бойынша деректер жеке тұлғалардың мемлекеттік дерекқорынан сұратылады), сізге өз аймағыңыздың көші-қон полициясына жүгіну қажет.\n',
	question14: 'Мемлекеттік қызметкерлер бойынша мәліметтерді енгізу қажет пе?',
	answer14: 'Еңбек кодексінде мемлекеттік қызметкерлердің еңбек қызметі жөніндегі мәліметтерді енгізу көзделмеген.',
	question15:
		'Егер 2007 жылға дейін Қазақстан Республикасының Еңбек кодексі еңбек шартының міндетті түрде болуын реттемегендіктен, еңбек шарты жасалмаса не істеу керек?',
	answer15:
		'Қолданыстағы Еңбек кодексіне сәйкес еңбек шарты міндетті түрде жасалуы керек. Осыған сәйкес, егер ол болмаса, онда сіз еңбек шартын жасасып, ол туралы ақпаратты ЕТД-ге енгізуіңіз керек.',
	question16: 'ЕШ тіркеу кезінде кәсіпорынның ЭЦҚ кімге ресімделуі тиіс?',
	answer16:
		'Еңбек шарттарын тіркеу кезінде заңды тұлғаның басшысына не басшының сенім білдірілген тұлғасына ресімделген жұмыс берушінің ЭЦҚ пайдаланылады. Бұл кадр бөлімінің қызметкері болуы мүмкін.',
	question17: 'Жұмыстан босатылған қызметкерлердің еңбек шарттарын тіркеу қажет пе?',
	answer17:
		'Егер қызметкер 18.09.2020 жылға дейін жұмыстан кетсе, онда ЕШ тіркеудің қажеті жоқ.\n' +
		'Егер қызметкер 18.09.2020 ж. кейін жұмыстан кетсе, онда ЕШ тіркеу міндетті болып табылады.\n',
	question18: '18.09.2020 жылға дейін еңбек шарты жасалған қызметкерлердің мәліметтерін енгізу қажет пе?',
	answer18:
		'Қолданыстағы барлық еңбек шарттарын енгізу қажет. Бұл ретте, 18.09.2020 жылға дейін қабылданған жұмыс істеп жүрген қызметкерлердің деректерін:',
	answer18_1:
		'-\tсаны 2000 адамға дейінгі кәсіпорындар үшін-осы Қағидалар күшіне енген күннен бастап бір жыл ішінде;\n' +
		'-\tсаны 2000 адамнан асатын кәсіпорындар үшін-осы Қағидалар күшіне енген күннен бастап екі жыл ішінде енгізуге болады.\n',
	question19:
		'Еңбек шарттары туралы мәліметтерді енгізбегені үшін қандай да бір айыппұлдар, қылмыстық немесе әкімшілік жауапкершілік қарастырылған ба?',
	answer19:
		'Алайда, ҚР ЕК-нің 193-бабының 11-тармағына (01.01.2016 жылға дейін қолданыста болған ҚР ЕК-нің 330-бабы) сәйкес мемлекеттік еңбек инспекторлары еңбек заңнамасының сақталуын мемлекеттік қадағалау мен бақылауды жүзеге асыру кезінде Қазақстан Республикасының еңбек заңнамасын бұзу, мемлекеттік еңбек инспекторларының актілерін жұмыс берушілердің орындамауы фактілері бойынша ақпаратты, талап қоюларды және өзге де материалдарды тиісті құқық қорғау органдарына және соттарға жіберуге құқылы.',
	question20: 'Қызметкерлердің дербес деректерін қорғау қалай қамтамасыз етіледі?',
	answer20:
		'Еңбек шарттары бойынша деректер еңбек шарттарын есепке алудың бірыңғай жүйесінің дерекқорында сақталады. ЕШЕБЖ мемлекеттік органдардың бірыңғай тасымалдау ортасында орналасқан, жүйе ҚР ҰҚК "Мемлекеттік техникалық қызмет" РМК "Ақпараттық қауіпсіздік" талаптарына сәйкестігі тексерілді,\n' +
		'ақпараттық қауіпсіздік туралы сертификат алынды. Барлық интеграциялар "Электрондық үкіметтің"сыртқы шлюзі арқылы ғана жүргізіледі. Жүйе деректеріне қол жеткізу тек мынадай заңдар шеңберінде жүзеге асырылады:\n' +
		'"Ақпаратқа қол жеткізу туралы" Қазақстан Республикасының Заңы 2015 жылғы 16 қарашадағы № 401-V ҚРЗ. Дербес деректер және оларды қорғау туралы Қазақстан Республикасының 2013 жылғы 21\n' +
		'мамырдағы N 94-V Заңы" ақпараттық-коммуникациялық технологиялар және ақпараттық қауіпсіздікті қамтамасыз ету саласындағы бірыңғай талаптарды бекіту туралы "Қазақстан Республикасы Үкіметінің 2016 жылғы 20 желтоқсандағы № 832 Қаулысы.\n',
	answer20_1:
		'"Ақпараттық-коммуникациялық технологиялар және ақпараттық қауіпсіздікті қамтамасыз ету саласындағы бірыңғай талаптарды бекіту туралы" Қазақстан Республикасы Үкіметінің 2016 жылғы 20 желтоқсандағы № 832 Қаулысы.',
	question21:
		'Егер ақпарат электронды түрде сақталатын болса, жұмыс берушілер электронды нұсқада ЭЕШ-ны мемлекеттік мұрағатқа тапсыра ала ма? Бұл нормалар заңдарда жазылған ба?',
	answer21: 'Қазіргі уақытта бұл норма ҚР Еңбек кодексінің және Қағидалардың ағымдағы редакциясында қарастырылмаған.',
	question22: 'Кәсіби дағдылар мен жеке қасиеттер міндетті түрде толтырылуы керек пе?',
	answer22:
		'Жұмыскермен еңбек шартын жасасу және тоқтату,  Кодекстің 28-бабы 1-тармағының 1), 2), 3), 4), 5) және 13) тармақшаларында көзделген мәліметтер қамтылған, оған енгізілетін өзгерістер және (немесе) толықтырулар туралы ақпаратты еңбек шарттарын есепке алудың бірыңғай жүйесіне енгізеді;\n' +
		'Демек, "кәсіби дағдылар" және "жеке қасиеттер" сияқты қосымша ақпаратты енгізу міндетті емес.\n',
	question23: 'Қашықтан жұмыс істеуге шығу туралы қосымша келісімдерді тіркеу қажет пе?',
	answer23:
		'Жұмыс режимі қашықтықтан жұмыс істеуге өзгерген жағдайда «Қашықтықтан жұмыс» өрісін өзгерту арқылы ҚК енгізу қажет. Бұл жағдайда мекен-жай, жұмыс орны толтыру үшін міндетті емес болады.',
	question24: 'Азаматтықты ауыстырған кезде ЖСН деректерін қалай өзгертуге болады?',
	answer24:
		'Шарт карточкасындағы «Азаматтықты ауыстырған кезде ЖСН өзектендіру» батырмасын басу және қажетті жолдарды толтыру қажет. Бұдан кейін ЭЦҚ көмегімен қол қою және ЕШЕБЖ-ға тіркеуге жіберу қажет.',
	question25:
		'Жұмыс орны ретінде қаланы көрсете аламыз ба, себебі жұмысшының жұмыс орны тұрақты емес, ол жүріп-тұратын  сипатқа ие?',
	answer25:
		'Жұмыс жүріп-тұру сипатқа ие кезіде, жұмыс орындалатын жерде елді, өңірді немесе қаланы, елді мекенді және жұмыс берушінің толық мекенжайын (көше, үй нөмірі, кеңсе) көрсету қажет.',
	question26:
		'Егер қызметкер қайтыс болса және еңбек шарты ЕШЕБЖ енгізілмесе не істеу керек? Жүйе оны қазір енгізуге мүмкіндік бермейді.',
	answer26: 'Адам қайтыс болған жағдайда, ол туралы ақпаратты ЕШЕБЖ -ге енгізудің қажеті жоқ.',
	question27: 'Машықтанушылар туралы сұрақ. Ақылы практика кезінде уақытша ЕШ тіркеу керек пе?',
	answer27:
		'Еңбек кодексінің 30-бабында еңбек шартын жасасу мерзімі регламенттелген. Егер жұмыс беруші машықтанушымен еңбек шартын жасаса, онда ол еңбек шарты туралы ақпаратты сотқа енгізеді.',
	question28: 'Жұмыс істейтін зейнеткерлер туралы мәліметтерді енгізу керек пе?',
	answer28:
		'Жұмыс беруші барлық еңбек шарттары бойынша, оның ішінде зейнеткерлер бойынша еңбек шарттары туралы мәліметтерді ЕШЕБЖ-ға енгізеді.',
	question29: 'Жүктілік және босану және бала күтімі бойынша әлеуметтік демалыстарды енгізу міндетті ме?',
	answer29: 'Қағидаларға сәйкес жұмыс беруші ЕШЕБЖ-ға мынадай қосымша мәліметтерді жібереді:',
	answer29_1:
		'1) Жұмыс уақыты мен демалыс режимі;\n' +
		'2) қызметкердің жүктілікке және бала (балаларды) тууға, жаңа туған баланы (балаларды) асырап алуға байланысты демалысқа және бала үш жасқа толғанға дейін оның күтіміне байланысты жалақы сақталмайтын демалысқа шығуы туралы ақпарат қамтылуға тиіс.\n',
	question30:
		'ЕШЕБЖ-де еңбек шартында қате табылған жағдайда немесе қате тіркелген ЕШ болған жағдайында жұмыскерге қайда жүгіну қажет?',
	answer30:
		'Мәліметтерді енгізу үшін жауапкершілік жұмыс берушіге жүктеледі, егер еңбек шарты қате тіркелсе немесе болмаса, жұмыс берушіге хабарласу қажет. Қате тіркелген еңбек шарты болған жағдайда, яғни егер қызметкер аталған кәсіпорында жұмыс істеп жүрмесе және ешқашан жұмыс істемесе, еңбек жөніндегі уәкілетті органға жүгіну қажет.',
	main_effects: 'Қызметкерлер үшін негізгі әсерлер:',
	remote_and_easy: '•\t ҚР еңбек заңнамасына сәйкес электронды еңбек шартына қашықтан және оңай қол қою;',
	reducing_the_time: '•\t Құжаттарды жинаудан бас тарту және ұйымдарға бару арқылы жұмысқа орналасу уақытын қысқарту;',
	receive_proactive:
		'•\t Жұмыссыздар базасында тіркелу және жүктілігі мен босануы бойынша төлем алу бойынша проактивті қызметтерді алу;',
	receipt_of_commercial:
		'•\t Қызметкердің жұмыспен қамтылуын растау қажеттілігінсіз коммерциялық қызметтерді алу (жұмыс орнын растау бөлігінде);',
	monitoring_compliance:
		'•\t Жұмыс берушінің еңбек заңнамасын сақтауын бақылау және әлеуметтік және еңбек тәуекелдерінен қорғау.',
	order_minister:
		'Қазақстан Республикасы Еңбек және халықты әлеуметтік қорғау министрінің 2020 жылғы 3 қыркүйектегі № 353 бұйрығы. Еңбек шарттарын есепке алудың бірыңғай жүйесінде еңбек шарты туралы мәліметтерді ұсыну және алу қағидаларын бекіту туралы Қазақстан Республикасының Әділет министрлігінде 2020 жылғы 4 қыркүйекте № 21173 болып тіркелді',
	order_minister_2:
		'Қазақстан Республикасы Еңбек және халықты әлеуметтік қорғау министрінің 2023 жылғы 26 желтоқсандағы № 526 бұйрығы. Қазақстан Республикасының Әділет министрлігінде 2023 жылғы 27 желтоқсанда № 33811 болып тіркелді',
	description_help: 'Сипаттамасы',
	rules_submitting:
		'Еңбек шарттарын есепке алудың бірыңғай жүйесінде еңбек шарты туралы мәліметтерді ұсыну және алу қағидалары',
	rules_harmful:
		'Жұмыс берушінің қаражаты есебінен кәсіптік төлемді жүзеге асыру, тоқтата тұру, қайта бастау және тоқтату қағидалары',
	instruction_employers:
		'Еңбек ресурстары порталында hr.enbek.kz еңбек шарттарын тіркеу бойынша жұмыс берушілерге арналған нұсқаулық',
	methodology: 'Қызметкерді жазатайым оқиғалардан міндетті сақтандыру шарты бойынша төлемдер бойынша әдістемелік құрал',
	instr: {
		ref_1: 'Порталына тіркелу және кіру бойынша нұсқаулық',
		ref_2: 'Қызметкер ретінде порталда жұмыс істеуге арналған нұсқаулық',
		ref_3: 'Жұмыс беруші ретінде порталда жұмыс істеуге арналған нұсқаулық',
		ref_4: 'Кәсіпорынды қосуға арналған нұсқаулық',
		ref_5: 'Еңбек шарттарын қосуға арналған нұсқаулық',
		ref_6: 'Еңбек шартына қосымша келісімді қосуға арналған нұсқаулық',
		ref_7: 'Әлеуметтік демалысты қосуға араналған нұсқаулық',
		ref_8: 'ЖСН актуализациялауға арналған нұсқаулық',
		ref_9: 'Еңбек шартын автоматты түрде ұзартуға арналған нұсқаулық',
		ref_10: 'Филиалдар арасында қызметкерлерді ауыстыруға арналған нұсқаулық',
		ref_11: 'Қайта ұйымдастыруға байланысты БСН ауыстыруға арналған нұсқаулық',
		ref_12: 'Қызметкерге жұмыс орнынан анықтама алу бойынша нұсқаулық',
		ref_13: 'Жеке тұлға үшін еңбек шартын түзету жөніндегі нұсқаулық',
		ref_14: 'Электрондық еңбек шартын жасасу жөніндегі нұсқаулық',
		ref_15: 'Зиянды еңбек жағдайлары бойынша мәліметтерді енгізу жөніндегі Нұсқаулық',
		ref_16: 'Қосымша келісімді тіркеу және зиянды еңбек жағдайлары бойынша еңбек шартын бұзу жөніндегі Нұсқаулық',
		ref_17: 'Электрондық еңбек шартын бұзу жөніндегі нұсқаулық',
		ref_18: 'Жазатайым оқиғаны тіркеу жөніндегі нұсқаулық',
		ref_19: 'Штат кестесін енгізу және өзгерту жөніндегі нұсқаулық',
		ref_20: 'Қызметкердің жеке ісін қалыптастыру жөніндегі нұсқаулық',
		ref_21:
			'Азаматтық-құқықтық сипаттағы шарт және шарттың қосымша келісімі бойынша мәліметтерді енгізу жөніндегі нұсқаулық',
	},
	video_instruction: 'Видеонұсқаулық:',
	asked_questions: 'ЖИІ ҚОЙЫЛАТЫН СҰРАҚТАР',
	instructions: 'НҰСҚАУЛЫҚТАР',
	servicesTabs: 'СЕРВИСТЕР',
	for_employers: 'Работодателям',
	confirm_your_employment:
		'Еңбек шарттарын есепке алудың бірыңғай жүйесімен интеграциясы болған жағдайда, екінші деңгейдегі банктерден және нарықтың басқа да қызметтерінен кредит алған кезде өзнің жұмыспен қамтылғанын растаудың қажеті жоқ',
	get_automated_services: 'Жеке нарықтан автоматтандырылған қызметтерді алыңыз',
	use_opportunity:
		'Жүктілігі және босануы бойынша әлеуметтік демалыстарды тіркеу туралы жұмыс берушінің деректері негізінде проактивті (онлайн) режимде жүктілік және босану бойынша төлемдерді тағайындау мүмкіндігін пайдаланыңыз',
	receive_state_support: 'Жүктілік және босану бойынша төлемдерді алу үшін мемлекеттік қолдау алыңыз',
	termination_employment:
		'Еңбек шарты тоқтатылған және жүйеде еңбек қатынастарын  жаңадан тіркеу болмаған жағдайда, қосымша құжаттарсыз жұмыспен қамтуды қолдау бағдарламаларына қатысуға өтінім беріңіз',
	government_unemployment_support: 'Жұмыссыздық бойынша мемлекеттік қолдау алыңыз',
	control_hr_documents: 'Интернеттегі кадрлық құжаттарды бақылаңыз',
	manage_personal_documents:
		'Жеке құжаттарды жеке кабинеттен  басқарыңыз. Жұмысқа тезірек кірісіңіз, жұмыс берушіге жүгіну қажеттілігінсіз жұмыс орнынан анықтама алыңыз.',
	based_entered_data_employment:
		'Еңбек шарттары бойынша енгізілген мәліметтер негізінде қызметкердің электрондық еңбек кітапшасы жасалады, бұл қағаз нұсқасын жүргізу қажеттілігін жояды',
	your_mail: 'Сіздің e-mail',
	invalid_mail_entered: 'е-mail қате енгізілді',
	invalid_phone_number_entered: 'Телефон нөмірі қате енгізілді',
	register_employment_contracts_online: 'Еңбек шарттарын онлайн режимінде тіркеңіз',
	learn_about_integration_unified_accounting_system_employment_contracts:
		'Еңбек шарттарын есепке алудың бірыңғай жүйесімен интеграциялау туралы біліңіз',
	find_job_title: 'Жұмыс табыңыз',
	find_employee: 'Қызметкерді табыңыз',
	pass_self_assessment_compliance_labor_law_requirements:
		'Еңбек заңнамасы талаптарының сақталуына өзін-өзі тексеруден өтіңіз',
	frequently_asked_questions: 'Жиі қойылатын сұрақтар',
	form_store_personal: 'Команданың жеке істерін бір базада қалыптастырыңыз және сақтаңыз',
	manage_entire_package: 'Қызметкерлердің барлық құжаттар пакетін жеке кабинеттен басқарыңыз',
	use_template_contracts: 'Үлгі шарттарын қолданыңыз',
	types_employment_contracts_agreements:
		'Жеке кабинетте командамен жұмыс істеу үшін еңбек шарттары мен келісімдерінің барлық түрлері қолжетімді',
	access_single_employee_profile: 'Қызметкерлердің бірыңғай профиліне қол жеткізіңіз',
	informed_experience_employment_employee: 'Қызметкердің тәжірибесі мен параллельді жұмысы туралы хабардар болыңыз',
	work_verified_documents: 'Тексерілген құжаттармен жұмыс жасаңыз',
	save_time_processing: 'Анықтамалар мен шектеулерді өңдеуге уақытты үнемдеңіз',
	save_time_collecting_documents: 'Құжаттарды жинауға уақытты үнемдеңіз',
	started_faster: 'Приступайте к работе быстрее, управляя документами из личного кабинета',
	government_support: 'Получайте государственную поддержку',
	termination_employment_contract_contract:
		'В случае расторжения трудового договора и отсутствия новой регистрации, подайте заявку по разным программам без дополнительных документов',
	control_hr: 'Интернеттегі кадрлық құжаттарды бақылаңыз',
	managing_documents_security:
		'Порталдағы құжаттарды басқара отырып, сіз Әлеуметтік және кәсіби қорғалу деңгейін арттырасыз',
	terms_use: 'Пайдаланушылық келісімі',
	about_project: 'Жоба туралы',
	main_information: 'нормативтік-анықтамалық-ақпарат',
	regular_questions: 'Жиі қойылатын сұрақтар',
	for_employer_to: 'Жұмыс берушілерге',
	for_worker: 'Қызметкерге',
	for_worker_to: 'Қызметкерлерге',
	staffing: 'Штаттық кесте',
	staffing_create: 'Жаңа штаттық кестені құру',
	staffing_create_from_table: 'Штаттық кестеден құру',
	position_create: 'Лауазым құру',
	send_appointment: 'Тағайындауларды ЕШЕБЖ-ға жіберу',
	import_file: 'Файлдан импорттау',
	search_input: 'Штаттық лауазымның атауын енгізіңіз',
	position_filled: 'Ауыстырылатын лауазым',
	positions_combination: 'Лауазымды қоса атқару',
	without_td: 'Еңбек шарты жоқ',
	delegatingBin: 'Иә (Тағайындаған: {{bin}})',
	count_staff_units_1: 'Штаттық бірліктер саны ',
	count_staff_units_2: ' олардың ішінен бос ',
	count_staff_units_3: 'Штаттық кесте жобасына қосылған бірліктер саны ',
	add_position: 'Лауазымға тағайындау',
	staffing_table: {
		project: 'Жоба',
		history: 'Тарих',
		admin: 'Әкімшілік',
		code: 'Код',
		union_name: 'Құрылымдық бөлімше',
		name: 'Құрылым түрі',
		code_wp: 'Коды',
		workplace_code_label: 'Жұмыс орнының коды',
		count_staff_units: 'Штат бірліктері',
		salary: 'Жалақы',
		supplement_surcharge: 'Үстеме/Қосымша ақы',
		sum: 'Нақты жалақы',
		action: 'Әрекет',
		iin: 'ЖСН',
		fio: 'А.Т.Ж.',
		birthDay: 'Туылған күні',
		position_name: 'Лауазым',
		rate: 'Мөлшерлеме (барлығы/бос)',
		contract_number: 'Шарт №',
		begin_date: 'Басталу күні',
		end_date: 'Аяқталу күні',
		cause: 'Ескерту',
		status: 'Жіберу мөртебесі',
		status_assignment: 'Тағайындалу мөртебесі',
		number_bets: 'Ставкалар саны',
		info_no_positions: 'Бұл құрылымдық бөлімшеде лауазымдар құрылмаған',
		substitute_fio: 'Орын басушының А.Т.Ж.',
		info_no_staff: 'Штаттық кестенің жобасы құрылған жоқ',
		reason_temporary: 'Жұмыс орнында уақытша болмау себебі',
		group_code: 'Кәсіптер тобының коды',
		count_work_place: 'Жұмыс орындарының саны',
	},
	staff_modal: {
		title:
			'Сіз қызметкерді қызметтен жойып тұрсыз. Сіз қызметкер лауазымынан жойып тастағыңыз келетініне сенімдісіз бе?',
		note_placeholder: 'Қызметкердің қызметінен жоюдың негізін көрсетіңіз',
		yes: 'Иә',
		no: 'Жоқ',
		choose_from_handbook: 'Мәнді таңдаңыз',
		title_position: 'Лауазымға тағайындау',
		create_position: 'Лауазым құру',
		position_category: 'Лауазым санаты',
		edit_position: 'Жұмыс орнын өңдеу',
		info_position: 'Жұмыс орны туралы ақпарат',
		workplace_code: 'Жұмыс орынның коды',
		workplace_placeholder: 'Жұмыс орынның кодын еңгізіңіз',
		salary_placeholder: 'Жалақыны еңгізіңіз',
		supplement_surcharge_placeholder: 'Сыйақыны енгізіңіз',
		cause_placeholder: 'Ескертуді енгізіңіз',
		freelancer: 'Штаттан тыс қызметкер',
		freelancer_position: 'Штаттан тыс лауазым',
		position_kz: 'Қазақ тіліндегі лауазымы',
		position_ru: 'Орыс тіліндегі лауазымы',
		position_placeholder: 'Штаттық лауазымды енгізіңіз',
		title_staffing_first: 'Штаттық кесте',
		order_number: 'Бұйрық нөмірі',
		order_date: 'Бұйрық күні',
		code: 'Құрылым коды',
		code_hint:
			'Штаттық кесте құрылымының ерікті, бірегей (қайталанбайтын) коды жұмыс орындарын ауыстыру және сәйкестендіру үшін қажет',
		code_placeholder: 'Құрылым кодын енгізіңіз',
		order_number_placeholder: 'Бұйрық нөмірін еңгізу',
		comment: 'Түсініктеме',
		comment_placeholder: 'Түсініктеме еңгізіңіз',
		staff_information: 'Құрылым туралы ақпарат',
		subsidiary: 'Еншілес ұйымды (филиалды)қосыңыз',
		bin: 'Еншілес ұйымның БСН/ЖСН',
		bin_placeholder: 'БСН/ЖСН енгізіңіз',
		structure_name: 'Құрылмының орыс тіліндегі атауы',
		structure_name_kz: 'Құрылмның қазақ тіліндегі атауы',
		structure_name_placeholder: 'Құрылымның орыс тіліндегі атауын еңгізіңіз',
		structure_name_placeholder_kz: 'Құрылымның қазақ тіліндегі атауын еңгізіңіз',
		structure_type: 'Құрылым түрі',
		structure_type_placeholder: 'Құрылым түрін таңдаңыз',
		structure_add: 'Құрылымды қосу',
		number_bets_placeholder: 'Ставкалар санын енгізіңіз',
		reason_temporary_placeholder: 'Жұмыс орнында уақытша болмау себебін енгізіңіз',
		info_workPlace: 'Кәсіптер тобы бойынша ақпарат',
		hint_positions: 'ҚР Оқу-ағарту министрлігінің №123, №145, №224, №338 бұйрықтарына енгізілмеген лауазымдар.',
		struct_school: 'Азаматтық қызметшілер ұйымдарына арналған құрылым',
		info: {
			title: '<i><strong>Категории организаций, подлежащих подключению:</strong></i>',
			school:
				'<i><strong>білім беру саласы:</strong> қорғаншылық және қамқоршылық органдары, меншіктің барлық нысанындағы мектептер, ата-анасының қамқорлығынсыз қалған балаларға және жетім балаларға арналған білім беру ұйымдары (Балаларды қолдау орталығы – ЦПД, Кәмелетке толмағандарды бейімдеу орталығы – ЦАН, отбасылық үлгідегі балалар ауылдары), арнайы білім беру ұйымдары, мектеп-интернаттар;</i>',
			health:
				'<i><strong>денсаулық сақтау саласы:</strong> амбулаториялық-емханалық көмек, стационарлық көмек, қалпына келтіру емі және медициналық оңалту көрсететін ұйымдар, сондай-ақ өзге де медициналық ұйымдар;</i>',
			sport:
				'<i><strong>туризм және спорт саласы:</strong> балалар мен жасөспірімдер спорт мектептері, мүгедектігі бар адамдарға арналған спорт мектептері, өзге де ұйымдар;</i>',
			culture:
				'<i><strong>мәдениет саласы:</strong> музейлер, кітапханалар, театрлар, филармониялар, мәдениет үйлері, көрме залдары, кинотеатрлар, концерттік ұйымдар және мәдениет саласындағы өзге де ұйымдар.</i>',
		},
		sphere_type: 'Ұжымның саласы',
		sphere_type_placeholder: 'Ұжымның саласын таңдаңыз',
	},
	workplace: {
		title: 'Жұмыс орын туралы ақпарат',
		create_date: 'Жұмыс орнын құру күні',
		tariff_rate: 'Бірліктер саны',
		tariff_rate_required: 'Тарифтік мөлшерлеме *',
		count_tariff_rate: 'Бірліктер саны *',
		manual_input: 'Қолмен енгізу *',
		directory: 'Анықтама *',
		accept_position: 'Лауазымға тағайындалған',
		edit_position: 'Өңдеу:',
		information_prescribing: 'Тағайындау туралы ақпарат',
		staff_unit: 'Штат бірлігі',
	},
	copy: 'Еңбек ресурстарын дамыту орталығы',
	our_socials: 'Біз әлеуметтік желілерде',
	our_phone: 'Біздің телефон',
	more_details: 'Толығырақ',
	useful_information: 'Пайдалы ақпарат',
	documents_bank: 'Типтік құжаттар банкі',
	government_demand: 'Еңбек заңнамасының талаптары',
	single_system: 'Еңбек шарттарын есепке алудың бірыңғай жүйесі туралы',
	service_integration_data_transmission:
		'ЕШЕБЖ-да еңбек шарттарын тіркеу үшін пайдаланылатын анықтамалықтарды беру сервисімен интеграциялау туралы',
	service_integration_sync: 'Еңбек шарттарын синхрондау сервисімен интеграция туралы',
	service_integration_packages: 'Еңбек шарттарын пакеттік жүктеу сервисімен интеграциялау туралы',
	service_integration_registry: 'Еңбек шарттарын тіркеу сервисімен интеграция туралы',
	have_question: 'Сұрақ бар',
	ask_your_question: 'Оны төмендегі нысан арқылы қойыңыз',
	your_name: 'Есіміңіз кім?',
	select_region: 'Анықтамалықтан аймақты таңдаңыз',
	question_topic: 'Сіздің сұрағыңыздың тақырыбы',
	question: 'Сіздің сұрағыңыз',
	fill_in_full_data: 'Барлық деректерді толтырыңыз',
	attache_file: 'Файлды тіркеу',
	send: 'Жіберу',
	remove: 'Жою',
	remove_contract: 'Қате келісімшартты жою',
	donwload_reference: 'Анықтаманы жүктеу',
	call_to_us: 'Немесе өзіңіз қоңырау шалыңыз',
	call_within_kz: 'Қазақстан бойынша қоңыраулар үшін',
	refer_to_regional_inspection: 'Аймақтық еңбек инспекциясына хабарласыңыз',
	chose_area: 'Аймақты таңдаңыз',
	choose_city: 'Қаланы немесе ауданды таңдаңыз',
	find: 'Табу',
	inspector: 'Инспектор',
	director: 'Директор',
	difficulties: 'Қиындықтар туындады ма?',
	contact_technical_support:
		'Техникалық қолдау қызметіне хабарласыңыз,\n' + 'солай біз сіздің мәселеңізді шеше аламыз.',
	send_message: 'Хабарлама жіберу',
	digital_ecosystem: 'Сандық мүмкіндіктер экожүйесі',
	conversations_kz: 'Қазақстан бойынша қоңыраулар үшін',
	main: 'БАСТЫСЫ',
	portal: 'ПОРТАЛ',
	services: 'Сервистер',
	questions: 'Сұрақтар',
	helpTab: 'НҚА',
	crtr: ' «Еңбек ресурстарын дамыту орталығы» АҚ',
	rus: 'Русский',
	language: 'KZ',
	error_change_lng: 'Ошибка при изменении языка',
	feedback: 'Кері байланыс',
	ask_feedback: 'Сұрақты төмендегі пішін арқылы орнатыңыз:',
	company_name: 'Нұр-сұлтан қаласы әкімдігінің халықты жұмыспен қамту орталығы коммуналдық мемлекеттік мекемесі',
	rate_worker_detect:
		'Оценка уровня социальной защищенности работника в Казахстане остается на слабом уровне. Трудовые договоры часто не заключаются, обязательства по ним не исполняются, трудовые книжки теряются, и работнику приходится обойти все места работы и поднимать архивы.',
	you_are_under_detect: 'Еңбек ресурстары порталында сіз толықтай қорғалғансыз',
	registration: 'Тіркеу',
	registration_as: 'Ретінде тіркелу',
	registration_as_worker: 'қызметкер',
	registration_as_employer: 'жұмыс беруші',
	reduction_time: 'Құжаттарды жинаудан және ұйымдарға барудан бас тарту арқылы жұмысқа орналасу мерзімдерін қысқарту',
	proactive_base:
		'Еңбек шарты бұзылған және жаңа еңбек шарты тіркелмеген жағдайда жұмыссыздар базасында проактивті тіркеу',
	get_proactive_service: 'Проактивті қызметтерді алу мүмкіндігі',
	social_defend: 'Әлеуметтік тәуекелдерден қорғау',
	search_qualified_workers:
		'Еңбек шарттары бойынша мәліметтерді енгізіңіз және деректерді уақтылы өзектендіру қажеттілігі туралы порталдың хабарламаларын алу арқылы заңнаманы сақтаңыз',
	source_portal: 'Еңбек ресурстары порталы кадрлық іс жүргізу процестерін жеңілдетеді',
	reduction_cost_employment_contracts: 'Еңбек шарттарын ресімдеу құнын төмендету',
	simplification_touch_contracts: 'Жеке іс жүргізуді жеңілдету',
	risk_reduction:
		'Деректерді бұрмалау тәуекелдерін қысқарту (еңбек өтілі, еңбекке жарамсыздық, соттылық, шектеулер мен тыйым салулар)',
	get_full_access:
		'Қызметкерлердің бірыңғай бейіндері және еңбек тарихы туралы мәлімет беру (қызметкердің қатарлас жұмыспен қамтылуы туралы хабардар болу)',
	electronic_employment_contracts: 'Электрондық еңбек шарттары',
	electronic_employment_contract_1: 'Электрондық еңбек шарты',
	employment_contracts: 'Еңбек шарттары',
	collective_contract: 'Ұжымдық шарт',
	employment_contract_1: 'Еңбек шарты',
	worker_transfer_requests: 'Жұмысшыларды ауыстыру туралы сұраулар',
	molding_personal_business: 'Жеке істі қалыптастыру',
	registration_employment_contracts: 'Еңбек шарттарын тіркеу',
	online_consultant: 'Еңбек кеңесшісі',
	find_job: 'Жұмыс  табу',
	find_worker: 'Қызметкерді табу',
	employment_navigator: 'Еңбек навигаторы',
	portal_employment_source: 'Еңбек ресурстары порталы',
	reference_information: 'Анықтамалық ақпарат',
	entrance: 'Кіру',
	i_employer: 'Мен - жұмыс берушімін',
	i_employee: 'Мен- қызметкермін',
	registry: 'Тіркеу',
	actual_resumes_vacancies: 'Жұмыспен қамту саласындағы өзекті түйіндеме, бос орындар және онлайн қызметтер',
	learning_skills: 'Жаңа дағдыларға үйрету және мансапты дамыту мүмкіндігі',
	support_business: 'Бизнесті бастау немесе кеңейту үшін қолдау',
	career_road: 'Өз мансап жолын құру',
	migration_description: 'Қазақстандағы көші-қон легін басқару',
	mansap_description: 'Мамандық таңдау және мансап траекториясын басқару',
	digital_ecosystem_employment: 'Жұмыспен қамтудың цифрлық экожүйесі',
	electronic_labor_exchange: 'Электрондық еңбек биржасы',
	app_download_link: 'Мобильді қолданбаны жүктеп алу үшін телефон камерасын осы QR-ге бағыттаңыз',
	intro_sub_title: 'Жұмысқа орналасу процесін онлайн ұйымдастырыңыз',
	count_employment_contracts: 'шарттары',
	count_employers: 'жұмыс берушілер',
	count_workers: 'қызметкерлер',
	contracts: 'шарттар',
	contract_1: 'шарт',
	intro_second_slider: 'Бірыңғай еңбек қоймасы',
	intro_second_sub_title_first_part: 'Шарттарды тіркеңіз және команданың ресурстарын басқарыңыз',
	intro_third_title: 'Құжаттарды жинауға уақытты үнемдеңіз-онлайн шарттар жасаңыз',
	intro_third_title_second: '',
	to_registration: 'Тіркелу',
	rule: 'rule-kz.pdf',
	max_file_size: 'Max file size is 15MB',
	phone: 'Телефон',
	email: 'Email',
	bin: 'БСН',
	yin: 'ЖСН',
	me: 'Мен',
	who_worker: 'қызметкер',
	who_employer: 'жұмыс беруші',
	entered_wrong: 'Қате енгізілді',
	enter_in: 'Енгізіңіз',
	digital: 'сан',
	make_up_password: 'Құпия сөз ойлап табыңыз',
	enter_password: 'Құпия сөзді енгізіңіз',
	password_error: ' Құпия сөз кемінде 8 таңбадан тұруы керек және кіші, бас әріптер мен сандардан тұруы керек.',
	repeat_password: ' Құпия сөзді қайталаңыз',
	agree_for: 'Келісемін',
	with_user_agreement: 'Пайдаланушы келісімімен',
	and_you_can_keep_my_data: 'және өзімнің жеке деректерімді жинауға және өңдеуге келісім беремін',
	sign_ecp_and_continue: 'ЭЦҚ-мен қол қою және жалғастыру',
	show: 'Көрсету',
	hide: 'Жасыру',
	forgot_password: 'Құпия сөзді ұмыттыңыз ба',
	enter_in_cabinet: 'Кабинетке кіру',
	your_password_from_ecp: 'ЭЦҚ құпия сөзін  енгізіңіз',
	required_field: 'Міндетті жол',
	cancel: 'Бас тарту / болдырмау',
	close: 'Жабу',
	next: 'Келесі',
	company_id: 'Кәсіпорынның ID-і',
	close_message: 'Хатты жабу',
	password_restoration: 'Құпия сөзді қалпына келтіру',
	make_up_new_password: 'Жаңа пароль ойлап табыңыз',
	by: 'бойынша',
	ecp_data: 'ЭЦҚ',
	sms_data: 'СМС',
	qr_data: 'QR',
	etd: 'ЭЕШ',
	code_from: 'Код',
	continue: 'Жалғастыру',
	send_verification_code: 'Растау кодын жіберу',
	have_not_account: 'әзірге аккаунт  жоқ',
	similar_password_error: 'Құпия сөз Сіз ұсынған құпия сөзге сәйкес келуі керек',
	save_and_enter_in: 'Сақтау және кіру',
	send_code_again: 'Кодты қайта жіберу',
	in_time: 'арқылы',
	second_in_short: 'бірге',
	your_email_label: 'Тіркеу кезінде көрсетілген E-mail ',
	incorrect_password: 'Қате пароль енгізілді',
	incorrect_verification_code: 'Дұрыс емес код енгізілді',
	incorrect_email: 'қате E-mail енгізілді',
	required_email_field: ' E-mail та жолы бос болмауы тиіс',
	required_password_field: 'Құпия сөзді енгізу жолы бос болмауы тиіс',
	enter_verification_code: '4 саннан тұратын кодты енгізіңіз',
	transfer_request_btn: 'Басқа филиалдан аударуды сұрау',
	transfer_request_title: 'Қызметкерді (- лерді) басқа филиалдан ауыстыруға сұрау салу',
	transfer_request_date: 'Сұрау салу күні',
	transfer_request_bin: 'Қызметкер ауыстырылатын филиалдың БСН',
	transfer_branch_name: 'Филиалдың атауы',
	transfer_employeers_data: 'Қызметкер(лер)дің деректері',
	transfer_request_sended: 'Сұрау жіберілд',
	transfer_wait_for_confirmation: 'Растауды күтіңіз',
	transfer_watch_status: 'Сіз сұрау мәртебесін "қызметкерлерді аудару туралы сұраулар" бөлімінен бақылай аласыз',
	transfer_go_to_list: 'Сұраулар тізіміне өту',
	transfer_request_form_date: 'Сұрау салуды қалыптастыру күні',
	transfer_bin_to: 'Қызметкерлер ауысып баратын жұмыс берушінің БСН',
	transfer_bin_from: 'Қызметкерлер ауысатын жұмыс берушінің БСН',
	transfer_name_to: 'Қызметкерлер ауысып келетін жұмыс берушінің атауы',
	transfer_name_from: 'Қызметкерлер ауысатын жұмыс берушінің атауы',
	transfer_status_request: 'Сұрау мәртебесі',
	transfer_status: 'Аударма мәртебесі',
	branch_info: 'Қызметкерлер туралы деректер',
	employer_from: 'Қызметкерлер ауысатын жұмыс беруші',
	employer_to: 'Қызметкерлер ауысып келетін жұмыс беруші',
	send_contract: 'ЕШ беру',
	reject_transfer: 'Аудармадан бас тарту',
	create_additional_agreement: 'Қосымша келісімшарт құру',
	transfer_list_empty_message: 'Сіз қызметкерлерді басқа филиалдан ауыстыру туралы бірде-бір сұрау салған жоқсыз.',
	transfer_request_outgoing: 'Шығыс',
	transfer_request_incoming: 'Кіріс',
	add_id: 'ЖСН қосу',
	send_request: 'Сұрау жіберу',
	choose: 'Таңдау',
	save: 'Сақтау',
	save_and_sign: 'ЭЦҚ сақтау және қол қою',
	refuse_for_selected: 'Таңдалғанды қабылдамау',
	reset_all: 'Барлығын тазалау',
	give_selected: 'Таңдалған ЕШ жіберу',
	sign_and_send: 'ЭЦҚ-мен қол қою және жіберу',
	sign_and_prolong: 'ЭЦҚ-ға қол қою және ұзарту',
	sign_and_save: 'ЭЦҚ-ға қол қою және сақтау',
	sign_ecp: 'ЭЦҚ-мен қол қою',
	sign_ecp_rsa: 'ЭЦҚ (RSA)таңдау',
	and: 'және',
	restore: 'қалпына келтіру',
	terminate: 'бұзу',
	send_to_sign_worker: 'Қол қоюға жіберу',
	sign_to_sign_employer: 'Қол қою және жұмыс берушіге жіберу',
	add: 'қосу',
	save_as_template: 'Үлгі  ретінде сақтау',
	open_contract_text: 'Шарттың мәтінін ашу',
	contract_text: 'Шарт мәтіні',
	attach_etd_pdf: 'ЭЕШ-ның PDF файлын тіркеу',
	draft_etd: 'Электрондық еңбек шартының жобасы (ЭЕШ)',
	contract_info: 'Шарт туралы ақпарат',
	termination_info: 'Тоқтату/бұзу туралы ақпарат',
	cancel_changes: 'Енгізілген өзгертулерден бас тарту',
	//Contracts
	contract: {
		see_full_text: 'ЭЕШ-ның толық мәтінін қарау',
		contract_info: 'Шарт туралы ақпарат',
		info: {
			job_address: 'Жұмысты орындау орны',
			remote_job: 'Қашықтықтан жұмыс',
			number: 'Шартты нөмірі',
			td_number: 'Шарттың нөмірі',
			type: 'Шарт түрі',
			registration_date: 'Жасалған күні',
			start_date: 'Басталу күні',
			expiration_date: 'Аяқталу күні',
			contract_term: 'Шарттың мерзімі',
			termination_date: 'Бұзу күні',
			note: 'Ескерту',
			note_body:
				'Келісімшарт зиянды еңбек жағдайлары бар жұмыстарда еңбек қызметін тоқтату туралы өтінішке сәйкес қызметкердің қалауы бойынша бұзылады',
			note_body_additional:
				'Жұмыскердің еңбек жағдайларын зиянды жағдайдан қалыпты жағдайға өзгерту туралы өтінішіне сәйкес келісімшарт қызметкердің қалауы бойынша өзгертілді',
			validity: 'Жарамдылық мерзімі',
			work_type: 'Жұмыс түрі',
			position: 'Лауазымы',
			nkz_position: 'ҰҚЖ бойынша лауазымы',
			working_condition: 'Еңбек жағдайлары',
			established_position: 'Штаттық лауазым',
			address: 'Адрес',
			country_code: 'Ел коды',
			KATO_code: 'ӘАОС коды',
			time_mode: 'Жұмыс уақыты режимі',
			tariff_rate: 'Тарифтік мөлшерлеме',
			work_country: 'Жұмыс  орнының  елі',
			work_region: 'Жұмыс орнының аймағы/облысы мен ауданы',
			work_locality: 'Елді мекен',
			work_address: 'Жұмыс орнының мекенжайы',
			conditions1: '1-тізім бойынша жұмыс түрі',
			conditions2: '2-тізім бойынша жұмыс түрі',
			conditions3: 'МКЗЖ тізімі бойынша жұмыс түрі',
			employeeRequest: 'Қызметкердің өтінішінің болуы',
			employeeConsent: 'Қызметкердің дербес деректерді өңдеуге келісімі',
		},
		tariff_rate_tooltip:
			'Тек толық емес жұмыс уақыты үшін. 0-ден 1-ге дейінгі мәнді енгізіңіз (мысалы, 0.5, 0.7 және т. б.)',
		error_get_contract: 'Произошла ошибка при открытии ТД. Попробуйте позже. ',
		placeholder_phone: 'Телефон нөмірін енгізіңіз +7',
	},
	update: 'Жаңарту',
	my_profile: 'Менің профилім',
	worker_data: 'Қызметкердің деректері',
	change_password: 'Құпия сөзді өзгерту',
	update_data: 'Деректерді жаңарту',
	last_update_date: 'Соңғы жаңарту күні',
	logo: 'Логотип',
	actualisation_data: 'ЖСН өзектендіру',
	during_change_citizenship: 'Азаматтықты өзгерту кезінде',
	document_approve_personality: 'Жеке басын куәландыратын құжат',
	document_type: 'Құжат түрі',
	document_number: 'Құжат нөмірі',
	issue_date: 'Берілген күні',
	issued_by: 'Кім берді',
	contact_data: 'Байланыс деректері',
	phone_number: 'Телефон нөмірі',
	your_phone_number: 'Сіздің телефон нөміріңіз',
	registration_address: 'Тіркеу мекенжайы',
	not_approved: 'Расталмаған',
	your_phone: 'Телефонды енгізіңіз',
	enter_address: 'Мекенжайды енгізіңіз',
	approve: 'Растау',
	save_changes: 'Өзгерістерді сақтау',
	move_file_or: 'Файлды мына аймаққа апарыңыз немесе',
	upload_file_from_your_pc: 'Оны компьютерден жүктеңіз',
	upload: 'Жүктеу',
	file_formats: 'Файл пішімі',
	to: 'дейін',
	kb: 'Кб',
	electronic_contract_title: 'Электрондық еңбек шарты',
	download_pdf_eec: 'ЭЕШ жүктеу',
	download_pdf_eds: 'ЭҚК жүктеу',
	download_pdf_ekd: 'ЭҰШ жүктеу',
	date_created: 'Жасалған күн',
	send_to_rework: 'Пысықтауға жіберу',
	revoke:
		'Сіз шынымен электрондық еңбек шартына қол қоюды қайтарып алғыңыз келе ме ? Бұл жағдайда электрондық еңбек шартын жасасу процесі тоқтатылады',
	revoke_eds:
		'Сіз шынымен электрондық қосымша келісімге қол қоюды қайтарып алғыңыз келе ме ? Бұл жағдайда электрондық қосымша келісім жасасу процесі тоқтатылады',
	decline: 'Бас тарту',
	reject: 'Бас тарту',
	el_cause: 'Электрондық еңбек шартының жобасын жұмыс берушіге пысықтау үшін жіберу себебін көрсетіңіз',
	el_cause_eds: 'Электрондық Қосымша келісім жобасын жұмыс берушіге пысықтау үшін жіберу себебін көрсетіңіз',
	el_cause_short: 'Себебін көрсетіңіз',
	sure_sign:
		'Сіз қызметкермен электронды қосымша келісім жасайсыз! Қол қойылғаннан кейін бұл шарттар Еңбек кодексінің 27-бабының 2-тармағына сәйкес еңбек шарттарын есепке алудың бірыңғай жүйесіне автоматты түрде жіберіледі және кез келген өзгерістерді шартқа қосымша келісім жасасу арқылы ғана жүргізуге болады.',
	sure_sign_employee: 'Мен шарттың талаптарымен келісемін және электрондық қосымша келісімге қол қоямын.',
	sure_decline:
		'Сіз келісімшартқа қол қоюдан бас тартасыз. Электрондық еңбек шартын жасасуды тоқтатқыңыз келетініне сенімдісіз бе?',
	sure_decline_eds:
		'Сіз қосымша келісімге қол қоюдан бас тартасыз. Сіз электронды қосымша келісім жасасуды тоқтатқыңыз келетініне сенімдісіз бе?',
	document_name: 'Құжат атауы',
	id_identification: 'Жеке куәлік',
	enter_document_number: 'Құжат нөмірін енгізіңіз',
	wrong_document_number: 'Құжат нөмірі қате',
	enter_issued_by: 'Құжатты берген органды көрсетіңіз',
	old_password: 'Құпия сөз ескірген',
	enter_old_password: 'Бұрынғы құпия сөзді енгізіңіз',
	come_up_new_password: 'Жаңа құпия сөз ойлап табыңыз',
	repeat_new_password: 'Жаңа құпия сөзді қайталаңыз',
	worker_iin: 'Қызметкердің ЖСН',
	entered_incorrect_bin_iin: 'Қате БСН / ЖСН енгізілді',
	personal_short_information: 'Қызметкердің аты-жөні',
	filled_automate: 'Автоматты түрде толтырылады',
	reorganisation: 'Қайта құру',
	registration_number: 'Тіркеу нөмірі',
	registration_date: 'Тіркеу күні',
	kind_activity: 'Қызмет түрі',
	type_ownership: 'Меншік нысаны',
	state_registration_of_person: 'Заңды тұлғаны мемлекеттік тіркеу',
	approved: 'Расталды / құпталды',
	only_for_not_full_work_day:
		'Тек толық емес жұмыс уақыты үшін. 0-ден 1-ге дейінгі мәнді енгізіңіз (мысалы, 0.5, 0.7 және т. б.)',
	change_bin_during_registration: 'Қайта құру кезіндегі БСН өзгеруі',
	new_bin: 'Жаңа БСН',
	name: 'Атауы',
	not_indicated: 'Көрсетілмеген',
	already_exist_email: 'Мұндай email  бар пайдаланушы бар',
	employer_doesnt_found: 'Заңды тұлға табылмады',
	worker_doesnt_found: 'ЖТМДҚ  ДҚ жеке тұлға табылмады ',
	bad_credentials: 'Қате БСН/ЖСН немесе құпия сөз',
	termination_employment_contract: '{{registerDate}} жылғы № {{contractNumber}} еңбек шартын тоқтату/бұзу',
	terminate_confirm: 'Түсінікті, бәрібір бұзу',
	terminate_delete_warning:
		'Еңбек шарты тоқтатылғаннан/бұзылғаннан кейін қосымша келісімдерді жою, редакциялау және құрудан қорғалған',
	terminate_cancelation_warning: 'Қате бұзудың күшін жою үшін ресми хатпен ҚР ЕХӘҚМ-не жүгіну қажет',
	terminate_edit_warning:
		'Еңбек шарты тоқтатылғаннан/бұзылғаннан кейін қосымша келісімдерді жою, редакциялау және құрудан қорғалған',
	confirm_edit_termination_data: 'Түсінікті, бұзу деректерін өзгерту',
	register_soc_vacation: 'Шартқа әлеуметтік демалысты тіркеу',
	soc_vacation: 'Шартқа әлеуметтік демалыс',
	soc_vacation_delete: 'Әлеуметтік демалыс сіздің кабинетіңізден жойылады',
	soc_vacation_edit: 'Шартқа әлеуметтік демалысты өзгерту',
	soc_vacation_type: 'Әлеуметтік демалыс түрі',
	vacation_date_start: ' бастап жұмыс істемеді',
	vacation_date_end: ' дейін  жұмыс істемеді',
	vacation_date_work_start: 'Бірінші жұмыс күні ',
	vacation_date_work_start_hint:
		'Қызметкердің әлеуметтік демалыстан мерзімінен бұрын шыққаннан кейінгі бірінші жұмыс күні',
	incapacity_days: 'Еңбекке жарамсыздық кезеңіндегі демалыс күндері',
	set_weekends_count: 'Демалыс күндерінің санын көрсетіңіз',
	timesheet_number: 'Табель нөмірі',
	set_timesheet_number: 'Табель нөмірін көрсетіңіз',
	subdivision_ru: 'Бөлімшенің атауы (орыс)',
	subdivision_kz: 'Бөлімшенің атауы (Қаз)',
	set_department_name: 'Бөлімшенің атауын көрсетіңіз',
	confirm_delete: 'Сіз жойғыңыз келетініне сенімдісіз бе?',
	no_restore: 'Қалпына келтіру мүмкіндігінсіз бе?',
	yes_sign_and_delete: 'Иә, ЭЦҚ-мен қол қою және жою',
	yes_sign: 'Иә, ЭЦҚ-мен қол қою',
	no_cancel: 'Жоқ, бас тарту',
	delete_yes: 'Иә, жою',
	vacation_info: 'Демалыс туралы ақпарат',
	set_new_template_name: 'Жаңа шаблонның атауын көрсетіңіз',
	choose_template: 'Үлгіні таңдаңыз',
	additional_contract_delete: 'Қосымша келісім сіздің кабинетіңізден жойылады',
	additional_contract_number: 'Қосымша келісім нөмірі',
	set_additional_contract_number: 'Қосымша келісім нөмірін көрсетіңіз',
	reg_date_additional_contract: 'Қосымша келісім жасалған күн',
	start_date_additional_contract: 'Қосымша келісімнің басталу күні',
	end_date_additional_contract: 'Қосымша келісімнің аяқталу күні',
	terminate_date: 'Шарттың тоқтатылған/бұзылған күні',
	terminate_date_contract: 'Бұзу күні',
	contract_status: 'Шарт мәртебесі',
	government_type_restore: 'Қалпына келтіру туралы шешім шығарған органның түрі',
	restore_order_number: 'Қалпына келтіру туралы бұйрықтың нөмірі',
	government_name_restore: 'Қайта қабылдау туралы шешім шығарған органның атауы',
	choose_from_directory: ' Каталогтан таңдаңыз',
	position_placeholder: 'Штаттық лауазымды көрсетіңіз немесе анықтамалықтан таңдаңыз',
	position_placeholder_second: 'Штаттық лауазымды көрсетіңіз',
	change_contract_term: 'Еңбек шартының мерзімін өзгерту',
	change_contract_other: 'Жалақы мөлшерінің және/немесе өзге де еңбек талаптарының өзгеруі',
	change_contract_position: 'Лауазымның және/немесе еңбек жағдайларының өзгеруі',
	change_working_hours: 'Жұмыс уақыты режимін өзгерту',
	change_work_type: 'Жұмыс түрін өзгерту',
	change_work_country: 'Жұмысты орындау орнын өзгерту',
	change_iin_bin: 'Филиал желісі ішінде ауысқан немесе қайта ұйымдастырылған жағдайда жұмыс берушінің БСН/ЖСН ауыстыру',
	change_term: 'Еңбек шартының мерзімін өзгерту',
	change_other: 'Басқа талаптар',
	enter_other_working_conditions: 'Қосымша келісімде өзгертілген басқа еңбек талаптарын енгізіңіз',
	edit_additional_contract: 'Шартқа қосымша келісімді редакциялау',
	contract_validity: 'Еңбек шартының қолданылу мерзімі',

	//Create Additional Contract
	create_additional_contract: 'Шартқа қосымша келісім жасау',
	additional_contract_info: 'Қосымша келісім туралы ақпарат',
	new_conditions: 'Шарттың жаңа талаптары',
	choose_conditions_to_change: 'Өзгертілетін Шарт талаптарын таңдаңыз',
	password: 'Құпия сөз ',
	code_has_been_sent_successfully: 'Код сіздің поштаңызға сәтті жіберілді',
	code_has_been_verified_successful: 'Пошта сәтті расталды',
	user_profile_updated_successfully: 'Пайдаланушы туралы ақпарат сәтті жаңартылды',
	max_size_photo_error: 'Суреттің максималды өлшемі-200 КБ',
	current_password_is_wrong: 'Ағымдағы құпия сөз дұрыс емес',
	password_has_been_changed: 'Құпия сөз сәтті өзгертілді',
	already_exist_bin: 'Мұндай БСН бар пайдаланушы бар',
	already_exist_in: 'Мұндай ЖСН бар пайдаланушы бар',
	reference_information_questions: {
		1: {
			question: 'ЭЦҚ-мен кіру мүмкін емес, қате шығады?',
			answer: 'NCALayer бағдарламасының орнатылуын және/немесе ЭЦҚ қолданылу мерзімін тексеру қажет',
		},
		2: {
			question: 'Менде ЭЦҚ жоқ, қалай кіре аламын?',
			answer:
				'Порталға кіру үшін электрондық цифрлық қолтаңба (ЭЦҚ) қажет. Қазіргі уақытта ЭЦҚ-ны электрондық үкімет сайтында қашықтан алуға болады. Сонымен қатар, Сіз Порталға БСН/ЖСН пайдалана отырып кіре аласыз.',
		},
		3: {
			question: 'Мен Порталға бірінші рет кіремін, не істеуім керек?',
			answer:
				'Егер Сізде аккаунт болмаса, Сіз тіркелуіңіз керек. Аккаунтты тіркеу ЭЦҚ арқылы КІРУ терезесіндегі Басты бетте өтеді. Одан әрі Порталға кірген сайын, егер Сіз жұмыс беруші болсаңыз, БСН немесе қызметкер болсаңыз, ЖСН арқылы авторландыруды жүргізу қажет.',
		},
		4: {
			question:
				'Мен, жұмыс беруші осы Порталға еңбек шартын және қызметкермен еңбек шартын тоқтату туралы енгізбеуге бола ма?',
			answer:
				'Жоқ Қазақстан Республикасының қолданыстағы Еңбек кодексінің 23 -бабы 2 -тармағының 27 -тармақшасына сәйкес жұмыс беруші қызметкермен еңбек шартын жасасу және бұзу, оған өзгерістер және (немесе) толықтырулар енгізу туралы ақпаратты енгізуге міндетті.',
		},
		5: {
			question: 'Осы Порталда қызметтер ақылы түрде көрсетіледі ме? болса, қайсысы?',
			answer: 'Еңбек ресурстары порталында (ehr24) барлық қызметтер тегін көрсетіледі.',
		},
		6: {
			question:
				'Егер қызметкер өз еркімен жұмыстан шығып, еңбек шарты бұзылса, келісімшартты алып тастау керек пе? Кәсіпорындағы қызметкерлер санын толтырған кезде бұзылған шарт есептеледі ме?',
			answer:
				'Бұзылған ЕШ жоюдың қажеті жоқ. Белсенді қызметкерлер санында тек қолданыстағы еңбек шарттары ескеріледі.',
		},
		7: {
			question: 'Қате жасалған шарттарды қалай жоюға болады?',
			answer:
				'Шартты жою үшін шарттар тізімінде шартты таңдау қажет, осы шартқа қарама-қарсы  <b><<{{button}}>></b> батырмасын басу және ашылмалы мәзірден <b><<{{action}}>></b> әрекетін таңдау қажет.',
			suggestions: {
				actions: 'Әрекет',
				remove_contracts: 'Шартты жою',
			},
		},
		8: {
			question:
				'Негізгі компанияға қабылданған қызметкерлер бар, ал аударымдар филиалдан. Бұл жағдайда қалай болу керек? Филиалдағы жеке БСН, қызметкерлермен қалай болуға болады: жұмыстан босату немесе басқаша ма?',
			answer:
				'Кодекстің 1-бабы 1-тармағының 39) тармақшасына сәйкес жұмыс беруші-бұл қызметкер еңбек қатынастарында болатын жеке немесе заңды тұлға. ҚР Азаматтық кодексінің (бұдан әрі – ҚР АК) 33-бабына сәйкес меншік, шаруашылық жүргізу немесе жедел басқару құқығында оқшауланған мүлкі бар және осы мүлікпен өз міндеттемелері бойынша жауап беретін, өз атынан мүліктік және жеке мүліктік емес құқықтар мен міндеттерді сатып ала алатын және жүзеге асыра алатын, сотта талапкер және жауапкер бола алатын ұйым заңды тұлға деп танылады. Сонымен қатар, филиалдар мен өкілдіктер заңды тұлға болып табылмайтынын атап өтеміз. Оларға өздерін құрған заңды тұлға мүлік береді және олар бекіткен Ережелер негізінде әрекет етеді (ҚР АК 43-бабының 3-тармағы). Осылайша, қызметкермен еңбек шарты заңды тұлғамен, яғни бас кәсіпорынмен жасалады және бас кәсіпорын ЕШЕБЖ-ға ақпарат енгізеді.',
		},
		9: {
			question:
				'Жалақысы сақталмайтын демалыста жүрген кызметкерлермен қалай болуға болады: олар бойынша МЗЖ болмайды, ал ЕШЕЖБ-да олар көрсетіледі. Бұл сәйкессіздік болмай ма?',
			answer:
				'Қызметкердің жалақысы сақталмайтын демалыста болуы МЗЖ бойынша сәйкессіздік ретінде шығатын болады, бірақ бұл хабарлама тек ақпараттық сипатта екенін еске саламыз.',
		},
		10: {
			question:
				'Жұмыс беруші қызметкердің ЕШ туралы ақпаратты енгізбестен бұрын жеке деректерді өңдеуге келісімге қол қоюы керек пе?',
			answer: 'Жұмыс берушінің қалауы бойынша',
		},
		11: {
			question: 'Еңбек шарттары бойынша мәліметтерді енгізу не үшін қажет? Ол не береді?',
			answer:
				'Еңбек шарттары бойынша мәліметтерді енгізу ҚР барлық Қызметкерлерінің еңбек қызметі бойынша эталондық деректер базасын құруға мүмкіндік береді. Жүйе жалдамалы қызметкерлердің еңбек қызметі туралы анық ақпаратты қалыптастыратын болады және өтілін растауға, сондай-ақ қорға түсетін түсімдерді бақылауға мүмкіндік береді Жұмыс берушілер үміткердің еңбек қызметі туралы сенімді ақпарат алады, Қызметкер әлеуметтік тәуекелдерден сақтандырылатын болады. ЕШЕБЖ кадрлық іс жүргізудің оңайлатылған және оңтайландырылған жүйесін пайдалануға мүмкіндік береді, Қызметкердің электрондық құжаттамасы бойынша мәліметтер алу жөніндегі сервиспен интеграциялау арқылы еңбек өтілі, біліктілігі, жұмыс орны рәсімдерін растауға арналған уақытты қысқартады. Бұл Қызметкерге жұмысқа орналасу, еңбек шартын жасасу кезінде шығындарды азайтуға, қашықтықтан ынтымақтастықты жеңілдетуге мүмкіндік береді.',
		},
		12: {
			question: '1 адамнан тұратын ЖК бойынша мәліметтерді енгізу керек пе?',
			answer: 'Жоқ',
		},
		13: {
			question: 'Бейрезиденттер бойынша мәліметтерді енгізуге бола ма?',
			answer: 'Иә. Барлық жалдамалы қызметкерлердің еңбек шарттары бойынша мәліметтер енгізіледі.',
		},
		14: {
			question: 'Мемлекеттік қызметшілер бойынша мәліметтерді енгізуге бола ма?',
			answer: 'Жоқ, кодексте мемлекеттік қызметшілердің еңбек қызметі жөніндегі мәліметтерді енгізу көзделмеген.',
		},
		15: {
			question:
				'Егер 2007 жылға дейін Қазақстан Республикасының Еңбек кодексі еңбек шартының міндетті түрде болуын реттемегендіктен, еңбек шарты жасалмаса ше?',
			answer:
				'Қолданыстағы Еңбек кодексіне сәйкес еңбек шарты міндетті түрде жасалуы керек. Осыған сәйкес, егер ол болмаса, онда еңбек шартын жасасып, оны тіркеу қажет.',
		},
		16: {
			question: 'ЕШ тіркеу кезінде кәсіпорынның ЭЦҚ кімдерге ресімделуі тиіс?',
			answer:
				'Еңбек шарттарын тіркеу кезінде заңды тұлғаның басшысына не басшының сенім білдірілген тұлғасына ресімделген жұмыс берушінің ЭЦҚ пайдаланылады. Бұл кадр қызметінің қызметкері болуы мүмкін.',
		},
		17: {
			question:
				'Неліктен бұл еңбек шарттарын жасасу үшін қажетті жалақы және еңбек жағдайлары туралы ақпаратты қамтымайды? Егер мен ЭЕШ-ға ауыссам, бұл маған қағаз жүзінде ЕШ-ны жасасудың қажеті жоқ дегенді білдіре ме?',
			answer:
				'ЭЕШ-бұл электрондық еңбек шартының аббревиатурасы. Жұмыс беруші еңбек шартын электронды немесе дәстүрлі тәсілмен қағаз тасығышта жасай алады және және ол бойынша мәліметтерді міндетті түрде ЕШЕБЖ-ға enbek.kz/басқа порталдар немесе кәсіпорынның кадрлық есебінің АЖ арқылы енгізеді.',
		},
		18: {
			question: 'Жұмыстан босатылған қызметкерлер үшін еңбек шарттарын тіркеу қажет пе?',
			answer:
				'Еңбек шарттарын тіркеу тек ағымдағы қызметкерлерге қатысты жүргізіледі. Бұл жағдайда, егер қызметкер жұмыстан кетсе, онда жүйеде бұзу тіркеледі.',
		},
		19: {
			question: '18.09.2020 жылға дейін еңбек шарты жасалған қызметкерлердің мәліметтерін енгізу қажет пе?',
			answer:
				'Қолданыстағы барлық еңбек шарттарын енгізу қажет. Бұл ретте, 18.09.2020 жылға дейін қабылданған жұмыс істеп тұрған қызметкерлердің деректерін енгізуге болады: осы Ереже күшіне енген күннен бастап бір жыл ішінде саны 2000 адамға дейінгі кәсіпорындар үшін; осы Ереже күшіне енген күннен бастап екі жыл ішінде саны 2000 адамнан асатын кәсіпорындар үшін.',
		},
		20: {
			question:
				'Еңбек шарттары туралы мәліметтерді енгізбегені үшін қандай да бір айыппұлдар, қылмыстық немесе әкімшілік жауапкершілік қарастырылған ба?',
			answer: 'Еңбек шарттары туралы мәліметтерді енгізбегені үшін қылмыстық және әкімшілік жауапкершілік көзделмеген.',
		},
		21: {
			question: 'Қызметкерлердің дербес деректерін қорғау қалай қамтамасыз етіледі?',
			answer:
				'Еңбек шарттарын есепке алудың бірыңғай жүйесі мемлекеттік органдардың бірыңғай көліктік ортасында орналасқан, жүйе мемлекеттік техникалық қызметтің барлық талаптарына сәйкес ақпараттық қауіпсіздік сынағынан өтті. Барлық интеграциялар "электрондық үкіметтің" сыртқы шлюзі арқылы ғана жүргізіледі. Жүйе ҚР ҰҚК "мемлекеттік техникалық қызмет" РМК "Ақпараттық қауіпсіздік" талаптарына сәйкестігіне тексерілді, ақпараттық қауіпсіздік туралы сертификат алынды. Жүйе Мемлекеттік органдардың бірыңғай көлік ортасында орналасқан және сыртқы жүйелерді интеграциялау "электрондық үкіметтің" сыртқы шлюзі арқылы ғана жүзеге асырылады. Жүйе деректеріне қол жеткізу тек мынадай заңдар шеңберінде жүзеге асырылады: "Ақпаратқа қол жеткізу туралы" Қазақстан Республикасының Заңы 2015 жылғы 16 қарашадағы № 401-V ҚРЗ. Дербес деректер және оларды қорғау туралы Қазақстан Республикасының 2013 жылғы 21 мамырдағы N 94-V Заңы. "Ақпараттық-коммуникациялық технологиялар және ақпараттық қауіпсіздікті қамтамасыз ету саласындағы бірыңғай талаптарды бекіту туралы" Қазақстан Республикасы Үкіметінің 2016 жылғы 20 желтоқсандағы № 832 Қаулысы.',
		},
		22: {
			question:
				'Егер ақпарат электронды түрде сақталатын болса, жұмыс берушілер электронды нұсқада ЭЕШ-ны мемлекеттік мұрағатқа тапсыра ала ма? Және бұл нормалар заңдарда көрсетілген бе?',
			answer: 'Бұл норма ҚР Еңбек кодексінің және Қағидалардың ағымдағы редакциясында қарастырылмаған.',
		},
		23: {
			question: 'Кәсіби дағдылар мен жеке қасиеттер міндетті түрде толтырылуы керек пе?',
			answer:
				'Жұмыс беруші қызметкермен еңбек шартын жасасу және тоқтату туралы, ол бойынша енгізілетін, тармақшаларда көзделген мәліметтерді қамтитын өзгерістер мен толықтырулар туралы ақпарат енгізеді 1), 2), 3), 4), 5) және Кодекстің 28-бабы 1-тармағының 13) тармақшасы еңбек шарттарын есепке алудың бірыңғай жүйесіне енгізіледі. Демек, "әскери міндет", "арнайы дағдылар", "жалпы және икемді дағдылар" сияқты қосымша ақпаратты енгізу міндетті емес.',
		},
		24: {
			question:
				'Қашықтан жұмысқа шығу туралы қосымша келісімді тіркеу қажет пе? Жұмыс орны өзгере ме? Тіркеу қажет болған жағдайда толық емес жұмыс күні бола ма? (Еңбекақы мөлшері 0,5 есе азаяды.)',
			answer:
				'Қосымша келісімді енгізу кезінде міндетті жолдарды толтыру қажет, мұндай жолдар жұлдызшамен * ("Қосымша келісімнің нөмірі", "Қосымша келісім жасалған күн", "Қосымша Келісімнің қолданылуы басталған күн"), сондай-ақ өзгерген тиісті жолды толтыру қажет',
			answer_1: 'лауазымы ауысқан кезде "Лауазымы" және "Штаттық лауазымы" деген жолдар толтырылады',
			answer_2: 'жұмысты орындау орнын ауыстырған кезде "Жұмысты орындау орны" жолы толтырылады',
			answer_3: 'жұмыс уақыты режимін ауыстырған кезде "Жұмыс уақыты режимі" деген жол толтырылады',
			answer_4:
				'еңбек шартының мерзімін ұзарту кезінде "Шарттың мерзімін" және "Еңбек шартының қолданылу мерзімінің аяқталу күнін" толтыру қажет. "Еңбек шартының қолданылуы аяқталған күн" жолында еңбек шарты ұзартылатын күнді көрсету қажет.',
		},
		25: {
			question:
				'Егер бұрын жұмыстан шығарылған қызметкер қайтарылса, еңбек шартын қайтадан енгізу мүмкін болмайды. Қалай?',
			answer:
				'ЕШ туралы мәліметтерді енгізу бойынша техникалық мәселелер туындаған жағдайда Министрлікке немесе "Еңбек ресурстарын дамыту орталығы" АҚ-ға жүгіну қажет.',
		},
		26: {
			question: 'Азаматтықты ауыстырған кезде ЖСН деректерін қалай өзгертуге болады',
			answer:
				'Бұл функционал ЕШЕБЖ-да іске асырылмаған. Бұл мәселені шешу үшін Министрлікке қызметкердің ЖСН өзгерту туралы өтінішпен ЕШЕБЖ-ға және enbek.kz порталына хат жолдау қажет. Хатта қызметкердің ЖСН мен аты-жөні, ұйымның БСН, шарттың нөмірі мен күні көрсетілуі тиіс.',
		},
		27: {
			question:
				'Біз жұмыс орны ретінде жай қаланы көрсете аламыз ба, себебі жұмысшының жұмыс орны жоқ, оның жүріп-тұратын жұмыс сипаты бар?',
			answer:
				'Жұмыстың жүріп-тұру сипаты кезінде жұмысты орындау орны жолында жұмыс берушінің мекенжайын көрсету қажет.',
		},
		28: {
			question:
				'Қызметкер ЕШЕБЖ енгізілмеген, қазан айында қайтыс болған, жүйе оны қазір енгізуге мүмкіндік бермейді ме?',
			answer:
				'ЕШЕБЖ-де "ЖСН" бағаны міндетті өріс болып табылады, қайтыс болған адамның ЖСН жоқ, яғни бұл жағдайда еңбек шарттары бойынша мәліметтер енгізілмейді.',
		},
		29: {
			question: 'Тәжірибеленушілер туралы сұрақ. Ақылы тәжірибе. Жеке еңбек шартын тіркеу керек пе? 1 айға уақытша?',
			answer:
				'Кодекстің 30-бабында еңбек шартын жасасу мерзімі регламенттелген. Кодексте, егер белгілі бір жұмысты орындау уақыты болмаса, бір ай мерзімге еңбек шартын жасасу көзделмеген. Осылайша, егер жұмыс беруші тәжірибеленушімен еңбек шартын жасаса, онда ол еңбек шарты туралы ақпаратты ЕШЕБЖ-ға енгізеді.',
		},
		30: {
			question: 'Жұмыс істейтін зейнеткерлер туралы мәліметтерді енгізу керек пе?',
			answer:
				'Жұмыс беруші барлық еңбек шарттары бойынша, оның ішінде зейнеткерлер бойынша еңбек шарттары туралы мәліметтерді ЕШЕБЖ-ға енгізеді.',
		},
	},
	//About us
	back: 'Артқа',
	registration_working_contract: 'Еңбек шартын электрондық форматта тіркеу',
	electronic_molding: 'МО АЖ - дан Қызметкердің электрондық Жеке ісін қалыптастыру',
	conclusion_contract: 'Электрондық еңбек шартын жасасу',
	automation_checking: 'Шарттың ҚР Еңбек кодексіне сәйкестігін автоматты түрде тексеру',
	provide_information: 'МО АЖ Кадрлық есептілікті ұсыну',
	worker_professional_history: 'Қызметкердің жұмысқа орналасу тарихын жүргізу (электрондық еңбек кітапшасы',
	edit_confirm_contract: 'Қолданыстағы ЭЕШ-на өзгерістер енгізу',
	employee_comment: 'Жұмыскердің пікірі',
	about_us: {
		introduce:
			'Қазақстан Республикасының Еңбек ресурстары порталы (ehr24) еңбек шарттарын есепке алу процесін және мемлекеттік органдар мен жұмыс берушілердің өзара іс-қимылын автоматтандыруға арналған.',
		resolve_problems: 'Портал қызметкер мен жұмыс берушінің қарым-қатынасындағы келесі міндеттерді шешуге бағытталған',
		full_zip_information:
			'Қызметкердің еңбек қызметі туралы барлық мәліметтер (бұрынғы жұмыс орындары туралы мәліметтер) онлайн режимінде мәліметтер алу мүмкіндігін ұсына отырып, Порталда шоғырланған, сондай-ақ мессенджерлерде кері байланыс алу бойынша техникалық шешімдер іске асырылған',
	},
	//For employer
	for_employer: 'Жұмыс берушіге',
	for_employer_page: {
		introduce:
			'Сапалы кадрларды іздеу жұмыс берушіден ресурстарды талап етеді. Өз тарапынан заңнама жұмыс берушіден еңбек шарттары бойынша мәліметтерді енгізуді талап етеді',
		resolve_problems: 'Еңбек ресурстары порталы кадрлық іс жүргізу процесінде барлық мәселелерді бірден шешеді',
		services: {
			provide_access:
				'Қызметкерлердің бірыңғай бейініне және еңбек тарихына қол жеткізуді ұсыну (қызметкердің қатар жұмыспен қамтылуы туралы хабардар болу)',
			shorting_of_risks:
				'Деректерді бұрмалау тәуекелдерін қысқарту (еңбек өтілі, еңбекке жарамсыздық парақтары, соттылықтар, шектеулер мен тыйым салулар)',
			simplify_personal_data: 'Жеке істерді жүргізуді оңайлату',
			reduce_price: 'Еңбек шарттарын ресімдеу құнын төмендету',
		},
		full_zip_information:
			'Жұмыс берушілердің ыңғайлылығы үшін Порталда қызметкердің жеке ісін ұсыну бойынша қызмет көрсету іске асырылды, онда паспорттық деректерді алу бөлігінде ҚР Әділет министрлігінің Жеке тұлғалардың мемлекеттік базасымен, диплом/білім туралы мәліметтерді алу бөлігінде ҚР Ғылым және білім министрлігінің ҰББДҚ АЖ-мен, қызметкердің жеке ісін қалыптастыру үшін соттылықтың болмауы/болуы туралы анықтаманы алу бөлігінде ҚР Бас прокуратурасының Құқықтық статистика және арнайы есепке алу комитетімен, ҚР Денсаулық сақтау министрлігімен қызметкердің Жеке ісін қалыптастыру үшін психо, нарко және туберкулез Диспансерлерінен анықтама алу бөлігінде және 0/75у анықтамасын алу бөлігінде, ҚР Еңбек және халықты әлеуметтік қорғау министрлігінің МОДҚ ААЖ Мүгедектіктің бар екендігі туралы анықтама алу бөлігінде, бұл өз кезегінде Порталды пайдаланудың ыңғайлылығын қамтамасыз етеді',
		effects_for_employers_list: {
			transfer_to_electronic_documents: 'Электрондық еңбек шарттарына көшу',
			keeping_electronic_book: 'Электрондық еңбек кітапшасын жүргізу',
			accessibility_for_employers: 'Жұмыс берушілер үшін қызметкерлердің бірыңғай бейініне қолжетімділік',
			shorting_tome_for_iteration: 'Интеграция уақытын қысқарту',
		},
	},
	//Worker page
	for_worker_page: {
		introduce:
			'Қазақстанда қызметкердің әлеуметтік қорғалу деңгейін бағалау әлсіз деңгейде қалып отыр. Еңбек келісімшарттары жиі жасалмайды, олар бойынша міндеттемелер орындалмайды, еңбек кітапшалары жоғалады және қызметкер барлық жұмыс орындарын айналып өтіп, мұрағатты көтеруі керек',
		resolve_problems: 'Еңбек ресурстары порталында сіз толықтай қорғалғансыз',
		services: {
			shorting_terms_of_employment:
				'Құжаттарды жинаудан бас тарту және ұйымдарға бару арқылы жұмысқа орналастыру мерзімдерін қысқарту',
			proactive_registration:
				'Еңбек шарты бұзылған және жаңа еңбек шарты тіркелмеген жағдайда жұмыссыздар бойынша дерекқорда проактивті тіркелу',
			opportunity_of_getting_services: 'Проактивті қызметтерді алу мүмкіндігі',
			protect_from_socials_risks: 'Әлеуметтік тәуекелдерден қорғау',
		},
		full_zip_information: 'Мессенджерде кері байланыс алу бойынша техникалық шешімдер іске асырылды ',
		portal_is_providing:
			'Қызметкерді жұмысқа орналастыруды жеңілдету үшін Портал жұмыс берушінің жұмысқа орналасу құжаттарын электрондық түрде сұрауына мүмкіндік береді',
		portal_is_providing_2: 'Қазіргі уақытта Портал Әділет министрлігімен',
		portal_is_providing_2_0: 'Жиі қойылатын сұрақтармен Telegram-Bot',
		portal_is_providing_2_1: 'тіркеу мекенжайы, жеке куәлігі, туған жері',
		portal_is_providing_2_2:
			'из информационных систем государственных органов посредством интеграционного взаимодействия с Министерством юстиции',
		portal_is_providing_2_3: 'адрес регистрации, удостоверение личности, место рождения',
		portal_is_providing_2_4: 'Министерством образования',
		portal_is_providing_2_5: 'информация об образовании',
		portal_is_providing_2_6: 'Комитетом по правовой статистике и специальным учета Генеральной Прокуратуры РК',
		portal_is_providing_2_7: 'информация отсутствия либо наличия судимости',
		portal_is_providing_2_8: 'Министерством здравоохранения',
		portal_is_providing_2_9: 'справки из псих, нарко и туб. диспансеров',
		portal_is_providing_2_10: 'Министерством труда и социальной защиты населения',
		portal_is_providing_2_11: 'сведения об инвалидности',
		portal_is_providing_2_12: 'Министерством юстиции',
		portal_is_providing_2_13: 'фотоизображение',
		effects_for_workers: 'Қызметкерлерге арналған әсерлер',
		effects_for_workers_list: {
			order_has_power: 'Мәмілелер сотта жарамды (себебі барлық әрекеттер ЭЦҚ-мен бекітілген)',
			easy_assign: 'Еңбек шартына оңай қол қою',
			discipline_of_interaction: 'Жұмыс берушімен қашықтықтан өзара әрекеттесу',
			shorting_time_within_employment: 'Жұмысқа орналасу уақытын қысқарту',
		},
	},
	select: 'Таңдау',
	min_12_length: 'Минимальная длина 12 символов',
	max_12_length: 'Максималды ұзындығы 12 таңба',
	contracts_tab: {
		not_correct_bin: 'Қате БСН',
		min_12_length: 'Ең қысқасы 12 белгі',
		max_12_length: 'Ең қысқасы 12 белгі',
		warning_info: 'Қайта ұйымдастыруға байланысты қызметкерді ауыстыру күні шарт жасалған күннен ерте болмауы тиіс',
		termination_reason: 'ЕШ тоқтату/бұзу негізі',
		contract_term: 'Шарттың мерзімі',
		deleteAdditionalContract: 'Қосымша келісім сіздің кабинетіңізден жойылады',
		deleteAdditionalContractText:
			'Сіз <div><strong>{{additionalContent}}</strong></div> қосымша келісімін қалпына келтіру мүмкіндігінсіз жойғыңыз келетініне сенімдісіз бе?',
		deleteAdditionalContractNumber: '{{registerDate}} жылғы {{contractNumber}} шартқа № {{additionalContractNumber}}',
		searchInput: 'ЖСН, контрагенттің атын немесе штаттық лауазымын енгізіңіз',
		advancedSearch: 'Кеңейтілген іздеу',
		advancedSearchHide: 'Кеңейтілген іздеуді жабу',
		contract_number: 'Шарттың нөмірі',
		contract_employer_number: 'Шарттың нөмірі',
		indicate_contract_employer_number: 'Еңбек шартының нөмірін көрсетіңіз',
		contractor: 'Контрагент',
		position: 'Лауазым',
		status: 'Мәртебесі',
		expired_date: 'Аяқталу күні',
		conclusion_date: 'Қорытынды күні',
		registration_date: 'Тіркелген күні',
		type: 'Түрі',
		type_is_electronic: 'электрондық',
		type_is_not_electronic: 'қағаз',
		state: 'Жағдайы',
		action: 'Әрекет',
		number: 'Нөмірі',
		begin_date: 'Басталу күні',
		signed: 'Қол қойылды',
		vacation_type: 'Демалыс түрі',
		not_worked_from: 'Бастап жұмыс істемеді',
		not_worket_till: 'Дейін жұмыс істемеді',
		not_correct_iin: 'ЖСН енгізілді',
		date_in_empty: 'Кіру күні көрсетілмеген',
		export: 'Түсіру',
		current_list_treaties: 'Шарттардың ағымдағы тізімі',
		all_contracts: 'Барлық шарттар',
		current_contracts: 'Қолданыстағы шарттар',
		terminate_contracts: 'Бұзылған шарттар',
		overdue_contracts: 'Мерзімі өткен шарттар',
		error_irs: 'Бұл қызметкердің еңбек иммигранты бойынша рұқсаты жоқ',
		error_immigrant: 'Бұл қызметкердің шетелдік жұмыс күші(шетелдікке немесе азаматтығы жоқ адам) бойынша рұқсаты жоқ ',
		export_text: 'Қандай шарттар тізімін жүктегіңіз келетінін таңдаңыз',
		registration_employer_contract: 'Еңбек шартын тіркеу',
		registration_collective_contract: 'Ұжымдық шартты тіркеу',
		registration_employer_electronic_contract: 'ЭЕШ жасау',
		registration_new_employer_contract: 'Жаңа еңбек шартын тіркеу',
		registration_new_collective_contract: 'Ұжымдық шартты тіркеу',
		edit_collective_contract: 'Ұжымдық шартты өңдеу',
		change_bin_because_of_reorganization: 'Қайта ұйымдастыруға байланысты БСН өзгеруі',
		change_contract_bin: 'Қайта құруға байланысты құқық беруші кәсіпорын келісімдеріндегі БСН-нің өзгеруі',
		predecessor_bin: 'Құқық беруші кәсіпорынның БСН',
		date_employee_transfer: 'Жымыскердің ауыстыру күні',
		check: 'Тексеру',
		employees_data: 'Қызметкерлер туралы деректер',
		employee_fio: 'Қызметкердің тегі, аты және әкесінің аты',
		registration_employer_el_contract: 'Электрондық шартын тіркеу',
		enter_predecessor_bin: 'Құқық беруші кәсіпорынның БСН енгізіңіз',
		information_about_contract: 'Шарт туралы ақпарат',
		validity_term: 'Еңбек шартының қолданылу мерзімі',
		validity_term_hint: 'Еңбек шартының қолданылу мерзімі рұқсаттың қолданылу мерзіміне сәйкес келуге тиіс',
		date_of_contract_signing: 'Шартқа қол қою күні',
		start_contract_date: 'Басталу күні',
		end_contract_date: 'Шарттың қолданылу мерзімі',
		position_by_knz: 'ҰҚЖ бойынша лауазым',
		indicate_position_or_select_from_handbook: 'Штаттық позицияны көрсетіңіз немесе каталогтан таңдаңыз',
		job_type: 'Жұмыс түрі',
		working_time_mode: 'Жұмыс уақыты режимі',
		tarrif_rate: 'Тарифтік мөлшерлеме',
		country_work: 'Жұмыс орнының елі',
		region_work: 'Жұмыс орнының аймағы',
		distrcit_work: 'Жұмыс орнының ауданы',
		address_work: 'Жұмыс орнының мекенжайы',
		populated_area: 'Елді мекен',
		indicate_address_work: 'Жұмыс орындалатын мекенжайды көрсетіңіз',
		remote_work: 'Жұмыспен қамту нысаны',
		additional_information: 'Қосымша мәліметтер',
		professionals_skills: 'Кәсіби дағдылар',
		indicate_professionals_skills: 'Кәсіби дағдыларды көрсетіңіз',
		personal_qualities: 'Жеке қасиеттер',
		indicate_personal_qualities: 'Жеке қасиеттерді көрсетіңіз',
		you_havnt_registered_any_contract: 'Сіз ешқандай келісімшартты тіркеген жоқсыз',
		contract_short_information: '{{registerDate}} ж. басталған № {{contractNumber}} шарт',
		contract_recover_information: '{{contractNumber}} басталған {{registerDate}} Еңбек шартын қалпына келтіру',
		update_iin: 'ЖСН өзектендіру',
		terminate: {
			process_button_title: 'Түсінікті, бәрібір бұзу',
			warning: 'Еңбек шарты бұзылғаннан кейін қосымша келісімдерді жою, редакциялау және құрудан қорғалған',
		},
		recover: {
			text: 'Қате бұзудың күшін жою үшін ҚР ЕХӘҚМ ресми хатпен жүгіну қажет',
			confirm_button: 'Шартты қалпына келтіру',
			cancel_text: 'Болдырмау',
			worker_iin: 'Қызметкердің ЖСН',
			worker_fio: 'Қызметкердің аты-жөні',
			contract_info: 'Шарты туралы ақпарат',
			recover_date: 'Шартты қалпына келтіру күні',
			drestoreOrgTypeCode: 'Қалпына келтіру себебін таңдаңыз',
			restoreOrder: 'Қалпына келтіру туралы бұйрықтың нөмірі',
			dcourtCode: 'Қайта қабылдау туралы шешім шығарған органның атауы',
			select_from_dict: 'анықтамалықтан таңдаңыз',
			put_order_number: 'Бұйрықтың нөмірін көрсетіңіз',
			select_from_dict_or_input: 'Атауды енгізіңіз немесе анықтамалықтан таңдаңыз',
			sign_and_recover: 'ЭЦҚ-мен қол қою және қалпына келтіру',
			reject_text: 'Орындау мүмкін емес, осы ЕШ/ ҚЕШ / Тоқтату бойынша арнайы әлеуметтік төлемге сұраныс жіберілді',
			note: 'Пікір',
			note_placeholder: 'Еңбек шартын қалпына келтіру туралы түсініктеме жазыңыз',
		},
		collective_agreement_conclude: 'Ұжымдық шарт жасасу',
		conclude_collective_contract: 'Электрондық ұжымдық шарт жасасу',
		remove: {
			title: 'Шарт сіздің кабинетіңізден жойылады',
			are_you_sure_no_recovery:
				'Сіз <div><strong>{{registerDate}} ж. басталған № {{contractNumber}}</strong></div> шартты қалпына келтіру мүмкіндігінсіз жойғыңыз келетініне сенімдісіз бе?',
			process_button_title: 'Иә, ЭЦҚ-мен қол қою және жою',
		},
		remove_contract: {
			title: 'Назар аударыңыз!!!',
			are_you_sure_no_recovery:
				'Сіз еңбек шартын өшіргелі жатырсыз. Жойылған еңбек шартты қалпына келтіру мүмкін емес. Жалғастырғыңыз келетініне сенімдісіз бе?',
		},
		employee_iniitials: 'Фамилия, имя и ',
	},
	modal_info: {
		cancel_text: 'ok',
		title:
			'ҚР ҰКО NCALayer үшін SSL-сертификатының қолданылу мерзімінің аяқталуына байланысты 01.06.2022 жылы қосымшаны жаңартты.',
		body: 'Аутентификация және ҚР ҰКО ЭЦҚ кілттері арқылы қол қою кезінде қателер туындаған жағдайда, NCALayer бағдарламасын қайта іске қосу (шығу және қосымшаны қайта іске қосу) қажет, егер қате қайталанса, келесі сілтеме бойынша  NCALayer бағдарламасын қайта орнату қажет',
	},
	modal_info_employer: {
		cancel_text: 'ok',
		title: 'Құрметті жұмыс беруші!',
		body: 'Техникалық жұмыстарға байланысты «Адамның сыбайлас жемқорлық қылмыс жасағаны туралы мәліметтер» анықтамасына сұрау салу уақытша қол жетімсіз. ',
		body_second: 'Қолайсыздықтар үшін кешірім сұраймыз!',
		additional_info: 'Сауалнаманы өту',
		checkbox_text: 'Хабарламаны енді көрсетпеңіз',
	},
	modal_general: {
		cancel_text: 'ok',
		title: 'Құрметті жұмыс беруші!',
		body: 'Қызметкерді жазатайым оқиғалардан міндетті сақтандыру шартын (ЖОМС) жасасу үшін, Сіз Қазақстан Республикасы Еңбек және халықты әлеуметтік қорғау министрлігінің «Мемлекеттік аннуитеттік компания «ӨСК» АҚ қызметін пайдалана алатыныңызды хабарлаймыз ',
		additional_info: 'Қолайсыздықтар үшін кешірім сұраймыз. Қазіргі уақытта мәселені жою бойынша шаралар қабылдануда.',
	},
	modal_home: {
		cancel_text: 'Жабу',
		title: 'Құрметті еңбек ресурстары порталының пайдаланушылары!',
		body: 'Жаңарту бойынша техникалық жұмыстардың жүргізілуіне байланысты 2025 жылғы 6 қыркүйектен 7 қыркүйекке дейін сағат 21:00-ден 08:00-ге дейін Портал қолжетімсіз болады.',
		body_second: 'Қолайсыздық үшін кешірім сұраймыз.',
		checkbox_text: 'Хабарламаны енді көрсетпеңіз',
	},
	validation: {
		date: {
			min: 'Күні {{ minDate }} кеш болмауы тиіс',
			can_not_be_after_now: 'Күн ағымдағы күннен кейін болмауы тиіс',
			can_not_be_before_sub: 'Шартқа қол қою күні жұмыстың басталу күнінен кеш болмауы қажет',
			end_before_start: 'Шарттың қолданылу мерзімі басталу күнінен ерте болмауы қажет',
		},
		invalid_email: 'Пошта форматы дұрыс емес',
		required: 'Міндетті жол',
		required_nc: 'Рұқсатты тізімнен таңдаңыз',
		required_permit_ti: 'Сізде иммигрантты жұмысқа орналастыруға рұқсатыңыз жоқ',
		required_permit_irs: 'Сізде шетелдік жұмыс күшін жұмысқа орналастыруға рұқсатыңыз жоқ',
		required_date_from: 'Күні дұрыс қойылмаған',
		required_date_to: 'Күні дұрыс қойылмаған',
		required_nkz: 'Лауазымды анықтамалықтан таңдаңыз',
		requiredList1:
			'"1-тізім бойынша жұмыс түрі" және "2-тізім бойынша жұмыс түрі" өрістерінен кем дегенде бір мән толтырылуы керек',
		min_length: 'Минималды ұзындық: {{value}}',
		max_length: 'Максималды ұзындығы: {{value}}',
		min_length_20: 'Минималды ұзындық: 20',
		wrong_symbol: 'Жарамсыз таңба(лар)',
		labor: {
			date: {
				min: 'Ағымдағы күннен бастап 50 жылдан ерте болмауы тиіс',
				min_contract: 'Келісімшарт жасалған күннен ерте болмауы тиіс',
				max: 'Ағымдағы күннен кеш болмауы тиіс',
				max_contract: '"Жұмыс істемеді" өрісінің мәнінен кеш болмауы тиіс',
				max_work_date: '"Бірінші жұмыс күні" өрісінің мәнінен  кеш болмауы тиіс оң санды енгізіңіз',
				min_end_date: '"Дейін жумыс істемеді" өрісі "Бастап жумыс істемеді" өріс мәнінен бұрын болмауы керек',
			},
			number: {
				weekend: 'введите положительное число',
			},
		},
		staff: {
			greater: '0-ден көп болуы керек',
			less_1000: '1000-нан аз немесе тең болуы керек',
			less_2_75: '2.75-тен аз немесе тең болуы керек',
			enter_integer: 'Бүтін сан енгізіңіз',
			min_value: 'Ең аз саны 1',
			max_value: 'Максималды саны 1000',
		},
		min_12_length: 'Ең қысқасы 12 белгі',
		max_12_length: 'Ең қысқасы 12 белгі',
		iin_bin_error_employer: 'Қызметкердің ЖСН-ы жұмыс берушінің БСН/ЖСН-ы мен сәйкес болмауы тиіс',
		contracts_civil_low: {
			end_date_before_start: 'Дата окончания действия договора не может быть раньше даты начала работы',
			is_not_before_contractDate: 'Не должна быть раньше даты заключения договора ГПХ',
			is_not_after_contractDate: 'Не должна быть позже чем Дата начала действия доп.соглашения',
			is_not_before_subsidiaryContractDate: 'Не должна быть раньше чем Дата заключения доп.соглашения',
			is_not_before_today: 'Дата не должна быть позже текущего дня',
		},
	},
	search: 'Іздеу',
	notification: 'Хабарландыру',
	select_from_list: 'Тізімнен таңдаңыз',
	apply: 'қолдану',
	employer_data: 'Жұмыс берушінің деректері',
	add_employer_data: 'Жұмыс берушіні қосу',
	union_data: 'Ұжымдық одақтың деректері',
	employee_data: 'Қызметкердің деректері',
	representative_data: 'Өкілдің деректері',
	enterprise_name: 'Атауы',
	employee_yin: 'Қызметкердің ЖСН',
	representative_yin: 'Өкілдің ЖСН-і',
	representative_fio: 'Өкілдің аты-жөні',
	employee_initials: 'Тегі, аты және әкесінің аты',
	enter_count_digitals: '{{count}} сандарын енгізіңіз',
	choose_from_handbook: 'каталогтан таңдаңыз',
	value_from_to: '{{from}} - ден {{to}} - ге дейін енгізіңіз',
	no_data_find: 'деректер табылмады',
	notifications_all: 'Барлығы',
	notifications_read: 'Оқылған',
	notifications_unread: 'Оқылмаған',
	notification_open: 'Ашу',
	notification_close: 'Жабу',
	notification_go_back: 'Артқа',
	notification_go_forward: 'Алға',
	notification_show_per_page: 'Көрсету',
	notification_showed_per_page: 'Көрсетілген',
	notification_open_all: 'Барлық хабарландыруларды көрсету',
	notification_open_contract: 'Келісімді ашу',
	notification_open_etd: 'ЭКШ ашу',
	notification_open_addition_contract: 'Қосымша келісімді ашу',
	notification_no_notifications: 'Сізде әлі хабарламалар жоқ',
	pagination: {
		next: 'Алға >',
		previous: '< Артқа',
		show_per_page_text: 'Көрсету бойынша',
		show_all: 'Барлығы',
		showed: 'көрсетілген',
		from: 'бастап',
	},
	// Sidebar
	profile: 'Профиль',
	employment_contract: 'Келісім шарттар',
	personal_records: 'Жеке істер',
	notifications: 'Хабарламалар',
	events: 'Оқиғалар',
	nonotif: 'Хабарламалар жоқ!',
	noevent: 'Оқиға жоқ!',
	nodata: 'Деректер жоқ (Деректерді алу кезінде қате шығуда)',
	exit: 'Шығу',
	// My Profile
	organisation_data: 'Ұйым деректері',
	edit: 'Өңдеу',
	managers: 'Менеджерлер',
	company: 'Кәсіпорын',
	choose_company: 'Кәсіпорынды таңдаңыз',
	add_company: 'Кәсіпорын қосу',
	add_fl_employer: 'ЖТ жұмыс берушіні қосу',
	add_fl_employer_text: 'Сіз жұмыс берушінің кәсіпорындарына жеке тұлға қосасыз.',
	account_details: 'Деректемелер',
	contact_information: 'Байланыс ақпараты',
	experience_working_title: 'Зейнетақы алдындағы төлемдерді алдын ала есептеу',
	information_about_company: 'Кәсіпорын туралы ақпарат',
	bin_iin: 'БСН/ЖСН',
	iin: 'ЖСН',
	full_bin_name: 'Толық атауы',
	certificate_expiry_date: 'Сертификаттың қолданылу мерзімі',
	electronic_mail: 'Электрондық пошта',
	officePhone: 'Жұмыс телефоны',
	mobilePhone: 'Ұялы телефон',
	phoneOffice: 'Телефон (жұмыс)',
	phoneMobile: 'Телефон (ұялы)',
	lastname: 'Тегі',
	firstname: 'Аты',
	middlename: 'Әкесінің аты',
	city_district: 'Қала немесе аудан',
	locality: 'Елді мекен',
	address: 'Мекен-жайы',
	web_address: 'Сайттың адресі',
	employee_number: 'Қызметкерлер саны',
	details_about_company: 'Кәсіпорын туралы мәліметтер',
	account_settings: 'Есептік жазбаны орнату',
	go_to_profile: 'Профильге өту',
	notification_centre: 'Хабарламалар орталығы',
	logout: 'Шығу',
	edit_btn: 'Өзгерту',
	contract_information: 'Байланыс ақпараты',
	activity_type: 'Қызмет түрі',
	ownership_type: 'Меншік нысаны',
	internal: 'Ішкі',
	worker_count: 'Қызметкерлер саны',
	region: 'Аймақ',
	district: 'Аудан',
	house: 'Үй',
	office: 'Кеңсе',
	populated_area: 'Елді мекен',
	website: 'Сайттың адресі',
	drag_file: 'Файлды осы аймаққа сүйреңіз немесе',
	choose_ecp: 'ЭЦҚ таңдау',
	update_ecp: 'ЭЦҚ жаңарту',
	company_titles: {
		add_new_company: 'Жаңа ұйым қосу',
	},
	enter_website: 'Веб-сайтты енгізіңіз',
	write_what_you_want: 'Қажет деп санағаныңызды жазыңыз',
	//worker profile
	photo: 'Фото',
	fio: 'Толық аты',
	verification: 'Тексеру',
	verification_type: 'Верификация әдісін таңдаңыз',
	verification_info: 'ЭЦҚ (RSA), СМС немесе QR көмегімен верификациядан өту қажет',
	not_equal_bin: 'ЭЦҚ-дағы БСН кәсіпорынның БСН-мен сәйкес келмейді',
	contract_termination_reason: 'Еңбек шартын тоқтату/бұзу негізі',
	contract_termination_checkbox:
		'Өнімділіктің жоғарылауына әкелетін жаңа технологияларды (цифрландыруды) енгізуге байланысты ЕШ-ты тоқтату/ бұзу',
	contract_termination_without_employees_consent:
		'Қызметкермен өзара әрекеттестіктің болмауына байланысты қызметкердің келісімінсіз ЭЕШ тоқтату',
	contract_term: 'Еңбек шартының қолданыс мерзімі',
	contract_end_date: 'Шарттың аяқталу күні',
	wait: 'Күте тұрыңыз!',
	loading_from_esutd: 'ЕШЕБЖ -ден деректерді жүктеу жүріп жатыр...',
	prolongation_title: '{{registerDate}} жылғы № {{contractNumber}} еңбек шартын ұзарту',
	worker_fullname: 'Қызметкердің аты-жөні',
	additional_contract_creation_title: '{{registerDate}} басталған № {{contractNumber}} шартқа қосымша келісім жасау',
	select_all: 'Барлығын таңдау',
	contract_work_district: 'Жұмыс орнының аймағы',
	contract_work_region: 'Жұмыс орнының ауданы',
	contract_work_locality: 'Елді мекен',
	work_address_placeholder: 'Жұмысты орындау мекен-жайын көрсетіңіз',
	esutd_reg_date: 'ЕШЕБЖ тіркелген күні',
	electronic_contract_number: '{{registerDate}} басталған №{{contractNumber}} электрондық шарт',
	contract_number: '№{{contractNumber}} электрондық шарт',
	unknown_error: 'Белгісіз қате',
	sign_button: 'Қол қою',
	sign_button_all: 'Барлығына қол қою',
	sign_button_ecp: 'ЭЦҚ қол қою',
	sign_button_qr: 'QR қол қою',
	error_qr: 'QR-код құру кезінде қате. Кейінірек көріңіз.',
	error_was_signed: 'QR-код құру кезінде қате. Бұл құжатқа қол қойылды.',
	time_out: 'Күту уақыты аяқталды',
	text_edt_sign_employee: 'Мен шарттың талаптарымен келісемін және электрондық еңбек шартына қол қойғым келеді',
	text_qr_sign_employee1: '1. EGOV Mobile қосымшасын жүктеп алыңыз және орнатыңыз',
	text_qr_sign_employee1_biz: '1. EGOV Business қосымшасын жүктеп алыңыз және орнатыңыз',
	text_qr_sign_employee2: '2. Қосымшаның негізгі бетінің жоғарғы оң жақ бұрышында QR сканерін ашыңыз',
	text_qr_sign_employee3: '3. Кодты санау және қол қою үшін телефонды осы экранға апарыңыз',
	text_edt_sign:
		'Сіз қызметкермен электрондық еңбек шартын жасайсыз! Қол қойылғаннан кейін бұл шарттар Еңбек кодексінің 27-бабының 2-тармағына сәйкес еңбек шарттарын есепке алудың бірыңғай жүйесіне автоматты түрде жіберіледі және кез келген өзгерістерді шартқа қосымша келісім жасасу арқылы ғана жүргізуге болады.',
	open_etd: 'ЭЕШ ашу',
	open_eds: 'ЭҚК ашу',
	open_ecd: 'ЭҰШ ашу',
	recall_etd:
		'Сіз шынымен электрондық еңбек шартын бұзу туралы өтінішті қайтарып алғыңыз келе ме? Бұл жағдайда шарт жарамды болып қалады.',
	decline_etd:
		'Сіз шынымен электрондық еңбек шартын бұзу туралы өтінішті қайтарып алғыңыз келе ме? Бұл жағдайда шарт жарамды болып қалады.',
	edit_button: 'Өңдеу',
	recover_button: 'Қалпына келтіру',
	close_additional_contract: 'Қосымша келісімді жабу',
	add_contract_num: 'Қосымша келісім нөмірі',
	work_address: 'Жұмыстарды орындау орнының мекенжайы',
	create_add_contract: 'Қосымша келісім жасау',
	create_add_e_contract: 'ЭҚК жасау',
	create_social_leave: 'Әлеуметтік демалыс қосу',
	terminate_button: 'Бұзу',
	terminate_application: 'Бұзу туралы өтініш',
	terminate_application_sended: 'Жұмыс берушіге бұзу туралы өтініш  жіберілді',
	parties_requisites: 'Тараптардың деректемелері',
	additional_contracts: 'Қосымша келісімдер',
	social_leaves: 'Әлеуметтік демалыстар',
	auto_prolongation: 'Автоматты түрде ұзарту туралы ақпарат',
	close_contract: 'Еңбек шартын жабу',
	select_pls: 'Таңдаңыз',
	employee: 'Қызметкер',
	iin_bin: 'ЖСН/БСН',
	employer: 'Жұмыс беруші',
	required: 'Міндетті жол',
	invalid_email: 'Пошта форматы дұрыс емес',
	electronic_employment_contract: 'Электрондық еңбек шарты (ЭЕШ)',
	electronic_hint_contract:
		'Егер шарт электрондық форматта жасалса (жұмыс беруші мен қызметкердің ЭЦҚ-сы қол қойылса) құсбелгі қойылады. Егер шарт қағаз форматында жасалған болса, онда құсбелгі қойылмайды.',
	view_add_contr_title:
		'{{registerDate}} басталған № {{contractNumber}} шартқа № {{additionalContractNumber}} қосымша келісім',
	edit_contr_title: '№ {{contractNumber}} шартқа қосымша келісімді редакциялау',
	default_date_value: 'кк.аа.жжжж',
	edit_action: 'Өңдеу',
	delete_action: 'Жою',
	success_alert: 'Операция сәтті аяқталды!',
	error_reorganization_date:
		'Сұрау салуда қайта ұйымдастыру күні жоқ не ЗТ МДБ-да қайта ұйымдастыру күнінен ерте болмауы тиіс',
	social_leave: {
		early: {
			title: 'Әлеуметтік демалыстан ерте шығу туралы ақпарат',
			reason: 'Ерте шығу себебі',
			add: 'Ерте шығуды қосу',
			deleteTitle: 'Сіздің әлеуметтік демалыстан ерте шығуыңыз туралы ақпарат жеке кабинеттен өшіріледі.',
			deleteSubtitle:
				'{{contractDate}} күні жасалған №{{contractNumber}} келісімшарты бойынша әлеуметтік демалыстан ерте шығу №{{socialLeaveNumber}} туралы ақпаратты қайтару мүмкіндігінсіз жоюға сенімдісіз бе?',
		},
		form: {
			subtitle: 'Жұмыскер бойынша еңбекке жарамсыздық туралы мәліметтер бар.',
			text: 'Қызметкер бойынша еңбекке жарамсыздық туралы мәліметтер бар. Алдын ала толтыру үшін таңдаңыз:',
			oundata: 'Алдын ала толтырусыз',
			noworkstart: 'Еңбекке жарамсыздық туралы мәліметтер басталуы',
			noworkteel: 'аяқталуы',
			noworkfinish: 'шығу күні',
			earlyExit: {
				title: 'Выйти досрочно',
				registration: 'Әлеуметтік демалыс бойынша ерте шығуды тіркеу',
				information:
					'{{start_date}} - {{end_date}} аралығындағы еңбекке жарамсыздық туралы мәліметтер (шығу күні {{leave_date}})',
				reason_ru: 'Жұмысқа қайта оралу себебі орыс тілінде',
				reason_kz: 'Жұмысқа қайта оралу себебі қазақ тілінде',
				reason_placeholder: 'Себебін жазыңыз',
			},
		},
		registration_title: '{{registerDate}} жылғы № {{contractNumber}} шартқа әлеуметтік демалысты тіркеу',
		edit_title: '{{registerDate}} басталған № {{contractNumber}} шартқа әлеуметтік демалысты редакциялау',
		view_title: '{{entryDate}} басталған № {{contractNumber}} шартқа Әлеуметтік демалыс',
		info: 'Демалыс туралы ақпарат',
		type: 'Әлеуметтік демалыс түрі',
		temporary_disability_title: 'Еңбекке уақытша жарамсыздық парағы',
		leave_type_code_label: 'Код: әлеуметтік демалыс түрі',
		leave_type_name_label: 'Әлеуметтік демалыс түрінің атауы',
		begin_date_label: 'Бастап жұмыс істемеді',
		end_date_label: 'Дейін жұмыс істемеді',
		days_off_label: 'Демалыс күндерінің санын көрсетіңіз',
		days_off_placeholder: 'Демалыс күндерінің санын көрсетіңіз',
		sheet_num_label: 'Табель нөмірі',
		sheet_num_placeholder: 'Табель нөмірін көрсетіңіз',
		department: 'Бөлімшенің атауы',
		department_ru: 'Бөлімшенің атауы (рус)',
		department_kz: 'Бөлімшенің атауы (Қаз)',
		department_placeholder: 'Бөлімшенің атауын көрсетіңіз',
		first_date_label: 'Бірінші жұмыс күні мерзімі',
		fact_work_date_label: 'Жұмысқа нақты шыққан күні',
		fact_work_date_hint:
			'Қызметкердің әлеуметтік демалыстан мерзімінен бұрын шыққан күні (демалыстың жаңа аяқталу күні)',
		entryDate: 'ЕШЕБЖ тіркелген күні',
		close: 'Әлеуметтік демалысты жабу',
		delete_title: 'Әлеуметтік демалыс сіздің кабинетіңізден жойылады',
		delete_confirm:
			'Сіз {{entryDate}} басталған № {{contractNumber}} шарттың № {{leaveNumber}} әлеуметтік демалысын қалпына келтіру мүмкіндігінсіз жойғыңыз келетініне сенімдісіз бе?',
		no_data: {
			type_001: 'Қазақстан Республикасы Ішкі істер министрлігінің жүйесінде деректер жоқ',
			type_002: 'Қазақстан Республикасы Ғылым және жоғары білім министрлігінің жүйесінде деректер жоқ',
			type_004: 'Қазақстан Республикасы Денсаулық сақтау министрлігінің жүйесінде деректер жоқ',
			type_005: 'Қазақстан Республикасы Денсаулық сақтау министрлігінің жүйесінде деректер жоқ',
			type_006: 'Қазақстан Республикасы Денсаулық сақтау министрлігінің жүйесінде деректер жоқ',
			type_007: 'Қазақстан Республикасы Еңбек және халықты әлеуметтік қорғау министрлігінің жүйесінде деректер жоқ',
			type_009: 'Қазақстан Республикасы Денсаулық сақтау министрлігінің жүйесінде деректер жоқ',
			type_010: 'Қазақстан Республикасы Ішкі істер министрлігінің жүйесінде деректер жоқ',
			type_014: 'Қазақстан Республикасы Еңбек және халықты әлеуметтік қорғау министрлігінің жүйесінде деректер жоқ',
			type_016:
				'Қазақстан Республикасы Бас прокуратурасының Құқықтық статистика және арнайы есепке алу Комитетінің жүйесінде деректер жоқ',
			review_empty: 'Пікірлер бойынша мәліметтер жоқ',
		},
	},
	signed_status: 'Қол қойылған',
	pending_sign: 'Қолтаңбаны күтуде',
	sign_and_terminate: 'ЭЦҚ-мен қол қою және бұзу',
	update_iin: 'Қызметкердің ЖСН өзектендіруі (азаматтығы өзгерген жағдайда)',
	enter_12_digits: '12 санды енгізіңіз',
	new_epmloyee_iin: 'Қызметкердің жаңа ЖСН',
	auto_filled: 'Автоматты түрде толтырылады',
	employee_fio: 'Қызметкердің аты-жөні',
	enter_number: 'Нөмірді енгізіңіз',
	enter_fio: 'ТАЖ енгізіңіз',
	enter_position: 'Лауазымын енгізіңіз',
	actions: {
		view: 'Қарау',
		edit: 'Өңдеу',
		browsing: 'Қарау',
		createAdditionalAgreement: 'Қосымша келісімшарт құру',
		createSocialLeave: 'Әлеуметтік демалыс қосу',
		terminate: 'Бұзу',
		remove: 'Жою',
		sign: 'Қол қою',
		recover: 'Қалпына келтіру',
		revoke: 'Қайтарып алу',
		prolongation: 'Ұзарту',
		edit_termination: 'Тоқтатуды түзету',
		reject: 'Бас тарту',
		sendEmployee: 'қызметкерге жіберу',
		sendEmployer: 'Жұмыс берушіге жіберу',
		decline: 'Бас тарту',
		create: 'Еншілес қосу',
		appoint: 'Лауазымға тағайындау',
		approve: 'Растау',
		exclude: 'Алып тастау',
		join: 'Кіру',
		excludeFromTradeUnions: 'Кәсіподақтан шығу',
		addWorkplace: 'Жумыс орындарын қосу',
	},
	hint_position_knz:
		'Ұлттық кәсіптер жіктеуішіне негізделген анықтамалықтан қол жетімді лауазымдардың нұсқаларын алу үшін лауазымның алғашқы 3 әрпін енгізуді бастаңыз',
	hint_position:
		'Лауазымыңыздың атауын толтырыңыз немесе анықтамалықтан таңдаңыз (медициналық-әлеуметтік мекемелер үшін)',
	hint_working_condition: 'Еңбек жағдайлары анықтамалығынан таңдаңыз',
	hint_tarrif: 'Тек толық емес жұмыс уақыты үшін. 0-ден 1-ге дейінгі мәнді енгізіңіз (мысалы, 0.5, 0.7 және т. б.)',
	session_expired: 'Сессия устарела, необходимо авторизоваться заново',
	delete_sign: 'Верификацияны жою',
	attention: 'Назар аударыңыз!',
	delete_sign_title:
		'Қызметкер есептік жазбадан шығарылады. Қайта тексеруді ЭЦҚ, QR немесе СМС-растау көмегімен жүргізуге болады.',
	employeeProfile: {
		transfer: 'Ауыстыру',
		moveToConfirm: 'Ағымдағы пайдаланушыға ауысу үшін ұйымды өзіне ауыстыруды пайдалану қажет',
		alreadyRegisteredOnMe: 'Бұл кәсіпорын Cіздің жеке кабинетіңізде тіркелген',
		alreadyRegisteredOnPortal: {
			title: 'Бұл кәсіпорын порталда тіркелген!',
			description:
				'Кәсіпорын порталда тіркелген. Сіз ЭЦҚ пайдалана отырып, осы кәсіпорынды enbek.kz порталдағы жеке кабинетіңізге ауыстыра аласыз. Ауыстырғаннан кейін, кәсіпорындар тізімін жаңарту қажет болады',
			action: 'Ауыстыру үшін enbek.kz өту',
		},
	},
	errors: {
		required: 'Бұл өріс міндетті болып табылады',
	},
	date_from_hint_tooltip: 'Жұмыстың басталу күні рұқсаттың қолданылу кезеңінде болуы тиіс',
	date_to_hint_tooltip: 'Шарттың қолданылу мерзімі рұқсаттың қолданылу кезеңінде болуы тиіс',

	electronic_contract: {
		register_date_hint:
			'Необходимо указать предполагаемую дату подписания договора работодателем (дата не должна быть позднее 14 календарных дней от текущей даты)',
		date_from_hint:
			'Необходимо указать предполагаемую дату подписания ЭТД работодателем (дата не должна быть раньше даты подписания договора)',
		contract_text_title: 'Келісімшарт мәтіні',
		create_project_from_template: 'Шаблоннан ЭЕШ жобасын жасау',
		attach_file: 'ЭЕШ жобасының файлын енгізу',
		status_sign_eec: 'ЭЕШ қолтаңбасының мәртебесі',
		options: {
			employerType: 'Жұмыс беруші',
			0.1: 'Заңды тұлға',
			0.2: 'Жеке кәсіпкер (ЖК)',
			0.3: 'Физическое лицо',
			employeeType: 'Работник',
			14.1: 'ҚР резиденті',
			14.2: 'ҚР резиденті емес',
			14.3: 'ҚР резиденті емес (еңбек иммигранты)',
			14.4: 'Кәмелетке толмаған',
			language: 'Электрондық еңбек шартының тілі',
			1.1: 'Қазақ тілі',
			1.2: 'Орыс тілі',
			1.3: 'Екі тілді',
			jobType: 'Еңбек шарты бойынша жұмыс – бұл',
			2.1: 'Негізгі (негізгі жұмыс орны)',
			2.2: 'Қоса атқарылатын жұмыс',
			workCondition: 'Еңбек шарты бойынша жұмыс келесіге жатады',
			3.1: 'Қалыпты еңбек жағдайларына',
			3.2: 'Ауыр және/немесе зиянды және/немесе қауіпті еңбек жағдайларында орындалған',
			workBeginning: 'Жұмыстың басталуы',
			4.1: 'Тараптар еңбек шартына қол қойған күннен бастап',
			4.2: 'Еңбек шартында көрсетілген күннен бастап',
			term: 'Еңбек шартының мерзімі',
			5.1: 'Белгіленбеген мерзімге',
			5.2: 'Бір жылдан кем емес белгілі бір мерзімге',
			5.3: 'Белгілі мерзімге (шағын кәсіпкерлік субъектілерге)',
			5.4: 'Белгілі бір жұмыстың орындалу уақытына',
			5.5: 'Уақытша болмаған жұмыскерді алмастыру уақытына',
			5.6: 'Маусымдық жұмысты орындау уақытына',
			5.7: 'Шетелдік жұмыскерлердің еңбек қызметін жүзеге асыру уақытына',
			5.9: 'Еңбек иммигранты еңбек қызметін жүзеге асыру уақытына',
			probitionary: 'Сынақ мерзімі туралы талап еңбек шартында айқындалады',
			6.1: 'Иә',
			6.2: 'Иә, бұл ретте қызметкер ұйым басшысы немесе оның орынбасары, бас есепші немесе оның орынбасары, ұйым филиалдарының, өкілдігінің басшысы лауазымына қабылданады',
			6.3: 'Иә, бірақ сынақ мерзімі көрсетілмейді',
			6.4: 'Жоқ',
			workingTime: 'Қызметкерге жұмыс уақыты белгіленеді',
			7.1: 'Екі демалыс күнімен бес күндік (қырық сағаттық) жұмыс аптасы',
			7.2: 'Ауысымдық',
			7.3: '16-18 жас аралығындағы адамдар үшін: бес күндік жұмыс аптасы (36 сағаттық жұмыс уақыты, екі демалыс күні).',
			7.4: '16 жасқа дейінгі адамдар үшін: бес күндік жұмыс аптасы (24 сағаттық жұмыс уақыты, екі демалыс күні).',
			salary: 'Еңбекақы',
			8.1: 'Белгіленген мөлшер (лауазымдық жалақы)',
			8.2: 'Сағаттық мөлшерлеме',
			bonus: 'Ынталандырушы төлемдер (сыйлықақылар, бонустар ж',
			9.1: 'Иә (толығырақ)',
			9.2: 'Иә (қысқаша)',
			9.3: 'Жоқ',
			mandatory: 'Міндетті ұстап қалу',
			10.1: 'Міндетті ұстап қалғанға дейін',
			10.2: 'Міндетті ұстап қалудан кейін',
			downtime: 'Жұмыстың тоқтап қалуына ақы төлеу туралы ақпарат',
			11.1: 'Иә - (Бос тұрып қалу төлемі)',
			overtime: 'Үстеме, түнгі уақыттағы, мереке және демалыс күндеріндегі жұмысқа ақы төлеу туралы ақпарат',
			12.1: 'Иә - (Үстеме ақы төлеу)',
			paymentMethod: 'Төлем тәсілі',
			13.1: 'Қолма-қол ақшасыз төлем',
			13.2: 'Қолма-қол ақшамен',
			employeeRights: 'Еркін өріс. Қызметкердің қосымша құқықтары',
			34: 'Иә (Қызметкердің қосымша құқықтары)',
			employeeResp: 'Еркін өріс. Қызметкердің қосымша құқықтары',
			35: 'Иә (Қызметкердің қосымша құқықтары)',
			employerRights: 'Еркін өріс. Қызметкердің қосымша құқықтары',
			36: 'Иә (Қызметкердің қосымша құқықтары)',
			employerResp: 'Еркін өріс. Қызметкердің қосымша құқықтары',
			37: 'Иә (Қызметкердің қосымша құқықтары)',
		},
		new_template: 'Жаңа үлгі',
		new_template_select_options: 'Электрондық еңбек шартының нұсқаларын таңдау',
		open_contract_project: 'Шарт жобасын ашу',
		open_add_contract_project: 'Қосымша келісімшарт жобасын ашу',
		employee_rights_placeholder: 'Осы өрісте жұмыскердің қосымша құқықтарын көрсетіңіз',
		employee_works_placeholder: 'Осы өрісте жұмыскердің қосымша міндеттерін көрсетіңіз',
		employer_rights_placeholder: 'Осы өрісте жұмыс берушінің қосымша құқықтарын көрсетіңіз',
		employer_works_placeholder: 'Осы өрісте жұмыс берушінің қосымша міндеттерін көрсетіңіз',
		open_contract_project_title: 'Электрондық еңбек шартының жобасы',
		created: 'создан',
		sure_delete_template: 'Вы действительно хотите удалить шаблон?',
		resert_values: 'Енгізілген өзгертулерді қалпына келтіру',
		role: 'Рөлі',
		parties_requisites: 'Тараптардың деректемелері',
		name_fio: 'Атауы, Толық аты',
		sign_date: 'Қол қою күні',
		reset: 'Қалпына келтіру',
		reset_question: 'Сіз расымен барлық өзгерістерді қалпына келтіргіңіз келе ме?',
		project: 'Қолданыстағы ЭЕШ өзгерістер енгізу жобасы',
		terminate: 'Сіз электронды еңбек шартын бұзасыз! Қол қойылғаннан кейін сіздің келісімшартыңыз бұзылады.',
		status_sign_eds: 'ЭҚК қолтаңба мәртебесі',
	},
	personal_affairs: {
		medical_card: 'Жеке медициналық кітапша',
		worker: 'Қызметкерлер',
		title: 'Жеке істер',
		requests_title: 'Жеке істерге сұрау салу',
		request_electronic_affair: 'Электрондық жеке істі сұрау',
		checking_social_payments: 'Қызметкердің әлеум.төлем бойынша арнайы құқығын тексеріңіз',
		title_checking_social_payments: 'Арнайы әлеуметтік төлемдер бойынша құқықты тексеру',
		accepted_payments: 'Арнайы әлеуметтік төлем алуға құқығы бар',
		not_accepted_payments: 'Арнайы әлеуметтік төлем алуға құқығы жоқ',
		empty_status: 'Сұрауды тек сіздің жұмысшыларыңыз бойынша жіберуге болады',
		status: 'Мәртебесі: ',
		request_proactive: 'ПРОАКТИВКЕ ӨТІНІМДЕР',
		search_placeholder: 'Қызметкердің ЖСН немесе тегін енгізіңіз',
		total_count: 'Барлық істер',
		total_count_request: 'Барлық сұраулар',
		table: {
			certificate_count: 'Анықтамалар саны',
			watch_action: 'Жеке істі қарау',
			field_number: '№',
			employer_name: 'Жұмыс берушінің атауы',
			iin: 'Қызметкердің ЖСН',
			employee_fio: 'Қызметкердің аты-жөні',
			request_date: 'Сұрау салу күні',
			consent_date: 'Қызметкердің ЭЦҚ-мен қол қойған күні',
			request_status: 'Сұрау мәртебесі',
		},
		born_place: 'Туған жері',
		documents: 'Жеке басты куәландыратын құжаттар',
		address_full_registration: 'Тұрақты тіркелген мекен-жайы',
		document_name: 'Құжаттың атауы',
		ou_name: 'ББМ атауы',
		receipt_date: 'Түскен күні',
		certificate_issue_date: 'Аттестаттың берілген күні',
		certificate_number: 'Аттестат нөмірі',
		certificate_series: 'Аттестат сериясы',
		diploma_number: 'Диплом сериясы',
		course: 'Курс',
		language: 'Тілі',
		release: 'Шығару',
		class: 'Класс',
		education_form: 'Оқыту түрі',
		diploma_type: 'Диплом түрі',
		education_category: 'Білім беру санаты',
		tipo_cause: 'ТКБ кету себебі',
		vuz_cause: 'ЖОО кету себебі',
		spec_tipo_1: 'ТКБ мамандығы және сыныптауышы (негізгі)  ТКБ',
		spec_tipo_2: '2- ТКБ мамандығы және сыныптауышы',
		spec_tipo_3: '3- ТКБ мамандығы және сыныптауышы',
		spec_vuz_1: '1- ЖОО мамандығы және сыныптауышы (негізгі)',
		spec_vuz_2: '2 - ЖОО Мамандығы және сыныптауышы',
		spec_vuz_3: '3 - ЖОО Мамандығы және сыныптауышы',
		end_date: 'Аяқталу мерзімі',
		nkz_position: 'ҰҚЖ лауазымы',
		med_organization_address: 'Медициналық мекеменің атауы',
		work_education_address: 'Балалар мекемесінің/оқу/жұмыс орны',
		last_examination: 'Соңғы медициналық тексеру күні',
		last_examination_diseases: 'Соңғы медициналық тексеруден кейін анықталған аурулар атауы',
		doctor_fio: 'Дәрігердің аты-жөні',
		therap_conclusion: 'Терапевт қорытындысы',
		therap_fio: 'Терапевттің аты-жөні',
		date: 'Күні',
		name_code: 'Атауы коды',
		narco_conclusion: 'Наркологтың қорытындысы',
		narco_fio: 'Наркологтың аты-жөні',
		narco_date: 'Наркологқа жүгінген күні',
		liquid_examination: 'Психобелсенді заттардың болуына сұйық биологиялық ортаны зерттеу',
		psycho_conclusion: 'Психиатрдың қорытындысы',
		x_ray_data: 'Рентгенологиялық тексеру деректері',
		doctor_conclusion: 'Шарттары көрсетілген кәсіби жарамдылығы туралы дәрігерлік қорытынды',
		lab_data: 'Зертханалық зерттеулердің деректері',
		filling_fio: 'Анықтаманы толтырған адамның аты-жөні',
		head_fio: 'Медициналық ұйым басшысының аты-жөні',
		sign_date: 'Қол қою күні',
		error: 'Қате',
		go_to_personal_affair: 'Жеке іске өту',
		requested_information: 'Сұратылған анықтамалар',

		no_data: 'Сізде жеке істер жоқ',
		has_error: 'Қате пайда болды, кейінірек қайталап көріңіз!',
		request: {
			title: '«Жеке тұлғалар» мемлекеттік деректер қоры',
			form: {
				choose_data_label: 'Қажетті деректерді таңдаңыз',
				id_label: 'Жеке басын куәландыратын құжат',
				photo_label: 'Жеке басын куәландыратын құжаттағы фото',
				education_label: 'Білімі туралы құжат',
				employment_label: 'Еңбек кітапшасы',
				medicine_label: 'Медициналық анықтама 075/у',
				medicine_drug_label: 'Псих/нарко/туб ұйымдарында есепке алу',
				status_candas: 'Қандас куәлігі',
				committing_corruption_crime: 'Сыбайлас жемқорлық қылмыс жасаған туралы мәліметтер',
				military_service: 'Әскери қызмет өткені туралы мәліметтер',
				reviews: 'Қызметкер туралы пікірлер (жұмыс берушілерден қалған пікірлер)',
				action: 'Туберкулезге қарсы ұйымда есепке алу',
			},
		},
		card: {
			title: 'Жеке мәліметтер',
			info: {
				gender: 'Жынысы',
				birthday: 'Туған күні',
				nationality: 'Ұлты',
				citizenship: 'Азаматтығы',
				label: 'Жеке іс',
			},
			table: {
				title: 'Алынған анықтамалар',
				headers: {
					name: 'Анықтаманың атауы',
					request_data: 'Сұрау салу күні',
					sign_data: 'Қол қойылған күні',
					result: 'Нәтижесі',
					download: 'Жүктеу',
				},
			},
		},
		terminal_date: 'Тоқтату/бұзу күні: ',
		termination_reason: 'Тоқтату/бұзу негізі: ',
		loading_status: 'Ожидается проверка на право получения выплаты',
	},
	employee_affairs: {
		tabs: {
			first: {
				title: 'Жеке іс',
				action: 'Жеке іс ашу',
			},
			second: {
				title: 'ЖЕКЕ ІСКЕ СҰРАУ САЛУЛАР',
				action: 'Электрондық жеке істі сұрау',
			},
		},
	},
	qandas: {
		place_of_birth: 'Туған жері',
		assignment_date: 'Мәртебе берілген күн',
		expiration_date: 'Мәртебенің жарамдылық мерзімі',
		name_of_mio: 'Жергілікті органның атауы',
	},
	military: {
		local_authority: 'Жергілікті органның атауы',
		status: 'Мәртебе',
		comment: 'Пікір',
		code_movu: 'Жергілікті органның коды',
		rank: 'Әскери қызметші атағы',
		rank_code: 'Әскери қызметші атағының коды',
		is_assigned_bin: 'Заңды тұлға',
		booking_number_bin: 'Заңды тұлғаның бронь нөмірі',
		specialty: 'Әскери есеп мамандығы',
		specialty_code: 'Әскери есептік мамандық коды',
		period: 'Әскери қызмет өткеру кезеңі',
		begin: 'Басы',
		end: 'Соңы',
	},
	corruption: {
		type: {
			unjudged: 'Сыбайлас жемқорлық қылмыстары анықталған жоқ',
			judged: 'Сыбайлас жемқорлық қылмыс анықталды',
			uncertain: 'Сот шешімімен анықталмаған сыбайлас жемқорлық қылмыс анықталды ',
		},
		more_info_uncertain: 'Дополнительная информация о совершении коррупционного преступления', // translate
		answer_code: 'Код промежуточного ответа', // translate
		cause: 'Себебі', // translate
		more_info_judged: 'Дополнительная информация о совершении коррупционного преступления', // translate
		as_an_accused:
			'По сведениям на осужденного, привлеченного в качестве обвиняемого, арестованного, тип, описывающий одну запись', // translate
		number: 'Нөмір', // translate
		article_attraction: 'Тарту бабы',
		court: 'Сот',
		court_date: 'Сот күні',
		article_of_condemnation: 'Айыптау бабы',
		main_penalties: 'Негізгі жазалау шаралары',
		final_sentence: 'Үкім бойынша жазаның соңғы мерзімі ',
		additional_penalties: 'Қосымша жазалау шаралары',
		guilty_verdict: 'Айыптау үкімі',
		corruption_crime: 'Сыбайлас жемқорлық қылмысы',
		mode_type: 'Режим түрі',
		conditional_punishment: 'Шартты жазаны қолдану',
		trial_period: 'Сынақ мерзіміне',
		deferred_execution: 'Жазаны орындауды кейінге қалдыруды қолдану',
		grace_period: 'Кейінге қалдыру мерзімі',
		medical_nature: 'Медициналық сипаттағы мәжбүрлеу шараларын қолдану',
		medical_measures: 'Медициналық сипаттағы мәжбүрлеу шараларының түрі',
		date_of_judgment: 'Үкімнің енгізілген күні',
		date_of_sentencing: 'Жаза мерзімін есептеу күні',
		formal_conviction: 'Соттылықты өтеудің ресми мерзімі',
		criminal_case1: 'Қылмыстық істі тоқтатудың негізі',
		criminal_case2: 'Қылмыстық істі тоқтатудың негізі',
		organ: 'Қылмыстық істі тоқтатқан орган',
		termination_by_amnesties: 'Рақымшылықты тоқтату',
		exonerating_grounds: 'Оңалту негіздері бойынша тоқтату',
		force_of_the_judgment: 'Үкімнің заңды күшіне енген күні',
		instance: 'Инстанция',
		court_body: 'Сот органы',
		judgment_date: 'Сот шешімі шығарылған күн',
		decision: 'Қабылданған шешім',
		condemnation_decriminalized: 'Айыптау бабы қылмыссыздандырылды',
		criminal_record: 'Соттылықты алу, өтеу',
		date_of_removal: 'Соттылықты алу, өтеу күні',
		court_body2: 'Сот органы',
		release_data: 'Босату туралы мәліметтер',
		date_release: 'Босату күні',
		reason_for_release: 'Босату себебі',
		court_body3: 'Сот органы',
		court_order: 'Сот қаулысының Шығарылған күні',
		person_released: 'Адам сынақ мерзіміне шартты түрде босатылады',
		order_on_parole: 'ШТМБ туралы сот қаулысының шығарылған күні',
		released_on_parole: 'ШТМБ кім босатты',
		actual_release: 'Шартты түрде мерзімінен бұрын нақты босатылған күні',
		release_period: 'Срок освобождения', // translate
		deregistration_date: 'Есептен шығарылған күні',
		additional_marks: 'Қосымша белгілер',
		organ2: 'Орган',
		preventive_measure: 'Бұлтартпау шарасы',
		date_of_arrest: 'Қамауға алу күні',
		criminal_case: 'Қылмыстық істің нөмірі',
		initiation_criminal: 'Қылмыстық іс қозғалған күн',
		archiving_number: 'Мұрағат ісінің нөмірі',
		fingerprint_formula: 'Дактилоскопиялық формула',
		article_attraction2: 'Тарту бабы',
		nature_crime: 'Қылмыстың сипаты',
		about_the_previous: 'Алдыңғы үкім туралы ақпарат',
		relapse: 'Қайталану',
		movement_convict: 'Сотталғанның қозғалысы туралы деректер',

		convicted_persons: 'По арестованным задержании и осужденным лицам', // translate
		number2: 'Нөмір', // translate
		criminal_case_number: 'Қылмыстық істің нөмірі',
		date_sentencing: 'Үкім шығарылған күні',
		condemned_the_person: 'Адамды соттаған Орган',
		article_condemnation: 'Айыптау бабы',
		term: 'Мерзімі',
		additional_marks2: 'Қосымша белгілер',
		entry_into_force: 'Үкімнің заңды күшіне енуі',
		fingerprint_formula2: 'Дактилоскопиялық формула',
		engagement_date: 'Тарту күні',
		organ3: 'Орган',
		preventive_measure2: 'Бұлтартпау шарасы',
		criminal_code: 'ҚК бабы',
		other_marks: 'Басқа белгілер',
		additional_penalties2: 'Жазалау шараларын қолдану',
	},
	package_loading: {
		error_text:
			'Имеется(ются) ошибка(и) при подписании документов. Чтобы увидеть текст ошибки, необходимо открыть карточку договора',
		warning_text: 'Қол қойылмаған құжаттар бар',
		contract_error_text: ' Не зарегистрован по причине: {{errorText}} (Код ошибки: {{errorNumber}})',
		warning_text_additional:
			'Қосымша келісімге қол қою кезінде қате бар. Қате мәтінін көру үшін қосымша келісім картасын ашу керек.',
		warning_text_leave:
			'Имеется ошибка при подписании соц.отпуска. Чтобы увидеть текст ошибки, необходимо открыть карточку соц.отпуска',
	},
	edit_contract: '{{registerDate}} жылғы №{{contractNumber}} еңбек шартын өңдеу',
	contract_id: 'Шарттың ID-і',
	terms_page: {
		terms_title: 'Еңбек ресурстары порталын пайдалану туралы пайдаланушы келісімі',
		title_1: '1. ЖАЛПЫ ЕРЕЖЕЛЕР',
		chapter_chapter_1:
			'1.1. Осы Еңбек ресурстары порталын пайдалану туралы Пайдаланушы келісімі (бұдан әрі – Келісім) еңбек ресурстары порталында (',
		chapter_chapter_2: ') тіркелген жеке немесе заңды тұлғалардың Еңбек ресурстары порталын (',
		chapter_chapter_3: ') пайдалану жөніндегі қатынастарды реттейді.',
		chapter_2: '1.2. Осы Келісімде мынадай ұғымдар пайдаланылады:',
		chapter_3:
			'1) Еңбек ресурстары порталы (бұдан әрі – Портал) – www.hr.enbek.kz домендік атауында орналасқан жүйе, еңбек шарттарын есепке алуды, мемлекеттік органдар мен жұмыс берушілердің өзара іс-қимылын автоматтандыруға арналған.',
		chapter_4: '2) Пайдаланушы –осы Келісімнің шарттарын қабылдаған жеке немесе заңды тұлға.',
		chapter_5:
			'3) Портал әкімшісі (бұдан әрі – Әкімші) – порталды сүйемелдеуді және жүйелік-техникалық қызмет көрсетуді жүзеге асыратын «Еңбек ресурстарын дамыту орталығы» акционерлік қоғамының қызметкерлері;',
		chapter_6:
			'4) Есепке алу жазбасы (аккаунт) - бағдарламалық қамтылымда және (немесе) Портал жүйесінде сақталатын, Пайдаланушыға қолжетімділікті ұсыну мақсатында оны сәйкестендіру үшін қажетті мәліметтерді қамтитын деректер жиынтығы. Есептік жазбаны Пайдаланушы Порталға тіркелген кезде Портал Әкімшісі жасайды;',
		chapter_7: '5) Портал меншік иесі – «Еңбек ресурстарын дамыту орталығы» акционерлік қоғамы;',
		chapter_8:
			'6) Порталда жұмыс істеу жөніндегі Нұсқаулық - Порталда орындау немесе жүзеге асыру тәртібі мен тәсілін белгілейтін қағидаларды, нұсқауларды немесе нұсқаулықтарды қамтитын құжат.',
		title_2: '2. КЕЛІСІМНІҢ МӘНІ',
		chapter_9:
			'2.1. Осы Келісімнің мәні Пайдаланушыға Порталда бар ақпаратқа қол жеткізуді ұсыну және Порталдың мынадай қызметтері мен сервистерін көрсету бойынша өзара қарым - қатынастарды реттеу болып табылады:',
		chapter_10: '1) электрондық еңбек шартын жасасу;',
		chapter_11: '2) еңбек шарттарын тіркеу;',
		chapter_12: '3) еңбек консультанты;',
		chapter_13: '4) жеке істі қалыптастыру;',
		chapter_14: '5) анықтамалық ақпарат.',
		chapter_15:
			'2.2. Осы Келісім Қазақстан Республикасы Азаматтық Кодексінің 395-бабының 5-тармағына сәйкес жария оферта-шарт (ұсыныс) болып табылады және Порталды пайдалану кезінде туындайтын қатынастарды реттейді.',
		chapter_16:
			'2.3. Әкімші Пайдаланушыға ескертусіз осы Келісімнің тармақтарын кез келген уақытта өзгерту, қосу немесе жою құқығын өзіне қалдырады.',
		chapter_17: 'Осы Келісімнің жаңа редакциясы оның порталда жарияланған сәтінен бастап күшіне енеді.',
		chapter_18:
			'2.4. Пайдаланушы осы Келісімнің барлық шарттарымен толық көлемде, ешқандай ескертпелерсіз және ерекшеліктерсіз келісетінін және олардың мәнін, сондай-ақ осы шарттарды бұзудың ықтимал салдарын толық көлемде түсінетінін растайды және осы Келісімді қабылдайды. Осы Келісімнің шарттарын қабылдай отырып, Пайдаланушы осы Келісімнің шарттарын орындауға міндеттенеді.',
		chapter_19:
			'2.5. Осы Келісім Пайдаланушы Порталда тіркеу рәсімінен өту арқылы оның шарттарын (акцепт) қабылдаған сәттен бастап күшіне енеді, бұл Қазақстан Республикасы Азаматтық кодексінің 396-бабы 3-тармағының мағынасы бойынша Әкімші офертасын қабылдау (акцепт) болып табылады.',
		chapter_20: 'Осы Келісім белгіленбеген мерзімге қолданылады.',
		chapter_21:
			'2.6. Осы Келісімнің шарттарын қабылдай отырып, Пайдаланушы осы Келісімнің шарттарын іске асыру мақсаттары үшін ғана өзінің дербес деректерін жинауға, өңдеуге және сақтауға келісім береді.',
		chapter_22:
			'2.7. Порталдың материалдары мен сервистерін пайдалану Қазақстан Республикасының қолданыстағы заңнамасының нормаларымен реттеледі.',
		title_3: '3. ТАРАПТАРДЫҢ ҚҰҚЫҚТАРЫ МЕН МІНДЕТТЕРІ',
		chapter_23: '3.1. Пайдаланушы құқылы:',
		chapter_24: '3.1.1. осы Келісімнің шарттары сақталған жағдайда Порталды пайдалануға рұқсат алу;',
		chapter_25: '3.1.2. осы Келісімнің 2-бөлімінің 2.1-тармағында сипатталған қызметтерді алу үшін Порталды пайдалану;',
		chapter_26: '3.1.3. Есептік жазбаны пайдалануды тоқтату және осы Келісімді бұзу;',
		chapter_27: '3.1.4. Есептік жазбаға кіру үшін логин және (немесе) құпия сөзді өзгерту;',
		chapter_28:
			'3.1.5. Қазақстан Республикасының заңнамасымен тыйым салынбаған өзге де құқықтарды жүзеге асыруға құқылы.',
		chapter_29: '3.2. Пайдаланушы міндеттенеді:',
		chapter_30:
			'3.2.1. Әкімшіге Порталда тіркелу нысанында ұсынылатын тармақтар бойынша дұрыс, дәл және толық ақпарат беру. Әкімшінің Пайдаланушы ұсынған ақпараттың дұрыс еместігі туралы кез келген күмәні Пайдаланушының тіркеуінен бас тартуға, уақытша бұғаттауға және (немесе) есептік жазбасын жоюға әкеп соғады;',
		chapter_31: '3.2.2. өзіңізді басқа жеке немесе заңды тұлға ретінде көрсетпеу;',
		chapter_32:
			'3.2.3. Есептік жазбаға кіру үшін пайдаланылатын бірегей логин мен құпия сөзді құпия сақтау. Есепке алу жазбасының логині мен құпия сөзі құпия ақпарат болып табылады және Қазақстан Республикасының қолданыстағы заңнамасында көзделген жағдайларды қоспағанда, жария етуге жатпайды. Пайдаланушының өз есептік жазбасының құпия сөзі мен логинін жоғалтуына байланысты кез келген тәуекелдерді Пайдаланушы өз бетінше көтереді;',
		chapter_33:
			'3.2.4. осы Келісімнің 2-бөлімінің 2.3-тармағына сәйкес Порталда енгізілген өзгерістермен танысу мақсатында осы Келісімнің мазмұнымен кезең-кезеңімен танысу;',
		chapter_34: '3.2.5.  Порталда келесіні орналастыру мүмкін емес:',
		chapter_36:
			'1) Пайдаланушы заң бойынша немесе қандай да бір шарттық қатынастарға сәйкес жария етуге құқығы жоқ ақпарат;',
		chapter_37:
			'2) қолданыстағы заңнаманы, үшінші тұлғалардың ар-намысы мен қадір-қасиетін, құқықтары мен заңмен қорғалатын мүдделерін бұзатын ақпарат;',
		chapter_38:
			'3) қорлайтын мазмұндағы, сондай-ақ адамдарды қандай да бір белгісі бойынша кемсітуді, зорлық-зомбылықты, жеккөрушілікті насихаттайтын ақпарат;',
		chapter_39:
			'3.2.6. осы Келісімде және еңбек шарттарын есепке алудың бірыңғай жүйесінде еңбек шарты туралы мәліметтерді беру мен алудың бекітілген Қағидаларында (бұдан әрі – Қағидалар) көзделген өзге де талаптарды сақтауға және өзге де міндеттемелерді орындауға міндетті.',
		chapter_40: '3.2.7. Портал сервистерін келесі мақсаттарда пайдаланбау:',
		chapter_41:
			'3.2.7.1. заңсыз болып табылатын контентті жүктеу үшінші тұлғалардың кез келген құқықтарын бұзу; нәсілдік, ұлттық, жыныстық, діни, әлеуметтік белгілері бойынша зорлық-зомбылықты, қатыгездікті, өшпенділікті және (немесе) кемсітуді насихаттау; нақты адамдардың, ұйымдардың, билік органдарының атына анық емес мәліметтерді және (немесе) қорлауды қамтитын ақпараттарды пайдаланбау;',
		chapter_42:
			'3.2.7.2. құқыққа қарсы әрекеттер жасауға итермелеу, сондай-ақ әрекеттері Қазақстан Республикасының аумағында қолданылатын шектеулер мен тыйым салуларды бұзуға бағытталған адамдарға жәрдемдесу;',
		chapter_43:
			'3.2.7.3. кәмелетке толмаған адамдардың құқықтарын бұзу және (немесе) оларға кез келген нысанда зиян келтіру;',
		chapter_44:
			'3.2.7.4. өзін басқа адам ретінде немесе оған жеткілікті құқықсыз ұйымның және (немесе) қоғамдастықтың өкілі ретінде, оның ішінде өзін Портал қызметкерлері ретінде ұсыну;',
		chapter_45: '3.2.7.5. Порталда орналастырылған ақпарат пен деректерге қатысты саналы түрде жаңылыстыруға бұрмалау.',
		chapter_46: '3.3. Пайдаланушыға тыйым салынады:',
		chapter_47:
			'3.3.1. портал мазмұнына қол жеткізу, сатып алу, көшіру немесе қадағалау үшін кез келген құрылғыларды, бағдарламаларды, процедураларды, алгоритмдер мен әдістерді, автоматты құрылғыларды немесе баламалы қол процестерін пайдалану;',
		chapter_48: '3.3.2. Порталдың дұрыс жұмыс істеуін бұзу;',
		chapter_49:
			'3.3.3. осы Портал сервистері арнайы ұсынбаған кез келген құралдармен кез келген ақпаратты, құжаттарды немесе материалдарды алу немесе алуға әрекет жасау үшін Порталдың навигациялық құрылымын кез келген тәсілмен айналып өту;',
		chapter_50:
			'3.3.4. Портал функцияларына, Порталға қатысты кез келген басқа жүйелерге немесе желілерге, сондай-ақ Порталда ұсынылатын кез келген қызметтерге рұқсатсыз қол жеткізу;',
		chapter_51:
			'3.3.5. Порталда немесе Порталға қатысты кез келген желіде қауіпсіздік немесе аутентификация жүйесін бұзу;',
		chapter_52:
			'3.3.6. кері іздеуді орындау, бақылау немесе кез-келген басқа Портал Пайдаланушысы туралы кез-келген ақпаратты бақылауға тырысу;',
		chapter_53:
			'3.3.7. Порталды және оның мазмұнын Қазақстан Республикасының заңнамасымен тыйым салынған кез келген мақсаттарда пайдалануға, сондай-ақ Портал иесінің немесе басқа тұлғалардың құқықтарын бұзатын кез келген заңсыз әрекетке немесе өзге де қызметке шақыруға тыйым салынады.',
		chapter_54: '3.4. Әкімші құқылы:',
		chapter_55:
			'3.4.1. Пайдаланушы осы Келісімнің шарттарын бұзған жағдайда Пайдаланушыға тіркеуден бас тарту, Пайдаланушының есептік жазбасын жою немесе бұғаттау;',
		chapter_56:
			'3.4.2. Қазақстан Республикасының заңнамасында айқындалған тәртіппен Пайдаланушыдан қажетті ақпаратты сұрату және алу;',
		chapter_57: '3.4.3. Пайдаланушы порталда ұсынған ақпараттың дұрыстығын тексеру;',
		chapter_58:
			'3.4.4. кез келген уақытта Порталдың рәсімделуін және пайдаланушылық интерфейсін, оның мазмұнын, ұсынылатын функциялардың мазмұнын өзгерту, Порталда пайдаланылатын немесе сақталатын скрипттерді, бағдарламалық қамтылымды, контентті және басқа объектілерді және кез келген қосымшаларды Пайдаланушыға хабарламай өзгерту немесе толықтыру;',
		chapter_59:
			'3.4.5. Порталдың пайдалану ережелерін өзгерту, сондай-ақ осы Порталдың мазмұнын өзгерту. Өзгерістер Келісімнің жаңа редакциясы Порталда жарияланған сәттен бастап күшіне енеді.',
		title_4: '4. КЕЛІСІМНІҢ КҮШІНЕ ЕНУІ',
		chapter_60: '4.1. Осы Келісім Пайдаланушы Порталда тіркелгеннен кейін күшіне енеді.',
		chapter_61:
			'4.2. Тіркеу Пайдаланушының тіркеу нысанын толтыру, осы Келісімнің барлық шарттарымен келісім білдіру және осы тіркеу нысандарын Порталдағы жұмыс жөніндегі нұсқаулыққа сәйкес Порталға жіберу арқылы жүзеге асырылады.',
		title_5: '5. ЖАУАПКЕРШІЛІК',
		chapter_62:
			'5.1. Порталға кез келген ақпаратты, мәліметтер мен материалдарды орналастыру кезінде Пайдаланушы өзі орналастыратын материалдардың, мәліметтер мен деректердің мазмұнына, Қазақстан Республикасының заңнамасына сәйкес оларды орналастыру мен пайдаланудың заңдылығына дербес жауапты болады.',
		chapter_63:
			'5.2. Пайдаланушы өз құпиясөзінің қауіпсіз сақталуы үшін, сондай-ақ оның жария етілуі кезінде орын алуы мүмкін салдарлар үшін дербес жауапты болады.',
		chapter_64:
			'5.3. Пайдаланушы Порталда міндетті түрде орналастырылуға жататын материалдарды, ақпаратты және Мәліметтерді уақтылы орналастыруға дербес жауапты болады.',
		chapter_65:
			'5.4. Әкімші Пайдаланушы Порталда орналастыратын ақпараттың, мәліметтердің, материалдардың мазмұны, олардың Қазақстан Республикасы заңнамасының талаптарына сәйкестігіне, Пайдаланушының Порталда орналастырылған ақпаратты, мәліметтер мен материалдарды пайдалану жөніндегі заңсыз әрекеттері үшін, Пайдаланушының үшінші тұлғалардың кез келген басқа құқықтарын бұзғаны үшін жауапты болмайды.',
		chapter_66:
			'5.5. Әкімшіге тәуелсіз себептер бойынша немесе Порталға қызмет көрсету бойынша жоспарлы немесе жоспардан тыс іс-шаралар жүргізілген жағдайда туындаған Портал жұмысындағы техникалық уақытша іркілістер мен үзілістер үшін Әкімші жауапты болмайды.',
		chapter_67:
			'5.6. Әкімші уақытша іркілістер мен еңсерілмейтін күш мән-жайлары, оның ішінде электр желілерінің, Интернет желісінің жұмысындағы іркілістер және Әкімшіден тәуелсіз туындаған және осы Келісімнің шарттарын орындауға кедергі келтіретін басқа да мән-жайлар үшін жауапты болмайды.',
		chapter_68:
			'5.7. Әкімші басқа Пайдаланушылардың және (немесе) Порталдың кез келген басқа қатысушыларының әрекеттері үшін Пайдаланушының алдында жауапты болмайды.',
		chapter_69:
			'5.8. Әкімші жоғалған пайданы, пайдаланудан келтірілген залалды, деректердің жоғалуын немесе қандай да бір басқа материалдық емес ысыраптарды, бедел залалын және осының салдарынан туындайтын өзге де залалды қоса алғанда, кез келген тікелей, жанама залал үшін жауапты болмайды:',
		chapter_70: '5.8.1. Порталды пайдалану немесе пайдалану мүмкін еместігі;',
		chapter_71: '5.8.2. осы Келісімнің шарттарын өзгерту;',
		chapter_72:
			'5.8.3. Пайдаланушының деректеріне рұқсатсыз қол жеткізу немесе Пайдаланушы жіберетін немесе серверде сақталатын деректерді өзгерту;',
		chapter_73: '5.8.4. Порталда көрсетілетін қызметтерге қатысы бар кез келген басқа жағдай.',
		title_6: '6. БАСҚА ШАРТТАР',
		chapter_74:
			'6.1. Пайдаланушы Әкімшінің Мемлекеттік және (немесе) мемлекеттік емес ақпараттық жүйелерде (деректер базасында) қамтылған өзі туралы қосымша мәліметтерді алуына және жариялауына қарсылық білдірмейді.',
		chapter_75:
			'6.2. Порталдың техникалық жұмысына қатысты барлық шағымдар, сұраулар, сұрақтар, кез келген өзге хат-хабарлар Порталдың басты бетінде көрсетілген электрондық пошта мекенжайына жіберілуі тиіс.',
		chapter_76:
			'6.3. Пайдаланушының материалдарды, ақпаратты және мәліметтерді орналастыруына және (немесе) пайдалануына байланысты үшінші тұлғалардан наразылықтар келіп түскен жағдайда, Пайдаланушы көрсетілген наразылықтарды дербес және өз есебінен реттейді.',
		chapter_77:
			'6.4. Қағидалардың 13-тармағына сәйкес жұмыс беруші еңбек шарттарын есепке алудың бірыңғай жүйесіне еңбек шартын тоқтату туралы ақпарат енгізгеннен кейін еңбек шарттарын есепке алудың бірыңғай жүйесінде мәліметтерді өзгерту мен толықтыруды Қазақстан Республикасының Әкімшілік рәсімдік-процестік кодексіне сәйкес жұмыс берушінің немесе жұмыскердің өтініші негізінде еңбек жөніндегі уәкілетті мемлекеттік орган жүзеге асырады.',
		title_7: '7. ДАУЛАРДЫ ШЕШУ',
		chapter_78:
			'7.1. Осы Шарттың Тараптары арасында қандай да бір келіспеушіліктер немесе даулар туындаған жағдайда, сотқа жүгінер алдында талап арызды алдын ала ұсыну (дауды ерікті түрде реттеу туралы жазбаша ұсыныс) міндетті шарт болып табылады.',
		chapter_79:
			'7.2. Шағымды алушы оны алған күннен бастап күнтізбелік 15 күн ішінде талап қоюшыға талап арызды қарау нәтижелері туралы жазбаша хабарлайды.',
		chapter_80:
			'7.3. Дауды ерікті түрде шешу мүмкін болмаған жағдайда Тараптардың кез келгені өздеріне Қазақстан Республикасының қолданыстағы заңнамасымен берілген өз құқықтарын қорғау үшін сотқа жүгінуге құқылы.',
		chapter_81:
			'7.4. Порталды пайдалану шарттарына қатысты кез келген талап Қазақстан Республикасы Азаматтық кодексінің нормаларына сәйкес қойылуы тиіс.',
		title_8: '8. ҚОСЫМША ШАРТТАР',
		chapter_82: '8.1. Әкімші Пайдаланушыдан осы Келісімнің өзгерістеріне қатысты қарсы ұсыныстарды қабылдамайды.',
		chapter_83:
			'8.2. Порталда орналастырылған Пайдаланушының пікірлері құпия ақпарат болып табылмайды және Әкімші шектеусіз пайдалана алады.',
	},
	forms: {
		modal: {
			title: 'Сіз жаңа параққа ауысуды растайсыз ба?',
			bodyPart_1: 'Сіз ағымдағы өзін-өзі тексеру парағында барлық сұрақтарға жауап берген жоқсыз.',
			bodyPart_2: 'Өзін-өзі тексерудің басқа парағына ауысқан кезде, ағымдағы парақтағы барлық деректер жоғалады.',
			process_button_title: 'Өту',
			cancel: 'Бас тарту',
		},
	},
	last_update: 'cоңғы жаңарту',
	update_companies_list: 'Кәсіпорындар тізімін жаңарту',
	should_update_companies_list:
		'Жаңа кәсіпорын қосылған жағдайда enbek.kz порталында кәсіпорындар тізімін жаңарту қажет',
	role_select_warning: 'Жұмыс берушінің профиліне өту үшін тіркелгі параметрлерінде поштаны көрсету керек',
	go_to_settings: 'Параметрлерге өту',
	hint_oked_code: 'Таңдау опцияларын алу үшін қызмет түрінің алғашқы 3 әрпін теруді бастаңыз',

	warning_company_title: 'Сіздің профиліңіздегі бір немесе бірнеше кәсіпорындарыңыз порталда тіркелген!',
	warning_company_title_left: 'Кәсіпорын',
	warning_company_title_right: 'Байланыс ақпараты',
	date_error: 'Шартты бұзу күні ағымдағы күннен кеш болмауға тиіс',
	phone_error: 'Көрсетілген телефон нөмірі қазақстандық ұялы байланыс операторларына тиесілі емес!',
	phone_error_equal: 'Сіз "жұмыс телефоны" және "ұялы телефон"өрістерінде бірдей мәндерді көрсеттіңіз!',
	request_employee_ld: 'Қызметкердің жеке ісіне сұрау салу',
	request_id: 'Сұрау ID',
	form_date: 'Қалыптастыру күні',
	employee_data_ld: 'Қызметкер туралы деректер',
	employer_data_ld: 'Жұмыс беруші туралы деректер',
	employer_iin_bin: 'Жұмыс берушінің БСН/ЖСН',
	enter_bin_or_name: 'Кәсіпорынның БСН немесе атауын енгізіңіз',
	ld_requests: 'Жеке іске сұрау салулар',
	ld_medicine_error_1: 'Қазақстан Республикасы денсаулық сақтау',
	ld_medicine_error_2: ' министрлігінің базасында анықтама бойынша деректер жоқ',
	labor_activities_tab: 'ЕҢБЕК ҚЫЗМЕТІ',
	correction_requests_tab: 'ТҮЗЕТУ СҰРАУЛАРЫ',
	unsigned_records_tab: 'ҚОЛ ҚОЙЫЛМАҒАН ЖАЗБАЛАР',
	labor_records: {
		info_no_records: 'Сізде еңбек қызметі туралы жазбалар жоқ.',
		title: 'Электрондық\n' + 'еңбек кітапшасы',
		titlePage: 'Электрондық еңбек кітапшасы',
		add_record: 'Жазба қосу',
		searchInput: 'БСН немесе кәсіпорын атауын енгізіңіз',
		dateFrom: 'Кезеңнен бастап',
		dateTo: 'Дейінгі кезең',
		bin_iin_placeholder: 'БСН/ЖСН енгізіңіз',
		orgName: 'Кәсіпорын атауын енгізіңіз',
		export: 'Жүктеу',
		cancel_text: 'Болдырмау',
		export_text: 'Сіз электронды еңбек кітапшасын жүктегелі отырсыз',
		with_photo: 'фотосуретпен',
		without_photo: 'фотосуретсіз',
		work_experience: 'Жалпы жұмыс өтілі -',
		count_records: 'Қазіргі уақытқа дейінгі еңбек қызметі бойынша жазбалар - ',
		until_now: 'саны',
		open: 'Ашу',
		edit: 'Өңдеу',
		terminate: 'Бұзу',
		remove: 'Жою',
		choose_file: 'Выбрать файл',
		confirm: 'Растау',
		reject: 'Бас тарту',
		contract_data: 'ЕШЕБЖ-дан шарт бойынша деректер',
		labor: 'ЕШ',
		el_labor: 'ЭТК',
		laborDigitalization: 'Еңбек кітапшасы бойынша цифрланған деректер',
		bin_iin: ' (БСН/ЖСН: ',
		detail: 'Толығырақ ',
		short: 'Қысқаша ',
		reason_termination: 'Тоқтату себебі',
		date: 'Күні',
		record_type: 'Жазу түрі',
		establishedPost: 'Лауазымы',
		requestType: 'Сұрау түрі',
		action: 'Әрекет',
		revoke: 'Қайтарып алу',
		loading: 'Деректерді жүктеу жүріп жатыр...',
		no_data: 'Сізде түзету сұраулары жоқу',
		actions: 'Әрекет',
		request_edit: 'өңдеу ',
		request_terminate: 'тоқтатуға/бұзуға ',
		request_remove: 'жою ',
		title_request: 'Сұраныс ',
		contract_request: '{{contractDate}} жылғы № {{contractNumber}} еңбек шартын жоюға сұрау салу',
		request_data: 'Сұрау салу күні {{ requestDate }} ',
		request_status: 'Сұрау мәртебесі: ',
		view_contract: 'Келісімді ашу',
		hint_information: '*Тараптардың БСН/ЖСН түзету үшін ЕХӘҚМ ресми хатпен жүгіну қажет.',
		contract_terminate_info: 'Шартты бұзу туралы ақпарат',
		terminate_date: 'Тоқтату күні',
		contract_termination_reason: 'Тоқтату себебі',
		confirming_document: 'Растайтын құжаттар',
		full_size: 'Жалпы өлшемі',
		additional_information: 'Қосымша ақпарат',
		phone: 'Байланыс нөмірі',
		email: 'Пошта',
		placeholder_phone: 'Телефон нөмірін енгізіңіз',
		placeholder_email: 'Электрондық поштаңызды енгізіңіз',
		comment: 'Түсініктеме',
		placeholder_comment: 'Еңбек шартын бұзғыңыз келетін себебін енгізіңіз',
		note: 'Шешім',
		register_data: 'Шарттың ЕШЕБЖ-не тіркелген күні: ',
		max_size_photo_error: 'Максималды сурет өлшемі 10 МБ',
		error_size: 'Рұқсат етілген жалпы файл өлшемінен асып кетті',
		download: 'Жүктеу',
		cancel: 'Бас тарту',
		year: ' жылғы № ',
		enbek_shartin: ' еңбек шартын ',
		surau_salu: ' сұрау салу',
		max_size_all: 'Барлық файлдардың жалпы өлшемі 10 МБ тан аспауы керек',
		max_size_by_var: 'Барлық файлдардың жалпы өлшемі {{maxSize}} МБ тан аспауы керек',
		specify_reason: 'Тоқтату себебін немесе қажет болған жағдайда тоқтатудың бірнеше себептерін көрсету қажет',
		sign_and_send: 'Қол қою және жіберу',
		send_adjustments: 'Сіз еңбек шартын тоқтату/бұзу туралы мәліметтерді енгізу туралы сұрау жібересіз',
		sign_adjustments: 'ЭЦҚ көмегімен сұрауға қол қою арқылы, Сіз ұсынылған деректер үшін жауаптысыз',
		title_send_revoke: 'Сіз түзету сұрауын қайтарып алайын деп жатырсыз',
		body_sign_revoke:
			'Сіз шынымен түзету сұрауын қайтарып алғыңыз келе ме? Бұл жағдайда сұрауды еңбек жөніндегі уәкілетті мемлекеттік орган қарамайды.',
		confirming_document_no_required: 'Растайтын құжаттар (міндетті емес)',
		title_send_remove: 'Сіз еңбек шартының деректерін жою туралы сұрау жібересіз',
		title_send_edit: 'Сіз еңбек шарты бойынша деректерге түзету енгізу туралы сұрау жібересіз',
		instruction: 'НҰСҚАУЛЫҚ!',
		info_box_title: 'Еңбек шартындағы ақпаратты қалай өзгертуге болады?',
		contract_info: 'Шарт туралы ақпарат',
		position_by_nkz: 'ҰҚЖ негізіндегі лауазым',
		contract_employer_number: 'Еңбек шарттың нөмірі',
		hint_termination_reason:
			'Қажет болса, тоқтатудың бір немесе бірнеше себептерін жоюға немесе жаңаларын қосуға болады',
		additional_contract: 'Қосымша келісімдер туралы ақпарат',
		add_contract_num: '{{registerDate}} ж. №{{contractNumber}} қосымша келісім',
		view_contract_num: '№{{contractNumber}} қосымша келісім',
		social_leave: 'Әлеуметтік демалыс туралы ақпарат',
		social_leave_num: 'Әлеуметтік демалыс',
		weekend: 'Демалыс күндер',
		vacation_date_start: 'Бастап жұмыс істемеді',
		vacation_date_end: 'Дейін жұмыс істемеді',
		info: {
			availabilityFields: 'Келісімшарт өрістерінің ешқайсысы өзгертілген жоқ',
			max_end_date: '"Дейін жұмыс істемеді" өрісі "бастап жұмыс істемеді" өрісінен 184 күннен артық болмауы тиіс',
		},
		title_sign_confirm: 'Сіз сұранысты түзетуді растайтын боласыз',
		body_sign_confirm:
			'Сіз шынымен сұрауды түзетуді растағыңыз келе ме? Бұл жағдайда шартқа тиісті өзгерістер енгізілетін болады.',
		title_sign_reject: 'Сіз түзету сұрауын қабылдамайсыз.',
		body_sign_reject:
			'Сіз шынымен түзету сұрауын қабылдамағыңыз келе ме? Бұл жағдайда шартта тиісті өзгерістер жасалмайды.',
		note_placeholder: 'Сұрауға жауап пікірін енгізіңіз',
		note_text: 'Еңбек шарттарын есепке алудың бірыңғай жүйесінде сұранымдағы мәліметтерге сәйкес өзгерістер енгізілді',
	},
	banners: {
		text: '"Қазақстанның еңбек нарығы: цифрлық шындыққа жол" Ұлттық баяндамасынан біліңіз',
		transition: 'Өту         ',
	},
	unsigned_documents_will_removed_your_account: 'Қол қойылмаған құжаттар сіздің кабинетіңізден жойылады',
	selected_documents_will_signed: 'Таңдалған құжаттарға қол қойылады',
	sure_sign_selected_documents: 'Таңдалған құжаттарға қол қойғыңыз келетініне сенімдісіз бе?',
	sign_subscription: 'Қолтаңба белгісі',
	digitization: {
		modal_title: {
			create: 'Еңбек қызметі туралы жазбалар енгізу',
			edit: 'Еңбек қызметі бойынша жазбаларды түзету',
		},
		form: {
			titleCreate: 'Еңбек қызметі туралы жаңа жазба жасау',
			titleEdit: 'Еңбек қызметі туралы жазбаларды түзету',
			laborType: 'Ауысудың түрі',
			bin: 'БСН/ЖСН',
			choose: 'МЗЖ деректерінен таңдаңыз',
			orgName: 'Атауы',
			establishedPost: {
				1: 'Лауазымы',
				2: 'Лауазымы',
				3: 'Қайта ұйымдастырылғаннан/ауыстырудан кейінгі лауазымы',
			},
			eventDate: {
				1: 'Қабылдау күні',
				2: 'Лауазымға кіріскен күні',
				3: 'Ұйымның қайта құрылған/ауысқан күні',
				4: 'Еңбек шартын бұзу күні',
			},
			termReasonCodes: 'Еңбек шартын бұзу себебі',
			choosePeriod: 'Міндетті зейнетақы жарналарының деректерінен кезеңді таңдаңыз',
		},
		table: {
			text: 'Бір жұмыс кезеңіндегі барлық ауыстыруларды қосыңыз (жұмысқа қабылдаудан бастап, жұмыстан босатуға дейін, бар болса)',
			headers: {
				date: 'Күні',
				moving: 'Ауысу',
				bin: 'БСН/ЖСН',
				name: 'Атауы',
				position: 'Лауазымы',
				period: 'Кезең',
				actions: 'Әрекеттер',
			},
		},
		sign_all: 'Барлығына қол қою',
		sign_checked: 'Белгіленген жазбаларына қол қою',
		remove_checked: 'Белгіленген жазбаларды жою',
		sign_and_remove: 'Қол қою және жою',
		yes_remove: 'Иә, жою',
		confirm: {
			sign_contract: {
				title: 'Еңбек қызметі бойынша жазбаға қол қойылады',
				data: 'Сіз еңбек қызметі туралы жазбаға қол қойып, Еңбек шарттарын есепке алудың бірыңғай жүйесіне жібергіңіз келетініне сенімдісіз бе?',
			},
			remove_contract: {
				title: 'Еңбек қызметі туралы жазба жойылады',
				data: 'Сіз Еңбек жазбасын жойғыңыз келетініне сенімдісіз бе?',
			},
			sign_chosen: {
				title: 'Сіз белгіленген жазбаларға қол қоясыз ба',
				data: 'Сіз шынымен де белгіленген еңбек жазбаларына қол қойғыңыз келе ме? Қол қойылған жағдайда деректер Еңбек шарттарын есепке алудың бірыңғай жүйесіне жіберіледі және «Электрондық еңбек кітапшасы» бөлімінде көрсетіледі',
			},
			remove_chosen: {
				title: 'Сіз белгіленген жазбаларды жойғыңыз келеді ме',
				data: 'Сіз шынымен де қалпына келтіру мүмкіндігінсіз белгіленген еңбек жазбаларын жойғыңыз келе ме?',
			},
			sign_and_send_all: {
				title: 'Сіз барлық сақталған жазбаларға қол қоясыз ба',
				data: 'Сіз шынымен де барлық сақталған еңбек жазбаларына қол қойғыңыз келе ме? Қол қойылған жағдайда деректер Еңбек шарттарын есепке алудың бірыңғай жүйесіне жіберіледі және «Электрондық еңбек кітапшасы» бөлімінде көрсетіледі',
			},
			buttons: {
				sign_and_send: 'Подписать и отправить',
				yes_remove: 'Да, удалить',
			},
		},
		bin: 'Ұйымның БСН',
	},
	choose_employment_contract: 'Еңбек шартын таңдаңыз',
	person_not_found: 'ЖСН табылмады',
	membersSearchInput: 'Кәсіподақ мүшесінің ЖСН енгізіңіз',
	ncalayer_info:
		'NCALayer-ге қосылу кезінде қате пайда болды немесе байланыс үзілді. Егер NCALayer іске қосылмаған болса іске қосыңыз немесе жұмысты жалғастырыңыз, келесі қол қою кезінде байланыс автоматты түрде қалпына келтіріледі.',
	pension: {
		searchInput: 'Контрагенттің ЖСН немесе аты-жөнін енгізіңіз',
		status_request: 'Өтінім мәртебесі',
		state: 'Жағдайы',
		request_date: 'Өтінім уақыты',
		birthday: 'Туған күні',
		actions: 'Әрекеттер',
		loading: 'Деректерді жүктеу жүріп жатыр…',
		no_data: 'Сізде зейнетақы төлемдерін тағайындауға өтінімдер жоқ',
		has_error: 'Қате орын алды, әрекетті кейінірек қайталаңыз!',
		contractor: 'Контрагент',
		persons: 'Зейнеткерлік жас алдындағы қызметкерді таңдаңыз',
		gender: 'Жынысы',
		out_day_work: 'Күндер қалды',
		no_pension_workers: 'Сізде зейнеткерлік жас алдындағы қызметкерлер жоқ',
		modal: {
			title: 'Келісім сұрау',
			data: 'Қызметкердің дербес деректерін жинауға және өңдеуге келісім алу',
			send_more: 'Жіберу және жалғастыру',
			close: 'Жабу',
		},
		create_request: 'Өтінімді жасау',
		payments: {
			tables_empty: 'Тәжірибе мен растайтын құжат міндетті түрде қосылуы керек',
			code_valid:
				'Проактивті қызметті жіберу өтініш берушіден дербес деректерге қол жеткізуге келісім алғаннан кейін ғана қолжетімді болады.',
			checkbox: {
				employee:
					'Кадрлар бөлімінің қызметкері проактивті өтінішке енгізілген деректердің тексерілгенін және жұмыскердің келісімімен тиісті нысанда толтырылғанын растайды.',
				seniority: 'Жұмыскердің еңбек өтілі туралы деректердің дұрыс енгізілгені туралы растауы алынды.',
				message:
					'Проактивке өтінімде енгізілген мәліметтер тексерілгенін және тиісті түрде толтырылғанын растау қажет.',
			},
			no_number: 'МАБ нөмірі жоқ',
			alert_no_number:
				'Проактивті қызметті жіберу мүмкін емес, өйткені өтініш берушінің телефон нөмірі мобильді азаматтар базасында жоқ, өтініш беруші телефон нөмірін МБА тіркеуі қажет.',
			hints: {
				update_status:
					'Егер "Келісім алынбаған" немесе "Келісім алынған" мәртебесі болса, дербес деректерді жинауға және өңдеуге келісім мәртебесін жаңартуға болады',
				request_again:
					'Егер "Келісім алынбаған" немесе "Келісім алынған" мәртебесі болса, дербес деректерді жинауға және өңдеуге қайта келісім сұратуға болады',
				experience:
					'Еңбек өтілі еңбек қызметінің барлық кезеңі үшін оның басталған сәтінен зейнеткерлік жасқа толған күнге дейін, оның ішінде оқу, әскери қызмет, еңбек қызметі (еңбек кітапшасы, еңбек шарты, мұрағаттық анықтама, бұйрықтан үзінді), жұмыс істемейтін ананың жас балаларына үш жасқа толғанға дейін күтімі кезеңдеріне енгізіледі.',
				type_of_experience:
					'Еңбек өтілінің типі жасына байланысты зейнетақы төлемдерін тағайындау, зейнетақы жүйесіне қатысу және мемлекеттік базалық зейнетақы төлемін тағайындау үшін құжаттардың (білім туралы диплом, әскери билет, балалардың туу туралы куәлігі) және еңбек қызметі туралы құжаттардың сканерленген түпнұсқаларымен расталады',
				benefit_type:
					'Жеңілдік өтілінің түрі жасына байланысты зейнетақы төлемдерін тағайындау үшін еңбек қызметі туралы құжаттардың сканерленген түпнұсқаларымен расталады',
				period_start_date: 'Еңбек қызметі басталған сәттен бастап оның басталу күні',
				period_end_date: 'Еңбек қызметі кезеңінің аяқталу күні зейнеткерлік жасқа толған күнге дейін толтырылады',
				name_of_experience: 'Атауын көрсетіңіз, мысалы: жұмыс, оқу, әскери қызмет, еңбек қызметі орнының',
				document_type:
					'Құжат түрін таңдау арқылы жүйе файл түрі, атауы, кеңейтімі және файл салмағы бірдей тіркелген құжатты тексереді',
				attach_file:
					'Құжатты мәтінді, барлық деректемелерді, күндерді, визаларды, қарарларды, өзге де жазуларды, мөрлер мен мөртабандарды еркін оқу мүмкіндігін қамтамасыз ететін түсті нұсқада сканерлеу қажет. Құжат сапалы түсті нұсқада сканерленуі керек. Бір файлдың өлшемі 13 МБ аспауы тиіс. JPG, JPEG, PNG, PDF тіркелетін файлдарының жарамды пішімдері.',
				pension_persons:
					'Тізімге зейнеткерлік жасқа дейін 3 айдан 11 күнге дейін зейнеткерлікке шыққан жұмыскерлер кіреді',
			},
			form: {
				title: 'Қызметкерге зейнетақы төлемін тағайындауға өтінім',
				labels: {
					app_info: 'Өтінім туралы ақпарат',
					app_id: 'Өтінім ID',
					app_creation_date: 'Өтінімнің жасалған күні',
					app_last_modified_date: 'Соңғы өзгеріс күні',
					app_status: 'Өтінім мәртебесі',
					note: 'Ескерту',
					app_state: 'Өтінімнің жай-күйі',
					app_consent: 'Өтініш берушінің келісімі',
					applicant_info: 'Өтініш беруші туралы ақпарат',
					iin: 'ЖСН',
					fio: 'Аты-Жөні',
					date_of_birth: 'Туған күні',
					sex: 'Жынысы' /*check*/,
					phone: 'Ұялы телефон',
					place_of_work: 'Жұмыс орнының атауы',
					personnel_officer: 'Кадр қызметінің қызметкері туралы ақпарат',
					employee_name: 'Қызметкердің аты-жөні*',
					employee_position: 'Қызметкердің лауазымы*',
					employee_phone: 'Телефон нөмірі*',
					experience: 'Еңбек өтілі',
					documents: 'Растайтын құжаттар' /*check*/,
					add_document: 'Құжатты қосу',
					submit_app: 'Өтінімді жіберу' /*check*/,
					update_status: 'Күйді жаңарту',
					request_again: 'Қайта сұрау',
				},
				placeholder: {
					enter_name: 'Аты-жөнін енгізіңіз',
					enter_position: 'Лауазымды енгізіңіз',
					enter_phone: 'Нөмірді енгізіңіз',
				},
				table: {
					date_from: 'Бар күн',
					date_by: 'Бойынша күн',
					name_of_experience: 'Жұмыс өтілінің атауы',
					type_of_experience: 'Өтілдің түрі',
					benefit_type: 'Жеңілдік өтілінің түрі',
					actions: 'Әрекеттер',
					document_type: 'Құжат түрі',
					document_name: 'Құжаттың атауы',
					add_entries: 'Жазбаларды қосу қажет',
				},
				exp_form: {
					adding_seniority: 'Өтілін қосу',
					type_of_experience: 'Өтілдің түрі*',
					choose_type_of_experience: 'Өтілдің түрін таңдаңыз',
					benefit_type: 'Жеңілдік өтілінің түрі',
					select_benefit_type: 'Жеңілдік өтілінің түрін таңдаңыз',
					start_date: 'Кезеңнің басталу күні*',
					date_format: 'кк.аа.жжжж.',
					end_date: 'Кезеңнің аяқталу күні*',
					name_of_experience: 'Жұмыс өтілінің атауы*',
					enter_name: 'Өтілдің түрін таңдаңыз',
				},
				doc_form: {
					add_document: 'Құжатты қосу',
					document_type: 'Құжат түрі*',
					choose_type_experience: 'Өтілдің түрін таңдаңыз',
					max_file_size_error: 'Максималды файл өлшемі 13 МБ',
					file_added: 'Бұл файл әлдеқашан қосылған',
				},
				diff_form: {
					diff1:
						'«Еңбек кітапшасы бойынша жұмыс» өтілі үшін келесі құжаттардың бірін ұсыну қажет: еңбек кітапшасы, мұрағаттық анықтама, бұйрықтардан үзінді көшірме, төтенше және максималды радиациялық қатер аймағында 1949 жылғы 29 тамыздан бастап 1963 жылғы 5 шілде аралығында тұру фактін растайтын құжат',
					diff2: '«Әскери қызмет» өтілі үшін «Әскери билет» құжатының түрін ұсыну қажет',
					diff7: '«16 жасқа дейінгі мүгедек баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff8: '«1 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff9: '«2 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff10: '«3 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff11: '«4 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff12:
						'«Бостандықтан айыру жерлерінде жазаны өтеу, тұтқында болу уақыты» өтілі үшін «Сот шешімі» құжатының түрін ұсыну қажет',
					diff17:
						'«Оқыту мекемелерінде оқу процесі» өтілі үшін «Орта арнайы немесе жоғары оқу орнын аяқтау туралы диплом» құжатының түрін ұсыну қажет',
					diff21: '«5 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff22: '«6 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff23: '«7 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
					diff24: '«8 - ші баланы күту» өтілі үшін «Туу туралы куәлік» құжатының түрін ұсыну қажет',
				},
			},
		},
		instructions: 'Проактивті өтінімдермен жұмыс істеу жөніндегі нұсқаулық',
		video_instructions: 'Видеонұсқаулық:',
	},
	portal_employment_contracts: 'Enbek HR - еңбек шарттары',
	available: '{{type}} - да кол жетімді',
	available_google: '{{type}} - де қол жетімді',
	dark_day: '2023 жылғы 29 қазанда - Қазақстан Республикасында жалпыұлттық аза тұту күні',
	unread_notifications: 'Оқылмаған хабарламалар',
	absence_notifications: 'Хабарламалар жоқ!',
	error_checks: 'Осы параметрлер бойынша құжат жоқ',
	error_checks_system: 'Жүйе қатесі, құжатты кейінірек тексеріп көріңіз',
	document_verification: 'Құжатты тексеру',
	document_checks_name: 'Құжаттың атауы',
	document_ID: 'Құжаттың ID',
	e_ad_contract: 'Электрондық қосымша келісім',
	e_term_contract: 'Шартты бұзу туралы ақпарат',
	document_status_sign: 'Құжатқа қол қою мәртебесі',
	document_number_date: 'Құжаттың нөмірі мен күні',
	document_sign_employer: 'Жұмыс берушінің қолы',
	document_sign_employee: 'Қызметкердің қолы',
	document_time_sign: 'Қол қою уақыты',
	document_note_title: 'ЕСКЕРТУ!',
	document_note:
		'Қазақстан Республикасы Еңбек кодексінің 33-бабының 1-тармағына сәйкес еңбек шарты жазбаша нысанда кемінде екі данада жасалады және оған тараптар қол қояды. Еңбек шартының бір данасы қызметкерде және жұмыс берушіде сақталады.\n' +
		'Еңбек шартын жасасу, оған өзгерістер мен толықтырулар енгізу электрондық цифрлық қолтаңба арқылы куәландырылған электрондық құжат нысанында жүргізілуі мүмкін.',
	replace_eds_file: 'ЭҚК файлын ауыстырыңыз',
	replace_eds_project_file: 'ЭЕШ жобасының файлын ауыстырыңыз',
	question_delete_project_etd: 'Сіз шынымен ЭЕШ жобасын жойғыңыз келе ме? Бұл жағдайда ЕШ жасау процесі тоқтайды',
	include_file_etd: 'ЭЕШ жобасының файлын тіркеу',
	file_info_size: 'Өлшемі 5МБ-тан аспауы керек',
	success_save: 'Сәтті сақталды',
	sign_all_title: 'Барлық қол қойылмаған құжаттарға қол қойылады',
	sign_all_body: 'Сіз қол қойғыңыз келетініне сенімдісіз бе?',
	add_file_eds: 'ЭҚК жобасының файлын енгізу',
	replace_file_eds: 'ЭҚК жобасының файлын ауыстыру',
	oppv_count_unikey_period: 'Жұмыс беруші айларда аударған МКЗЖ саны',
	oppv_spectial: 'Арнаулы кәсіптік мемлекеттік жәрдемақы, теңге',
	oppv_money: 'Өмірді сақтандыру компаниясынан төлем, теңге',
	oppv_money_employer: 'Жұмыс берушіден төлем, теңге',
	oppv_money_enpf: 'МЗЖ және МКЗЖ жинақтау есебінен БЖЗҚ дан зейнетақы төлемі',
	oppv_all: 'Ай сайынғы төлемдердің жалпы сомасы, теңге',
	oppv_calculate: 'Есептеу',
	oppv_last_update: 'Соңғы жаңарту: ',
	oppv_hint1:
		'2024 жылғы 1 қаңтардан бастап зиянды еңбек жағдайларында жұмыс істейтін адамдарға 55 жасқа толғанда және олар үшін МКЗЖ кемінде 84 ай төлеу фактісі кезінде 63/61 жасқа дейін Арнайы әлеуметтік төлем жүзеге асырылады.',
	oppv_hint2: 'МКЗЖ - Міндетті кәсіптік зейнетақы жарналары',
	oppv_hint3:
		'МЗЖ - Міндетті зейнетақы жарналары\n' +
		'МКЗЖ - Міндетті кәсіптік зейнетақы жарналары\n' +
		'БЖЗҚ - Бірыңғай жинақтаушы зейнетақы қоры',
	hierarchy_categories: 'ҰСК негізінде лауазым бөлімі',
	dangerous_working_document: 'Растайтын құжат *',
	conditions1: '1-тізім бойынша жұмыс түрі *',
	conditions2: '2-тізім бойынша жұмыс түрі *',
	conditions3: 'МКЗЖ тізімі бойынша жұмыс түрі *',
	conditions_hint1:
		'Қазақстан Республикасы Үкіметінің 1999 жылғы 19 желтоқсандағы № 1930 қаулысына сәйкес бекітілген жұмыс түрін таңдау қажет',
	conditions_hint2:
		'Қазақстан Республикасы Үкіметінің 1999 жылғы 19 желтоқсандағы № 1930 қаулысына сәйкес бекітілген жұмыс түрін таңдау қажет',
	conditions_hint3:
		'ҚР Еңбек және халықты әлеуметтік қорғау министрінің 2023 жылғы 24 мамырдағы № 170 бұйрығына сәйкес бекітілген жұмыс түрін таңдау қажет',
	download_button_hint: 'Растайтын файлды тіркеу қажет(барлық файлдардың жалпы өлшемі 10 МБ-тан аспауы керек)',
	oppv_comment: '* Бұл есептеу болжалды болып табылады және ақпараттық сипатта қолданылады. ',
	enter_iin: 'ЖСН енгізіңіз',
	tel_bmg: 'Сіздің ұялы азаматтар базасындағы телефон нөміріңіз (ҰАБ)',
	send_sms: 'ҰАБ жүйесінде тіркелген телефон нөміріне SMS кодын жіберу керек пе?',
	error_bmg: 'Осы ЖСН бойынша ҰАБ-да нөмір жоқ. Ұялы телефон нөмірін egov.kz арқылы тіркеуге болады.',
	error_bmg_service: 'Қате, қайталап көріңіз.',
	code_bmg: 'СМС коды',
	code_bmg_placeholder: 'СМС - тен кодты енгізіңіз',
	title_employeeRequest_1:
		'Сіз зиянды еңбек жағдайларында жұмыс істейтін жұмыскермен еңбек шартын бұзуды тіркейсіз. Егер жұмыскер арнайы әлеуметтік төлем алуға ниет білдірсе және ',
	title_employeeRequest_2: 'ережелерге ',
	title_employeeRequest_3:
		'сәйкес зиянды еңбек жағдайлары бар жұмыстарда еңбек қызметін тоқтату туралы өтініш жазса, сіз келесі шарттарды растауыңыз керек:',
	additional_employeeRequest_1:
		'Сіз еңбек жағдайларын «Зияндыдан» «Қалыптыға» өзгерту туралы қосымша келісімді тіркейсіз. Егер жұмыскер арнайы әлеуметтік төлем алуға ниет білдірсе және ',
	additional_employeeRequest_3:
		'сәйкес зиянды өндірістік факторлардың әсерін болдырмайтын басқа жұмысқа ауысу туралы өтініш жазса, сіз келесі шарттарды растауыңыз керек:',
	hr_manager_phone: 'Кадрлар бөлімінің телефон нөмірі*',
	employee_phone: 'Қызметкердің телефон нөмірі*',
	employee_phone_harmful: 'Жұмыскердің телефон нөмірі*',
	employeeRequest: 'Қызметкердің өтінішінің болуы',
	employeeConsent: 'Қызметкердің дербес деректерді өңдеуге келісімі',
	employerApprove: 'Жұмыс берушінің 1 КММ мөлшерінде әлеуметтік төлем төлеуге келісімі',
	employeeIban: 'Банктік шоттың болуы',
	error_message_button: 'Күні 2024 жылдан ерте болмауы керек',
	enpf: 'БЖЗҚ төлемінсіз',
	enpf_oppv: 'МКЗЖ жинақтау есебінен БЖЗҚ-дан төлемі',
	enpf_oppv_opv: 'МЗЖ және МКЗЖ жинақтау есебінен БЖЗҚ-дан төлем',
	iban_placeholder: 'KZ 18 таңбаны енгізіңіз',
	important_comment_1:
		'* Маңызды! Қызметкерге арнаулы әлеуметтік төлем тағайындау үшін қызметкер мобильді азаматтар базасында тіркелуге тиіс және жұмыс беруші "Қызметкерді еңбек (қызметтік) міндеттерін атқарған кезде оны жазатайым оқиғалардан міндетті сақтандыру туралы" Қазақстан Республикасы Заңының 23-1-бабына сәйкес зейнетақыға дейінгі аннуитеттік сақтандыру шартын жасасуға тиіс. ',
	important_comment_2: 'Кәсіби төлемді есептеу әдістемесін',
	important_comment_3: ' жүктеу',
	col_contract: {
		protocolDisagreement: 'Келіспеушілік хаттамасы',
		supplement_surcharge: 'Үстеме(Қосымша ақы)',
		industry: 'Саласы',
		date_end_col_contract: 'Ұжымдық шарттың қолданылу мерзімі  *',
		info_tariff_rates: 'Тарифтік мөлшерлеме, жалақының және үстеме ақылардың(қосымша төлем) мөлшері туралы ақпарат',
		add_info_work_place: 'Жұмыс орны туралы ақпарат',
		add_rank: 'Разрядты қосу',
		info_by_work_place: 'Жұмыс орны туралы ақпарат {{ count }}',
		tariff_rate_salary: 'Тарифтік мөлшерлеме(айлықақы)',
		inter_digit_coefficient: 'Разрядаралық коэффициент',
		rank_by_count: 'Разряд {{ count }}',
		rank: 'Разряд',
		set_count: 'Санын енгізіңіз',
		set_supplement_surcharge: 'Қосымша/үстеме ақыны енгізіңіз',
		set_coefficient: 'Коэффициентті енгізіңіз',
		protocol_disagreements: 'Келіспеушілік хаттамасы',
		typeEnterprise: 'Кәсіпорын түрі',
		typeOwnership: 'Меншік нысаны',
		contract_short_information: '{{dateFrom}} ж. басталған № {{contractNumber}} шарт',
		searchInput: 'Кәсіпорынның БСН немесе атауын енгізіңіз',
		set_ecd_doc: 'ЭҰШ жоба файлын тіркеңіз',
		update_ecd_doc: 'ЭҰШ  жобасының файлын ауыстырыңыз',
		table: {
			employer: 'Жұмыс беруші',
			bin: 'Жұмыс берушінің БСН',
			name: 'Жұмыс берушінің атауы',
			union_name: 'Кәсіподақ атауы',
			date_from: 'Келісім жасалған күн',
			date_to: 'Аяқталу күні',
			actions: 'Әрекеттер',
		},
		bin: 'Жұмыс берушінің БСН',
		name: 'Жұмыс берушінің атауы',
		firstUnion: 'Бастапқы проф. одақ',
		localUnion: 'Жергілікті проф. одақ',
		union_name: 'Кәсіподақ атауы',
		union_bin: 'Проф. Одақ БСН',
		representativeIin: 'Өкіл ЖСН',
		representativeFIO: 'Өкілдің тегі, аты және әкесінің аты',
		info: 'Ұжымдық шарт туралы ақпарат',
		number: 'Ұжымдық шарттың нөмірі',
		placeholder_number: 'Укажите номер',
		dateFrom: 'Келісім жасалған күн',
		dateTo: 'Аяқталу күні',
		pay_info: 'Еңбекақы төлеу жүйесі туралы ақпарат',
		pay: 'Үстеме жұмыс ақысы',
		placeholder_amount: 'Ставка өлшемін енгізіңіз',
		placeholder_percent: 'Пайызды енгізіңіз',
		placeholder_size_rate: 'Тарифтік мөлшерлеменің мөлшерін көрсетіңіз',
		placeholder_rate: 'Коэффициентті көрсетіңіз',
		placeholder_one_or_more_values: 'Бір немесе бірнеше мәндерді таңдаңыз',
		placeholder_amount_text: 'Іс-шараларды қаржыландыру көлемін енгізіңіз',
		amount: 'Соманы көрсетіңіз',
		holiday_pay: 'Мереке және демалыс күндері жұмысқа ақы төлеу',
		night_time_pay: 'Түнгі уақытта еңбекақы төлеу',
		combination_position_pay:
			'Лауазымдарды қоса атқару, қызмет көрсету аймағын кеңейту және уақытша болмаған қызметкердің міндеттерін орындау (ауыстыру) кезінде еңбекақы төлеу',
		term_compensation_pay:
			'Қызметкер зейнеткерлік жасқа толған кезде жұмыс берушінің бастамасы бойынша еңбек шарты бұзылған жағдайда өтемақы төлемі',
		way_compensation_pay:
			'Жұмыскерлердің жұмыс берушінің орналасқан жерінен немесе жинау пунктінен жұмыс орнына дейінгі жолда болған уақыты үшін өтемақы төлемі және кері оқу',
		wage_index_procedure: 'Жалақыны индекстеу тәртібі',
		information_tariff_rates: 'Тарифтік ставкалардың мөлшері туралы ақпарат',
		tariff_rate_category_workers: '1-разрядты қызметкерлердің тарифтік мөлшерлемесінің мөлшері',
		industry_agreement_coefficient: 'Салалық келісімдегі Коэффициент',
		min_coefficient: 'Минималды коэффициент',
		max_coefficient: 'Максималды коэффициент',
		different_coefficient: 'Разрядаралық коэффициенттерді белгілеу туралы',
		grade_min: '{{number}} -разрядты қызметкерлер үшін ең төменгі коэффициент',
		grade_max: '{{number}} -разрядты қызметкерлер үшін ең жоғары коэффициент',
		duration_working_hours_and_rest_time_holidays: 'Жұмыс уақыты мен демалыс уақытының ұзақтығы, еңбек демалысы туралы',
		working_time: 'Жұмыс уақыты',
		relax_time: 'Демалыс уақыты',
		safe_working_protection:
			'Салауатты және қауіпсіз еңбек және тұрмыс жағдайларын жасау туралы, еңбек қауіпсіздігі және еңбекті қорғау жөніндегі іс-шараларды қаржыландыру көлемі туралы, денсаулықты қорғауды жақсарту туралы',
		amount_funding: 'Еңбек қауіпсіздігі және еңбекті қорғау жөніндегі іс-шараларды қаржыландыру көлемі',
		funding_amount: 'Қаржыландыру сомасы',
		scanned_col_contract: 'Ұжымдық шарттың сканерленген көшірмесі *',
		forWorkers: '{{number}} санатындағы жұмысшылар үшін',
		colDownload: 'Ұжымдық шартты жүктеу',
		tradeUnion: 'Кәсіптік одақ',
		representativeTradeUnion: 'Кәсіптік одақ өкілі',
		fromTo: '{{min}} бастап {{max}} дейін',
		scan: 'Ұжымдық шарттың сканерленген көшірмесі',
		hint: {
			pay: 'Үстеме жұмыс үшін төлем мөлшерін көрсету қажет',
			holiday_pay: 'Мереке және демалыс күндері төлем мөлшерін көрсету қажет',
			night_time_pay: 'Түнгі уақытта еңбекақы мөлшерін көрсету қажет',
			combination_position_pay: 'Лауазымдарды біріктіру кезінде мөлшерін көрсету қажет',
			term_compensation_pay: 'Бұзылған жағдайда өтемақы төлемінің пайызын көрсету қажет',
			way_compensation_pay: 'Жұмыскерлер болған жағдайда өтемақы төлемінің пайызын көрсету қажет',
			wage_index_procedure: 'Жалақыны индекстеу пайызын көрсету қажет',
		},
		col_union: 'Біріктіру түрі',
		add_representative: 'Өкіл қосу',
		add_union: 'Бірлестікті қосу',
		guarantee_title: 'Ұжымдық шарттарда көзделген қызметкерлер үшін қосымша кепілдіктер мен жеңілдіктер',
		type_guarantees: 'Қосымша кепілдіктер мен жеңілдіктер түрі',
		type_benefits: 'Қосымша кепілдіктер мен жеңілдіктер',
		additional_guarantees: 'Қосымша кепілдіктер мен жеңілдіктер түрі',
		enter_information: 'Қосымша кепілдіктер мен жеңілдіктер туралы ақпаратты енгізіңіз',
		add_guarantees: 'Кепілдіктер қосыңыз',
		type_union_data: 'Кәсіподақ түрі',
		trade_union_data: 'Проф. одақтың деректері',
		union: 'Бірлестік',
		additional_information: 'Қызметкерлерге қосымша кепілдік және жеңілдіктер туралы ақпарат',
		contracts: 'Ұжымдық шарттар',
		info_for_create: 'Егер сіз кәсіптік одақтың өкілі болсаңыз және ұжымдық шарт жасасуға ниет білдірсеңіз, ',
		info_for_create_2: ' бөлімінде ақпаратты толтыру қажет',
		language: 'Электрондық ұжымдық шарттың тілі',
		kz: 'Қазақ тілі',
		rus: 'Орыс тілі',
		return: 'Қайту',
		project_title: 'Электрондық ұжымдық шарт жобасы',
		status_sign: 'ЭҰШ қол қою мәртебесі',
		trade_union_representative: 'Кәсіподақ өкілі',
		employer_representative: 'Жұмыс берушінің өкілі',
		worker_representative: 'Жұмысшы өкілі',
		text_ecd_sign_employer: 'Мен шарттың талаптарымен келісемін және электрондық ұжымдық шартқа қол қойғым келеді',
		text_ecd_sign_trade_union:
			'Сіз жұмыс берушімен ұжымдық шарт жасасасыз! Қол қойылғаннан кейін бұл шарттар автоматты түрде Еңбекті қорғау және қауіпсіздік жүйесіне жіберіледі',
		create_draft: 'Ұжымдық шарттың жобасын құру',
		send_to_sign_employer: 'Жұмыс берушіге қол қоюға жіберу',
		title_decline:
			'Сіз келісімшартқа қол қоюдан бас тартасыз. Электрондық ұжымдық шарт жасасуды тоқтатқыңыз келетініне сенімдісіз бе?',
		comment_employer: 'Жұмыс берушінің пікірі',
		decline_title_trade_union:
			'Сіз келісімшартқа қол қоюдан бас тартасыз. Электрондық Ұжымдық шарт жасасуды тоқтатқыңыз келетініне сенімдісіз бе?',
		revert_title:
			'Сіз шынымен электрондық ұжымдық шартқа қол қоюды қайтарып алғыңыз келе ме? Бұл жағдайда электрондық ұжымдық шарт жасасу процесі тоқтатылады',
		nkz_position: 'ҰҚЖ лауазымы  *',
		working_condition: 'Еңбек жағдайлары  *',
		tariff_rate_salary_required: 'Тарифтік мөлшерлеме(айлықақы)  *',
		supplement_surcharge_required: 'Үстеме/Қосымша ақы  *',
		inter_digit_coefficient_required: 'Разрядаралық коэффициент  *',
		amount_funding_required: 'Еңбек қауіпсіздігі және еңбекті қорғау жөніндегі іс-шараларды қаржыландыру көлемі  *',
		additional_guarantees_required: 'Қосымша кепілдіктер мен жеңілдіктер түрі  *',
		industry_required: 'Саласы  *',
	},
	contractDuration: {
		base: 'Шетелдікті тарту үшін негіздеме',
		permit_number: 'Рұқсат нөмірі',
		permit_number_placeholder: 'Рұқсат нөмірін енгізіңіз',
		dateOfPermit: 'Рұқсат берілген күні',
		education: 'Білімі',
		speciality: 'Мамандық',
		qualification: 'Біліктілік',
		hint: {
			base: 'Анықтамалықтан шетелдікті тарту үшін негізді таңдаңыз',
			permit_number: 'Рұқсат нөмірін көрсетіңіз',
			dateOfPermit: 'Рұқсат берілген күнді көрсетіңіз',
			education: 'Тізімнен білім таңдаңыз',
			speciality: 'Тізімнен мамандықты таңдаңыз',
			qualification: 'Тізімнен біліктілікті таңдаңыз',
		},
		employeeFio: 'Рұқсат иесінің аты-жөні',
	},
	welfare: {
		tab: 'ЖҰМЫСШЫЛАР ПОРТРЕТІ',
		general: 'Кәсіпорын бойынша ақпарат',
		totalEmployees: 'Барлық жұмыскерлер',
		menWomen: 'Ерлер / Әйелдер',
		calculated: ' Деректер күніне бір рет есептеледі, соңғы жаңартылған',
		info: 'Деректер күніне бір рет есептеледі, соңғы жаңартылған: ',
		structure: 'Мәртебе бойынша құрылым',
		pensioners: 'Зейнеткерлер',
		largeFamilies: 'Көпбалалы',
		disabilities: 'Мүгедектігі бар адамдар',
		guardians: 'МБА қамқоршылары',
		chronic: 'Созылмалы аурулармен',
		recipients: 'АӘК алушылар',
		hazardous: 'Зиянды жағдайда жұмыспен қамтылғандар',
		welfare: 'Жұмысшылар отбасының әл-ауқаты',
		incomeSituation: 'Қызметкерлердің отбасыларындағы табыс жағдайы',
		monthlyMinimum: 'Табысы ең төменгі күнкөріс деңгейінен төмен (отбасы мүшесіне)',
		minimumWage: 'Табысы ең төменгі жалақыдан төмен (отбасы мүшесіне)',
		lifeSituation: 'Қызметкерлердің отбасыларындағы өмірлік жағдай',
		prosperous: 'Ауқатты',
		satisfactory: 'Қанағаттанарлық',
		dysfunctional: 'Ауқатты емес',
		crisis: 'Дағдарыс',
		emergency: 'Шұғыл',
		nodata: 'Сіздің кәсіпорыныңызда жұмыскерлердің әл-ауқаты туралы ақпарат жоқ',
		tabs: {
			general: 'ЖАЛПЫ АҚПАРАТ',
			employeeList: 'МҰҚТАЖ ҚЫЗМЕТКЕРЛЕРДІҢ ТІЗІМІ',
			requestButton: 'Жұмысшылардың тізімін санаттардан сұраңыз: Дағдарыс, Төтенше жағдай',
			table: {
				iin: 'ЖСН',
				fio: 'Төлеуге тиіс (тг.)',
				status: 'Қызметкерлердің отбасыларындағы өмірлік жағдай',
			},
			search: {
				enterIIN: 'ЖСН немесе қызметкердің тегін енгізіңіз',
				total: 'Барлық мұқтаждар',
				sendRequestCnt: 'Келісім сұралды',
				consentCnt: 'Келісім берді',
			},
			tabs: {
				all: 'Барлығы',
				c: 'С (Қолайсыз)',
				d: 'D (Дағдарыс)',
				e: 'Е (Шұғыл)',
			},
			modal: {
				button: 'Келісім сұрауларын жіберу',
			},
			list: 'Мұқтаж жұмысшылардың тізімін қарау',
			hint: 'Тізімде дербес деректерді жинауға және өңдеуге келісім беретін дағдарысты және шұғыл санаттағы қызметкерлер көрсетіледі',
		},
	},
	payment: {
		tab: 'Арн.Әлеум.Төлем',
		title: 'Арнайы әлеуметтік төлем туралы ақпарат',
		calendarTab: 'Төлемдер күнтізбесі',
		paymentTab: 'Арнайы сұраулар.Әлеуметтік.Төлеу',
		transferTab: 'ТРАНСФЕРТТЕР БОЙЫНША ДЕТАЛИЗАЦИЯ',
		assignedForPayment: 'Төлеуге тағайындалған',
		dueToBePaid: 'Төлеу керек',
		paidToPersons: 'Адамдарға төленді',
		refund: 'Қайтару',
		employersDebt: 'Жұмыс берушінің қарызы',
		table: {
			assignedForPayment: 'Төлеуге тағайындалған',
			appointmentDate: 'Тағайындалған күні',
			dueToBePaid: 'Төлеуге тиіс (тг.)',
			paidToPerson: 'Адамға төленді (тг.)',
			refund: 'Қаражатты қайтару (тг.)',
			employersDebt: 'Жұмыс берушінің берешегі (тг.)',
		},
		briefly: 'Қысқаша',
		details: 'Толығырақ',
		sectionUnderDevelopment: 'Әзірлеудегі бөлім',
		event: 'Событие',
		status_history: 'Мәртебе тарихы',
	},
	transfer: {
		emplCount: 'Төлемдерге тағайындалды',
		errorCount: 'Трансферттер бойынша қателер саны',
		table: {
			fio: 'Төлемдерге тағайындалды',
			docDate: 'Төлем тапсырмасының жіберілген күні',
			payDate: 'Валюталау күні',
			refer: 'Төлемнің анықтамасы',
			amount: 'Төлем сомасы (тг.)',
			period: 'Кезең',
			error: 'Қатенің сипаттамасы',
			retDate: 'Қайтару күні',
			retRefer: 'Қайтару нөмірі',
			retAmount: 'Қаражатты қайтару (тг.)',
		},
	},
	staff: {
		status: 'ЕШЕБЖ мәртебесі:',
		refreshStatus: 'Мәртебені жаңарту',
		stop: 'Күтіңіз!',
		info_no_staff: 'Бекітілген штаттық кесте жоқ.',
		staff_units: 'Штаттық бірліктер',
		staff_units_placeholder: 'Санын еңгізіңіз',
		actual_salary_placeholder: 'Нақты жалақыны еңгізіңіз;',
		count_bets: 'Мөлшерлеме саны',
		substitute_yin: 'Ауыстырылған қызметкердің ЖСН',
		version: 'Нұсқа: ',
		del_current_position: 'Сіз ағымдағы лауазымды жойғыңыз келетініне сенімдісіз бе?',
		information_workplace_position: 'Жұмыс орны мен лауазымы туралы мәліметтерді қарау',
		remove_staffing_project: 'Сіз штаттық кесте жобасын жойғыңыз келеді. Әрекетті қайтару мүмкін болмайды.',
		remove_struct: 'Сіз құрылымдық бөлімді жойғыңыз келеді. Әрекетті қайтару мүмкін болмайды.',
		bold_question_remove: ' Сіз жалғастырғыңыз келетініне сенімдісіз бе?',
		staff_units_count_hint: 'Берілген лауазым үшін құрылатын көшірмелер санын енгізіңіз',
		staff_units_count_hint_1: 'Берілген лауазым үшін қосылатын көшірмелер санын енгізіңіз',
		error_info: 'Ошибка: нажмите просмотр',
		error_struct_or_wp: 'Штаттық кестеде қателер бар',
		error_status: 'Қате!',
		error_number: 'Қате: ',
		question: 'Штаттық кестенің жаңа нұсқасы бар. Оны жүктеп алғыңыз келе ме?',
		sign_and_request: 'Подписать и запросить',
		status_get_new_version_error:
			'Сіз штаттық кестенің ескірген нұсқасын қолданасыз, кейбір әрекеттер Сізге қол жетімді емес.',
		error_position_nkz:
			'"КҰК негізіндегі лауазым" еңбек шартындағы "КҰК негізіндегі лауазымға" сәйкес келмейді. Тағайындау мүмкін емес. Келісімшартты немесе штаттық кестені өзгертіңіз.',
		error_position:
			'"Лауазым" еңбек шартындағы "Лауазымға" сәйкес келмейді. Тағайындау мүмкін емес. Келісімшартты немесе штаттық кестені өзгертіңіз.',
		error_empty_contract: 'У работника не найдено трудовых договоров',
		error_no_contract: 'Договор не найден',
		substitute_fio: 'Фамилия, имя и отчество замещаемого сотрудника',
		remove_group:
			'Сіз кәсіптер тобын алып тастайсыз. Сіз кәсіптер тобын және оның құрамына кіретін жұмыс орындарын жойғыңыз келетініне сенімдісіз бе?',
		remove_workplace:
			'Сіз жұмыс орнын алып тастайсыз. Әрекетті қайтару мүмкін болмайды. Сіз жалғастырғыңыз келетініне сенімдісіз бе?',
		count_tariff_rate_all: 'Бірліктер саны (барлығы/еркін)',
		group_crate: 'Кәсіптер тобын құру',
		create_group: 'Кәсіптер тобын құру',
		edit_group: 'Кәсіптер тобын өңдеу',
		info_no_group: 'Мамандықтардың бірде бір тобы құрылған жоқ',
		orderDateError: 'Тағайындау күні бұйрық күнінен ерте болмауы тиіс',
		search_placeholder: 'ЖСН бойынша іздеу',
		reset: 'Тастау',
	},
	profUnions: {
		name: 'Кәсіподақтар',
		generalInformation: 'Жалпы мәліметтер',
		addGeneralInformation: 'Кәсіподақ туралы мәліметтерді қосыңыз',
		info: 'Егер сіз салалық немесе жергілікті кәсіптік одақ болсаңыз, міндетті мәліметтерді толтыру қажет',
		createTitle: 'Кәсіподақтың жеке кабинетін құру',
		editTitle: 'Кәсіподақтың жеке кабинетін өңдеу',
		approveProfUnionsField: 'Мүшелік ұйым енгізген ақпаратты растау қажет.',
		unionInfo: 'Кәсіподақ туралы ақпарат',
		createDate: 'Кәсіподақтың құрылған күні',
		unionType: 'Кәсіподақтың типі',
		industry: 'Саласы',
		descriptionUnion: 'Кәсіподақ қызметінің сипаттамасы',
		placeholderUnion: 'Кәсіподақтың сипаттамасын енгізіңіз',
		titleGoverning: 'Кәсіподақ органының құрамы',
		managerGoverning: 'Кәсіподақ органының мүшесі',
		innChairman: 'Төрағаның ЖСН',
		manager: 'Басқару органның мүшесі',
		managersList: 'Басқару органның мүшелері',
		position: 'Лауазымы',
		addMember: 'Басқарушы кеңес мүшесін қосыңыз',
		charter: 'Кәсіподақ жарғысы *',
		protocol: 'Жиналыс хаттамасы *',
		registration: 'Мемлекеттік тіркеу туралы анықтама *',
		cannotUpload: 'Қосымша файлдарды жүктеп салу мүмкін емес',
		information: 'Кәсіподақ туралы мәліметтер',
		industryUnion: 'Салалық кәсіподақ',
		tradeUnions: 'Кәсіподақтардың тізімі',
		addProfUnion: 'Кәсіби одақтарды қосу',
		docs: 'Құжаттары',
		infoList:
			'Сізде құрылымдық бөлімшелер жоқ. Сіз оларды өзіңіз қоса аласыз немесе жергілікті немесе бастапқы кәсіподақтың сұранысы бойынша қосылуды растай аласыз',
		employee_info_list: 'Сіздің ұйымыңызда кәсіподақтар жоқ',
		personsEmptyInfo:
			'Бұл кәсіподақта кәсіподақ мүшелері жоқ. Кәсіподақ оларды өзі қоса алады немесе сұраныс бойынша кіруді растай алады.',
		tradeUnionRegulations: 'Кәсіподақ туралы ереже',
		structuralUnit: 'Құрылымдық бөлімше болып табылады:',
		memberUnit: 'Мүшелік ұжым болып табылады:',
		addMemberUnit: 'Мүшелік ұжым қосу',
		structInfoUnit: 'Құрамына кіреді',
		count_manager: 'Мүшелер саны',
		approved: 'Расталды',
		excluded: 'Кәсіподақтан шығарылды',
		not_approved: 'Расталған жоқ',
		not_approved_prof: 'Кәсіподақ расталған жоқ',
		rejected_prof: 'Кәсіподақ қабылдаған жоқ',
		rejected_prof_unions: 'Кәсіподақ мүшелік ұжымы қабылдаған жоқ',
		not_approved_prof_unions: 'Кәсіподақ мүшелік ұжымы расталған жоқ',
		placeholder_primary: 'Кәсіподақ атауын енгізіңіз',
		info_list_employee: 'Егер сіз бастапқы кәсіптік одақ болсаңыз, міндетті мәліметтерді толтыру қажет',
		employee_trade_unions: 'Менің кәсіподақтарым',
		trade_members: 'Кәсіподақ мүшелері',
		add_prof_union_member: 'Кәсіподақ мүшесін қосыңыз',
		info_members: 'Сіздің кәсіподақ ұйымында әлі мүше жоқ',
		add_members_title: 'Кәсіподақ мүшелерін қосу',
		date_in: 'Қосылу күні',
		fio: 'Тегі Аты Әкесінің Аты',
		chairman_trade_union: 'Кәсіподақ төрағасы',
		noDataTradeUnion: 'Кәсіподақ туралы деректер жоқ',
		unionStatus: 'Мәртебе',
		approved_members: 'Тұрады',
		not_members: 'Тұрмайды',
		not_approved_members: 'Бекітуді күтуде',
		status_members: 'Мүшелік мәртебесі',
	},
	contactPhone: 'Байланыс телефоны',
	contactPhonePlaceholder: 'Байланыс телефонын енгізіңіз',
	laborProtection: 'Еңбекті қорғау',
	accidents: 'Жазатайым оқиғалар',
	gender: 'Жынысы',
	day: 'күн',
	day1: 'күн',
	day2: 'күн',
	accidentsPage: {
		date: 'Тергеу туралы деректерді жіберу күні: {{date}}',
		registerAccident: 'Жазатайым оқиғаны тіркеу',
		accidentDate: 'Жазатайым оқиға күні',
		victimFullName: 'Зардап шеккеннің аты-жөні',
		victimSurname: 'Тегі',
		victimFirstname: 'Аты',
		victimSecondName: 'Әкесінің аты',
		placeholderSurname: 'Тегін енгізіңіз',
		placeholderFirstname: 'Атын енгізіңіз',
		placeholderSecondName: 'Әкесінің атын енгізіңіз',
		victimIin: 'Зардап шеккеннің ЖСН',
		senderIin: 'Мәлімдеушінің ЖСН',
		severity: 'Ауырлық дәрежесі',
		state: 'Күйі',
		executionPeriod: 'Орындалу мерзімі',
		noAccidents: 'Бірде-бір жазатайым оқиға тіркелген жоқ',
		groupAccident: 'Топтық',
		registration_new_accident: 'Жазатайым оқиғаны тіркеу',
		accidentReport: 'Жазатайым оқиға туралы хабар',
		register: {
			accidentDate: 'Жазатайым оқиғаның күні мен уақыты',
			incidentScene: 'Оқиға орны',
			circumstances: 'Жазатайым оқиғаның мән-жайлары',
			selectRegion: 'Аймақты таңдаңыз',
			selectDistrict: 'Ауданды таңдаңыз',
			victim: 'Зардап шеккен',
			resident: 'ҚР резиденті',
			icd10Code: 'Код диагноза по МКБ 10',
			icd10NameProf: 'Диагнозы',
			icd10NameProfHint: 'Диагнозды немесе кәсіптік ауруды көрсету',
			selectIcd10: 'Диагнозді еңгізіңіз',
			addVictim: 'Зардап шеккенді қосу',
			responsibleFromGovernment: 'МО-дан жауапты',
			applicant: 'Мәлімдеуші',
			birthday: 'Туылған күні',
			passport: 'Паспорты',
			issuer: 'Кім берді',
			takenDate: 'Берілген күні',
			issuerName: 'Органның атауы',
			number: 'Нөмір',
			positionNkz: 'ҰҚЖ лауазымы',
			position: 'Лауазымы',
			incidentSceneHint: 'Оқиғаның толық мекенжайын көрсету қажет',
		},
		view: {
			accidentShortDate: 'ЖО күні мен уақыты',
			circumstances: 'ЖО мән-жайлары',
			victims: 'Зардап шеккендер',
			diagnosis: 'Диагнозы (кәсіптік ауру)',
			issued: ' берілген ',
			responsiblePerson: 'МО-дан жауапты адамды тағайындау күтілуде (еңбек инспекторы)',
			personCharge: 'МО-дан жауапты',
			organization: 'Ұйым',
		},
		icd: 'АХЖ-10 коды',
		boss: 'Басшы / басшының м.а.',
		send_data_value: 'Жазатайым оқиға туралы хабарлама жіберілген күн: {{date}}',
		icd_diagnosis: 'Диагнозы (АХЖ-10)',
		fio_condition_error: 'Үш мәннің бірін енгізіңіз',
		conclusionSeverity: {
			title: 'Жарақаттың ауырлық дәрежесі туралы қорытынды',
			category: 'Оқиға санаты',
			category_placeholder: 'Оқиға санатын таңдаңыз',
			med_doc: 'Медициналық мекемеден анықтама',
			doc_date: 'Құжаттың күні',
		},
		doc: 'Справка',
		startDate: 'Жарақаттың ауырлық дәрежесі туралы деректерді жіберу күні: {{date}}',
		investigationAccidents: {
			title: 'Комиссияны тағайындау',
			med_doc: 'Комиссияны тағайындау туралы бұйрық',
			bin_place_work: 'Жұмыс орнының БСН-і',
			place_work: 'Жұмыс орнының атауы',
			confirm_employee_representative: 'Жұмысшы өкілі комиссия құрамына қосылғанын растаймын.',
			assignment_order_file: 'Тағайындау туралы бұйрық файлы',
			send_data: 'Комиссия туралы деректерді жіберу күні: {{date}}',
			no_file: 'Файл жоқ',
			commission_members: 'Комиссия мүшелері',
		},
		fillingAct: {
			title: 'Н-1 актісін толтыру',
			general_info: 'Жалпы мәліметтер',
			accident_type: 'Оқиға түрі',
			category_placeholder: 'Оқиға түрін таңдаңыз',
			info_victim: 'Зардап шеккен туралы мәліметтер',
			act_number: 'Акт нөмірі',
			act_number_placeholder: 'Нөмірді енгізіңіз',
			act_date: 'Акт күні',
			experience: 'Жұмыс өтілі (жыл)',
			experience_placeholder: 'Жыл санын енгізіңіз',
			current_experience: 'Осы мамандық бойынша жұмыс өтілі',
			hours_from_start: 'Жұмыс басталған сәттен бері сағат саны',
			physical_condition: 'Физикалық жағдайы',
			physical_condition_placeholder: 'Күйін таңдаңыз',
			diagnosis: 'Диагнозы',
			icd: 'Диагнозы (АХЖ-10)',
			icd_placeholder: 'Диагнозды таңдаңыз',
			dates_briefings: 'Нұсқаулық өткізу күндері',
			induction_training_date: 'Кіріспе',
			repeated_briefing_date: 'Бастапқы, қайталау',
			knowledge_check_date: 'Білімін тексеру',
			medical_examinations: 'Медициналық тексеруден өту күндері',
			medical_preliminary_check: 'Алдын ала',
			medical_periodic_check: 'Мерзімді',
			accident_details: 'Жазатайым оқиға туралы мәліметтер',
			causes_accident: 'Жазатайым оқиғаның себептері',
			cause: 'Себеп',
			cause_placeholder: 'Себебін таңдаңыз',
			paragraph: 'Заң бабы',
			paragraph_placeholder: 'Мақала тармағын енгізіңіз',
			sub_paragraph: 'Баптың тармақшасы',
			sub_paragraph_placeholder: 'Мақала тармақшасын енгізіңіз',
			actCauseAdd: 'Себепті қосу',
			measures_eliminate_causes_accident: 'Жазатайым оқиға себептерін жою шаралары',
			actEventsAdd: 'Шараны қосу',
			description: 'Іс-шара сипаттамасы',
			description_placeholder: 'Жалпы сипаттама',
			end_date: 'Орындау мерзімі (аяқталу күні)',
			event_iin: 'Жауапты орындаушы (ЖСН)',
			event_established_post: 'Орындаушының лауазымы',
			eyewitnesses: 'Куәгерлер',
			position: 'Лауазымы',
			interview_date: 'Сұрау өткізу күні',
			witness_iin: 'Куәгер №1 (ЖСН)',
			add_witness: 'Куәгерді қосу',
			characteristic: 'Кәсіпорынның, учаскенің, жұмыс орнының сипаттамасы',
			severity: 'Ауырлық дәрежесі',
			send: 'Келісуге жібер',
			act_title: 'Акт толтырылды',
			act_hint: 'Акт будет направлен следующим лицам для согласования',
			employer_representatives: 'Жұмыс беруші өкілдері',
			employee_representatives: 'Жұмысшы өкілдері',
			add_representative: 'Өкілді қосу',
			inn_employerRepresentative: 'Жұмыс беруші өкілінің ЖСН-і',
			inn_employeeRepresentative: 'ИИН представителя работника',
			individual_representative: 'Жеке өкіл',
			title_status_table: 'Н-1 актісінің қол қою мәртебесі',
			accident: 'Жазатайым оқиға',
			act_representative: 'Қарау үшін актіні таңдаңыз',
			act_representative_placeholder: 'Қарау үшін актіні таңдаңыз',
			signSuccess: 'Қол қою және жіберу сәтті орындалды',
			signError: 'Қол қою немесе жіберу кезінде қате пайда болды',
		},
		severityResult: 'Тергеу нәтижесі',
		accidentInvestigation: 'Жазатайым оқиғаны тергеу',
		comissionAdd: 'Комиссия мүшесін қосу',
		comissionNumber: 'Комиссия мүшесі №{{count}}',
		specialInvestigationReport: {
			title: 'Арнаулы тексеру актісі',
			act: {
				actNumber: 'Акт нөмірі',
				investigationPeriod: 'Тергеп-тексеру кезеңі',
				investigationPeriodDate: '{{startDate}} тен {{endDate}} дейін',
				riskGroup: 'Тәуекел тобы',
				characteristicEnterprise: 'Кәсіпорын сипаттамасы',
				commissionConclusion: 'Комиссия қорытындылары',
				reasonAccident: 'Еңбек жазатайым оқиғасының себебі',
				articleLaw: 'Заң бабы',
				paragraph: 'Тармақ',
				subparagraph: 'Тармақша',
			},
			commission: {
				title: 'Комиссия',
				commissionNumber: 'Комиссия нөмірі',
				position: 'Лауазымы',
				organization: 'Ұйым',
				opinion: 'Ерекше пікір',
				chairman: 'Төраға',
			},
			injureds: {
				title: 'Зардап шеккендер',
				experience: 'Жұмыс өтілі (жыл)',
				employeeGuilt: 'Жұмысшының кінә дәрежесі',
				employeeGuilt_placeholder: '',
				introductoryBriefingDate: 'Кіріспе нұсқаулықтың күні',
				employerGuilt: 'Жұмыс берушінің кінә дәрежесі',
				employerGuilt_placeholder: 'Введите число(процент)',
				initialDate: 'Бастапқы және қайталап нұсқаулық күндері',
				dependents: {
					title: 'Асырауындағы тұлғалар',
					kinshipDegree: 'Туыстық дәрежесі',
				},
				checkDate: 'Білімін тексеру күні',
				prevMedCheckDate: 'Алдын ала медициналық тексеру күні',
				periodMedCheckDate: 'Мерзімді медициналық тексеру күні',
			},
			events: {
				title: 'Жазатайым оқиға себептерін жою бойынша іс-шаралар',
				desc: 'Іс-шаралардың сипаттамасы',
				date: 'Орындау мерзімі',
				responsibleExecutor: 'Жауапты орындаушы',
				position: 'Орындаушының лауазымы',
			},
			eyewitnesses: {
				title: 'Куәлар',
				experience: 'Жұмыс өтілі (жыл)',
				birthDate: 'Дата рождения',
				interviewDate: 'Сұхбат күні',
				position: 'Лауазымы',
				address: 'Адрес',
				phone: 'Байланыс телефоны',
			},
			date_investigation: 'Арнайы тергеп-тексеру деректерін алу күні: {{date}}',
			waiting: 'Арнайы тергеп-тексеру деректерін күту',
			dateN1: 'Н-1 актісі бойынша деректерді жіберу күні: {{date}}',
		},
		success: 'Успешно!',
		alert:
			'Сіз осы жазатайым оқиға бойынша барлық Н-1 актілеріне қол қойғалы отырсыз. Барлық актілермен алдын ала танысуыңызды сұраймыз.',
		checkDoc: {
			numberDate: '{{actDate}} ж. бастап №{{actNumber}}',
			employerRepresentativesSign: 'Жұмыс беруші өкілдерінің қолы',
			employeeRepresentativesSign: 'Жұмысшы өкілдерінің қолы',
			signing: 'Қол қоюда ',
			employerRepresentativesSignFio: '{{fio}}, Қол қою уақыты: {{date}}',
		},
	},
	occupational_risks_assessment: {
		search_placeholder: 'Iздеу',
		object: 'Объект',
		memberOfCommission: '',
		add_equip: '',
		ora_table: {
			field_1: 'Өтінім нөмірі',
			field_2: 'Объект',
			field_3: 'Өтінім берген күні',
			field_4: 'Интегралды бағалау жүргізудің жоспарланған мерзімі (жұмыс күндері)',
			field_5: 'Қызметтердің жалпы құны, теңге',
			field_6: 'Статус',
			project: 'Жоба',
		},
		steps: {
			step_1: {
				title: 'КТБ жататын объектілер',
				field_1: 'Кәсіпорын БСН/ЖСН',
				step_1_table: {
					field_1: 'БСН',
					field_2: 'Объектінің атауы',
					field_3: 'Заңды мекенжайы',
					field_4: 'Басты ЭҚЖЖ',
					field_5: 'Қосымша ЭҚЖЖ',
					field_6: 'Жазба мәртебесі',
				},
				add_object: 'Объект қосу',
				edit_object: 'Объект өңдеу',
				add_object_title: 'Объект қосу',
				rejected: 'Қабылданбады',
				waiting: 'Күтілуде',
				branch_alert:
					'Таңдалған филиалдарға штаттық кестелерді жіберу туралы хабарлама жолданады. Филиалдар бұл сұрауды келісуі немесе қабылдамауы мүмкін.',
				set_address: 'Укажите адрес объекта',
				set_oked: 'Укажите ОКЭД объекта',
				address_kaz: 'Адрес на казахском',
				address_rus: 'Адрес на русском',
				fact_address: 'Фактический адрес',
				error: 'Нысандар бойынша барлық мәліметтерді толтырыңыз'
			},
			step_2: {
				info_not_staff:
					'Сізде штаттық кесте толтырылмаған. Кәсіптік тәуекелдерді бағалау өтінімін қалыптастыру үшін штаттық кесте енгізу қажет.',
				info_not_staff_notification:
					'Сізде штаттық кесте толтырылмаған. Кәсіптік тәуекелдерді бағалау өтініміне келісім беру үшін штаттық кесте енгізу қажет\n',
				info_staff: 'Штаттық кестені жаңартқаннан кейін бұрын енгізілген барлық деректер сақталмайды',
				harmful: 'Зиянды факторлар',
				protective_equipment: 'Жеке қорғаныс құралдары (ЖҚҚ) бойынша деректер',
				equipments: 'Жабдық бойынша деректер',
				title: 'Кәсіпорын құрылымы',
				step_2_table: {
					field_1: '№',
					field_2: 'Мамандығы/лауазымы',
					field_3: 'Бөлім',
					field_4: 'Қызметкерлер санаты',
					field_5: 'Штаттық бірліктер саны',
				},
				eq_table: {
					field_1: 'Атауы',
					field_2: 'Пайдалануға берілген күні',
					field_3: 'Пайдалану мерзімі',
					field_4: 'Пайдалану мерзіміне сәйкестігі',
				},
				protective_table: {
					field_1: 'Атауы',
					field_2: 'Шығарылым нормасы',
					field_3: 'Типтік нормаларға сәйкестігі',
					field_4: 'ТР ТС 019/2011 талаптарына сәйкестігін растайтын сертификат',
				},
				update_schedule: 'Штаттық кестені жаңарту',
				empty_table: 'Деректер жоқ!',
				category: 'Негізгі персонал санаты'
			},
			step_3: {
				title: 'Өтінімді жіберу',
				field_1: 'Кәсіптік бағалау жүргізудің жоспарланған мерзімі',
				field_2: 'Қызметтердің жалпы құны, теңге',
				info: {
					first_row: 'Маңызды хабарлама! Назар аударыңыз, кәсіпорын келесі үшін жауапкершілік алады:',
					second_row: '1. Өтінімде толтырылған мәліметтердің дұрыстығы.',
					third_row: '2. Жұмыстарды орындау мерзімдерінің шынайылығы.',
					fourth_row: '3. Қызметтің көрсетілген соңғы құны жұмыстың нақты бағасын көрсетуі тиіс.',
					fifth_row:
						'Деректердегі, мерзімдердегі немесе құндағы қателіктер кешіктіруге алып келуі мүмкін. Өтінімді жібермес бұрын оны мұқият тексеріңіз.',
				},
			},
			step_4: {
				info: '',
				title: 'Арнайы ұйымды таңдау',
				field_1: '',
				field_2: '',
				field_3: '',
				field_4: '',
				field_5: '',
				field_6: '',
				field_7: '',
				field_8: '',
				alertSoDataDtoList: '',
				alertNoDataDtoList: '',
				protocol_field_1: 'Арнайы ұйымның БСН/ЖСН',
				protocol_field_2: 'Арнайы ұйымның атауы',
				protocol_field_3: 'Арнайы ұйымның мекенжайы',
				protocol_field_4: 'Байланыс деректері',
				tab_recommend: '',
				tab_all: '',
				table_title: '',
				search_placeholder: '',
				table_bin: '',
				table_name: '',
				table_address: '',
				table_contacts: '',
				info_recommendation: '',
				success: '',
				error: '',
				no_results: '',
				empty_protocol:
					'Ұсынылған мамандандырылған ұйымдарды іріктеу жүргізіледі. Іріктеу үш жұмыс күні ішінде аяқталады. Сондай-ақ, "Бүкіл тізім" қойындысынан ұйымды таңдауға болады.',
			},
			step_5: {
				title: '',
				create: 'Шартты қалыптастыру',
				bank: 'Банктік деректемелер',
				field_1: 'Қол қою негіздемесі (орыс тілінде)',
				field_1_kz: 'Қол қою негіздемесі (қазақ тілінде)',
				field_2: 'Басшы',
				field_3: '',
				field_4: 'БИК',
				field_5: 'ИИК',
				field_6: 'КБЕ',
				field_7: 'Банк атауы (орыс тілінде)',
				field_7_kz: 'Банк атауы (қазақ тілінде)',
				field_1_placeholder: 'Құжаттың нөмірі мен күнін көрсете отырып, бұйрыққа, шартқа және т.б. сәйкес келетін',
				field_1_kz_placeholder: 'Құжаттың нөмірі мен күнін көрсете отырып, бұйрыққа, шартқа және т.б. сәйкес келетін',
				field_2_placeholder: 'Басшының Толық аты',
				field_3_placeholder: '',
				field_4_placeholder: 'БИК',
				field_5_placeholder: 'ИИК',
				field_6_placeholder: 'КБЕ',
				field_7_placeholder: 'Атауы',
				field_7_kz_placeholder: 'Атауы',
				e_col_agreement: 'Электрондық шарт',
				organization: 'Арнайы ұйым',
				info_recommendation: '',
				field_1_spec_org: 'Специализированная организация',
				field_2_contract_number: '',
				field_3_contract_sum: '',
				field_4_contract_create_date: '',
				field_5_contract_begin_date: '',
				field_6_contract_end_date: '',
				field_1_spec_org_placeholder: '',
				field_2_contract_number_placeholder: '',
				field_3_contract_sum_placeholder: '',
				sign_and_send: '',
			},
		},
		applications: {
			title: 'КТБ өтінімдері',
			create_new_app: 'Жаңа өтінім жасау',
			applications_table: {
				number: 'Өтінім нөмірі',
				object: 'Объект',
				date_app: 'Өтінім берген күні',
				planned_dates: 'Интегралды бағалау жүргізудің жоспарланған мерзімі (жұмыс күндері)',
				total_cost: 'Қызметтердің жалпы құны, теңге',
				status: 'Мәртебе',
			},
		},
		regulatory_information: {
			replace_notification:
				'Жаңа анықтамалықты импорттау кезінде бұрын енгізілген барлық деректер толығымен жойылып, жаңа файлдың деректерімен алмастырылады.',
			new_app_notification:
				'Жүктеліп жатқан файлдың жаңа деректері бұрын енгізілген деректерді жоймай, қолданыстағы анықтамалыққа қосылады.\n' +
				'Қайшылықтар мен қателіктерді болдырмау үшін файлдағы деректердің бұрыннан бар жазбаларды қайталамайтынына көз жеткізіңіз.',
			add_new_rec: 'Жаңа жазбаларды қосу',
			replace_all_dict: 'Барлық анықтамалықты ауыстыру',
			head_title: 'Нормативтік-анықтамалық ақпарат',
			has_error: 'Сізде нормативтік-анықтамалық ақпарат жоқ',
			create: 'Құрылды',
			update: 'Өзгертілген',
			delete: 'Жойылған',
			sure_delete: '',
			title: 'НАА',
			equipment: 'Жабдықтар',
			equipment_modal: {
				title: 'Жабдықтарды қосу',
				object: 'Жабдықтар',
				field_1: 'Атауы',
				field_2: 'Пайдалануға берілген күні',
				field_3: 'Пайдалану мерзімі',
				field_4: 'Шексіз',
				field_5: 'Пайдалану мерзіміне сәйкестігі',
				field_6: 'Инвентарлық нөмір',
			},
			protective_equipment: 'ЖҚҚ',
			protective_equipment_modal: {
				title: 'Жеке қорғаныс құралдарын қосу',
				object: 'ЖҚҚ',
				field_1: 'ЖҚҚ атауы (қазақ тілінде)',
				field_2: 'ЖҚҚ атауы (орыс тілінде)',
				field_3: 'ЖҚҚ нормативтік құжаты',
				field_4: 'Шығарылым нормасы',
				field_5: 'Типтік нормаларға сәйкестігі',
				field_6: 'ТР ТС 019/2011 талаптарына сәйкестігін растайтын сертификат бар ма',
			},
			add_equip: 'Жазбаны қосу',
			import: 'Импорттау',
			download_dict: 'Анықтамалықты жүктеу',
			show_remove: 'Жойылғандарды көрсету',
			abbreviated: 'Кестенің қысқартылған түрі',
			info_table: {
				id: 'ID',
				name: 'Атауы',
				date_of: 'Пайдалануға берілген күні',
				rec_status: 'Жазба мәртебесі',
				service_life: 'Пайдалану мерзімі',
				within_service_life: 'Пайдалану мерзіміне сәйкес',
				create_date: 'Құрылу күні',
				update_date: 'Соңғы жаңарту',
				bin: 'Пайдаланушы',
			},
			info_table_protective: {
				id: 'ID',
				name_kz: 'Атауы (қазақ тілінде)',
				name_rus: 'Атауы (орыс тілінде)',
				date_create: 'Құрылу күні',
				last_update: 'Соңғы жаңарту',
				user: 'Пайдаланушы',
				rec_status: 'Жазба мәртебесі',
				normativ_document: 'ЖҚҚ нормативтік құжаты',
				rate_months: 'Шығарылым нормасы, айлар бойынша',
				compliant_standards: 'Типтік нормаларға сәйкестігі',
				is_cert: 'ТР ТС 019/2011 талаптарына сәйкестігін растайтын сертификат бар ма',
			},
		},
		contracts: {
			title: 'КТБ шарттары',
		},
		submit: 'Жаңа өтінім жасау',
		table_notification: '',
		occupational_risks_table: {
			number: '№',
			profession: 'Мамандығы/лауазымы',
			subdivision: 'Бөлім',
			personal_category: 'Қызметкерлер санаты',
			number_of_staff_units: 'Штаттық бірліктер саны',
		},
		add_harmful: 'Зиянды факторлар қосу',
		accept: 'Келісу',
		bin_iin: 'Кәсіпорын БСН/ЖСН',
		status: {
			create: 'Жаңа',
			update: 'Өзгертілген',
			delete: 'Жойылған',
		},
		request_from: 'Заявка от {{date}}',
		total: 'Всего: {{count}} заявок',
	},
	notification_open_my_unions: 'Өту',
	industryAgreement: {
		title: 'Салалық келісімдер',
		create: 'Салалық келісімді тіркеу',
		edit: 'Өңдеу',
		titleCreate: 'Салалық келісімді тіркеу',
		titleEdit: 'Салалық келісімді өңдеу',
		info: 'Салалық келісімдер тіркелмеген',
		agreement_data: 'Келісімнің деректері',
		industryAgreementName: 'Салалық келісімнің атауы',
		industryAgreementNameKz: 'Салалық келісімнің қазақ тіліндегі атауы',
		industryAgreementNameRu: 'Салалық келісімнің орыс тіліндегі атауы',
		placeholder_name: 'Атауын енгізіңіз',
		authStateName: 'Қызмет саласына тиісті уәкілетті мемлекеттік органның атауы',
		authStateNameKz: 'Қызмет саласына жауапты уәкілетті мемлекеттік органның қазақ тіліндегі атауы',
		authStateNameRu: 'Қызмет саласына жауапты уәкілетті мемлекеттік органның орыс тіліндегі атауы',
		industryAgreement: 'Саланың түрі',
		information_industry: 'Салалық кәсіподақтар туралы ақпарат',
		union: 'Кәсіподақ №',
		tradeUnionNameKz: 'Салалық кәсіподақтың қазақ тіліндегі атауы',
		tradeUnionNameRu: 'Салалық кәсіподақтың орыс тіліндегі атауы',
		add_union: 'Салалық кәсіподақты қосу',
		information_associations: 'Информация об отраслевых объединениях работодателей',
		associations: 'Жұмыс берушілер бірлестігі №',
		employerAssociationNameKz: 'Салалық жұмыс берушілер бірлестігінің қазақ тіліндегі атауы',
		employerAssociationNameRu: 'Салалық жұмыс берушілер бірлестігінің орыс тіліндегі атауы',
		add_association: 'Салалық жұмыс берушілер бірлестігін қосу',
		information: 'Салалық келісім туралы ақпарат',
		createDate: 'Тіркелу күні',
		dateFrom: 'Жасалған күні',
		dateTo: 'Әрекет ету мерзімінің аяқталу күні',
		coefficients: 'Разрядаралық коэффициенттерді белгілеу туралы',
		industrialCoef: 'Еңбектің зияндылығы мен қауіптілігіне қарай салалық коэффициент',
		baseSalary: 'Ең төменгі тарифтік мөлшерлеме (жалақы)',
		oneToTwoGradeCoef: 'I және II разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		twoToThreeGradeCoef: 'II және III разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		threeToFourGradeCoef: 'III және IV разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		fourToFiveGradeCoef: 'IV және V разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		fiveToSixGradeCoef: 'V және VI разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		sixToSevenGradeCoef: 'VI және VII разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		sevenToEightGradeCoef: 'VII және VIII разрядтар арасындағы разрядаралық коэффициенттің ең төменгі мәні',
		scanned: 'Салалық келісімнің сканерленген көшірмесі',
		bin: 'Салалық кәсіподақтың БСН',
		bin_employer: 'Салалық жұмыс берушілер бірлестігінің БСН',
		error_message: 'Салалық кәсіподақ табылмады, БСН тексеріңіз',
		guarantee_title: 'Салалық келісімдерде көзделген қызметкерлер үшін қосымша кепілдіктер мен жеңілдіктер',
		view: {
			title: 'Салалық келісім',
			tradeUnions: ' Салалық кәсіподақтар туралы ақпарат',
			employers: 'Салалық жұмыс берушілер бірлестігі туралы ақпарат',
		},
		table: {
			note: 'Ескертпе (өзгерту)',
			copy: 'Келісімнің сканерленген көшірмесі',
			name: 'Салалық келісімнің тарихы',
		},
		edit_info: 'Өзгерістері туралы ақпарат',
		updateDateTime: 'Өзгерту күні',
		updateTextKz: 'Өзгерістерге қатысты қазақ тіліндегі ескертпе',
		updateTextRu: 'Өзгерістерге қатысты орыс тіліндегі ескертпе',
		updateText_placeholder: 'Өзгерістер бойынша ақпаратты енгізіңіз',
		labelKz: ' (қазақ тілінде)',
		labelRu: ' (орыс тілінде)',
		confirm_modal: 'Салалық келісім деректері сақталады. <br /> Әрекетті растаңыз',
		edit_add: 'Өзгерістер немесе толықтырулар енгізу',
	},
	ckp_enterprise_passport: 'Кәсіпорын паспорты',
	ckp_no_info_on_your_enterprise: 'Сіздің кәсіпорыныңыз бойынша ақпарат жоқ',
	ckp_general_data: 'Жалпы деректер',
	ckp_objects: 'Нысандар',
	ckp_OSRNS: 'ЖОҚМС',
	ckp_organizational_form: 'Ұйымдастыру нысаны',
	ckp_BIN_IIN: 'БСН/ЖСН',
	ckp_registration_date: 'Тіркеу күні',
	ckp_ownership_right: 'Меншік құқығы',
	ckp_legal_address: 'Заңды мекен-жайы',
	ckp_region: 'Аймақ',
	ckp_phone: 'Телефон',
	ckp_manager: 'Басшы',
	ckp_statistics: 'Статистика',
	ckp_risk_level: 'Тәуекел деңгейі',
	ckp_average_rating: 'Орташа баға',
	ckp_employees: 'Қызметкерлер',
	ckp_citizens_foreigners: 'ҚР азаматтары/ Шетелдіктер',
	ckp_salary_for_12_24_months: '12 ай/ 24 ай ОАЖ',
	ckp_salary_by_region_and_OKED: 'Аймақ бойынша ОАЖ және ЭҚЖЖ/ ОАЖ бойынша',
	ckp_median_for_12_24_months: '12 ай/ 24 ай медианасы',
	ckp_salary_at_enterprise: 'Кәсіпорындағы ОАЖ',
	ckp_salary_for_citizens_foreigners: 'ҚР азаматтарында/ шетелдіктерде ОАЖ',
	ckp_full_enterprise_passport: 'Толық кәсіпорын паспорты',
	ckp_high: 'Жоғары',
	ckp_absent: 'Жоқ',
	ckp_medium: 'Орташа',
	ckp_low: 'Төмен',
	ckp_object_data_in_this_tab:
		'Осы қойындыда Қазақстан Республикасы Бас прокуратурасының Құқықтық статистика және арнайы есепке алу комитетінің деректері бойынша субъект объектілері туралы деректер',
	ckp_status: 'Мәртебесі',
	ckp_active: 'Белсенді',
	ckp_inactive: 'Белсенді емес',
	ckp_total_OSRNS_contracts: 'ЖОҚМС шарттарының жалпы саны',
	ckp_total_employees_insured_uninsured: '(сақтандырылған/ сақтандырылмаған)',
	ckp_contract_number_series: '№  СЖБД',
	ckp_conclusion_date: 'Жасалған күні',
	ckp_start_date: 'Әрекет ету басталуы',
	ckp_end_date: 'Аяқталу күні',
	ckp_insurance_company: 'Сақтандыру компаниясы',
	ckp_insured_employees_count: 'Сақтандырылған жұмысшылардың саны',
	ckp_validity_period: 'Әрекет ету мерзімі',
	ckp_insurer_BIN_IIN: 'Сақтандырушының ЖСН/БСН',
	ckp_insurance_company_name: 'Сақтандыру компаниясы (атауы)',
	ckp_total_annual_payroll: 'Жылдық жалпы ЕТҚ',
	ckp_version_number: 'Нұсқаның №',
	ckp_version_date: 'Нұсқаның күні',
	ckp_insurance_premium: 'Сақтандыру жарнасы',
	ckp_total_employees: 'Жұмысшылардың жалпы саны',
	ckp_branch_BIN: 'Бөлімшенің ЖСН-ны',
	ckp_number_of_workers: 'Жұмысшылар саны (персонал түрін есепке алмағанда)',
	ckp_inspections: 'Тексерулер',
	ckp_total_professional_control: 'Барлығы (кәсіби бақылау/ жоспардан тыс/ тапсырмалар)',
	ckp_active_completed: 'Ағымдағы/ аяқталған',
	ckp_active_completed_osrns: '(белсенді/ тоқтатылған)',
	ckp_instructions_issued: 'Нұсқаулар енгізілді',
	ckp_administrative_cases_initiated: 'Әкімшілік істер қозғалды',
	ckp_measures_taken: 'Қабылданған шаралар',
	ckp_KPSU_number: 'ҚСжАЕК №',
	ckp_inspection_type: 'Тексерунің түрі',
	ckp_execution_period: 'Өткізу мерзімі',
	ckp_inspector: 'Инспектор',
	ckp_unscheduled: 'Жоспардан тыс',
	ckp_preventive_control: 'Профилактикалық бақылау',
	ckp_violations_monitoring: 'Бұзушылықтар мониторингі',
	ckp_employment_contracts: 'Еңбек шарттары',
	ckp_total_OPV: 'Жалпы МЗТ',
	ckp_discrepancy_OPV_TD: 'МЗТ-ның және EШ-ның алшақтығы',
	ckp_discrepancy_TD_OPV: 'EШ-ның және МЗТ-ның алшақтығы',
	ckp_IRS_permissions: 'ШЖК-ға рұқсаттары',
	ckp_labor_migrants: 'Еңбек мигранттары',
	ckp_detection_date: 'Анықталған күні',
	ckp_violation_type: 'Бұзушылық түрі',
	ckp_description: 'Сипаттамасы',
	ckp_info_on_violations_updated_monthly: 'Қолданыстағы бұзушылықтар туралы ақпарат айына бір рет жаңартылады',
	ckp_workers: 'Қызметкерлер',
	ckp_source: 'Дереккөз',
	ckp_occupational_risks_assessment: 'Кәсіптік тәуекелдерді бағалау',

	ckp_general_info: 'Жалпы мәліметтер',
	ckp_name: 'Атауы',
	ckp_BIN: 'БСН',
	ckp_address: 'Мекен-жайы',
	ckp_contact_info: 'Байланыс ақпараты',
	ckp_OKED: 'ЭҚЖЖ',
	ckp_Keitz_index: 'Кейтц Индексі',
	ckp_risk_map_indicators: 'Еңбек тәуекелдері картасының көрсеткіштері',
	ckp_labor_risks: 'Еңбек тәуекелдері',
	ckp_financial_risks: 'Қаржылық тәуекелдер',
	ckp_social_risks: 'Әлеуметтік тәуекелдер',
	ckp_moderate_severe_injuries: 'Орташа және ауыр жарақат',
	ckp_staff_growth_percentage: 'Штат өсімнің %',
	ckp_staff_turnover_percentage: 'Кадрлар айналымы %',
	ckp_dismissed_for_negative_reasons_percentage: 'Теріс себептермен жұмыстан шығарылғандардың үлесі',
	ckp_management_foreigners_vs_citizens_ratio: 'Шетелдіктер мен ҚР азаматтарының басшылығындағы арақатынас',
	ckp_ERSON_inspections: 'ТСОБТ тексерулер',
	ckp_foreigners_in_staff_percentage: 'Штаттағы шетелдіктердің %',
	ckp_city_forming_enterprise: 'Қала құраушы кәсіпорынның белгісі',
	ckp_salary_difference_foreign_vs_citizens_management:
		'Шетелдіктер мен ҚР азаматтары басшыларының еңбекақысындағы айырмашылық',
	ckp_current_salary_below_30_percent: 'Ағымдағы ОАЖ өңірге және ЭҚЖЖ-ға қарағанда 30% - ға аз',
	ckp_salary_disproportion_max_vs_min: 'Максималды және минималды ОАЖ арасындағы диспропорция',
	ckp_salary_growth_rate: 'Төлемдердің өсу қарқыны',
	ckp_overdue_credit_percentage: '90 күннен астам несие мерзімі өткен үлес',
	ckp_harmful_production_staff_percentage: 'Зиянды өндірісі бар қызметкерлердің үлесі',
	ckp_large_family_staff_percentage: 'Көп балалы қызметкерлердің үлесі',
	ckp_non_local_staff_percentage: 'Жергілікті еместердің үлесі',
	ckp_young_staff_percentage: '30 жасқа дейінгі қызметкерлердің үлесі',
	ckp_group_DE_percentage: 'D,E тобына жататын қызметкерлердің үлесі',
	ckp_enterprise_portrait: 'Кәсіпорынның портреті',
	ckp_total_staff: 'Қызметкерлердің жалпы саны',
	ckp_total_OPV_staff_last_3_months: 'МЗТ бойынша соңғы 3 айдағы қызметкерлердің жалпы саны',
	ckp_average_salary_per_month: 'Орташа айлық жалақы, тг',
	ckp_median_salary_per_month: 'Медианалық жалақы, тг',
	ckp_last_12_months: 'Соңғы 12 ай',
	ckp_last_24_months: 'Соңғы 24 ай',
	ckp_employment_dismissal: 'Жұмысқа орналастыру/ Жұмыстан шығару',
	ckp_employed: 'Жұмысқа орналасқандар',
	ckp_dismissed: 'Жұмыстан шығарылған',
	ckp_dismissed_negative_reasons: 'Теріс себептермен',
	ckp_total_inspections: 'Тексерулер саны',
	ckp_prof_control: 'Проф. Бақылау',
	ckp_unscheduled_inspections: 'Жоспардан тыс',
	ckp_active_cases: 'Жарамды',
	ckp_completed_cases: 'Аяқталған',
	ckp_measures_on_inspections: 'Тексеру шаралары',
	ckp_instructions_given: 'Берілген ұйғарымдар',
	ckp_administrative_cases_opened: 'Әкімшілік істер қозғалды',
	ckp_OSRNS_contracts: 'ЖОҚМС шарттары',
	ckp_available_documents: 'Бар',
	ckp_not_available_documents: 'Жоқ',
	ckp_active_contracts: 'Белсенді',
	ckp_terminated_contracts: 'Тоқтатылған',
	ckp_injury_cases: 'Жарақаттанушылық',
	ckp_light_moderate_injuries: 'Жеңіл/Орташа дәреже',
	ckp_severe_injuries: 'Ауыр дәреже',
	ckp_fatalities: 'Қаза тапқандар',
	ckp_violations: 'Бұзушылықтар',
	ckp_workers_portrait: 'Жұмысшылардың портреті',
	ckp_status_based: 'Мәртебесі бойынша',
	ckp_welfare_based: 'Әл-ауқат бойынша',
	ckp_hazardous_conditions: 'Зиянды еңбек жағдайларында (МКЗЖ бойынша)',
	ckp_local_workers: 'Жергілікті',
	ckp_non_local_workers: 'Жергілікті емес',
	ckp_seasonal_workers: 'Маусымдық',
	ckp_large_family_percentage: 'Көп балалы қызметкерлер',
	ckp_ASP_recipients: 'АӘК алатын тұлғалар',
	ckp_LSI_percentage: 'Мүгедектер',
	ckp_chronic_conditions_percentage: 'Созылмалы аурулармен',
	ckp_income_per_family_member: 'Табыс (отбасы мүшесіне)',
	ckp_indebtedness: 'Несиелендірілген',
	ckp_category_A: 'А санаты',
	ckp_category_B: 'B санаты',
	ckp_category_C: 'C санаты',
	ckp_category_D: 'D санаты',
	ckp_category_E: 'E санаты',
	ckp_below_poverty_line: 'Төменгі күнкөріс деңгейінен төмен',
	ckp_below_minimum_wage: 'Ең төменгі жалақыдан төмен',
	ckp_has_loans: 'Несиелері бар',
	ckp_loan_overdue_90_days: 'Мерзімі 90 күннен асқан',
	ckp_ERSON_registration: 'ТСОБТ-не тіркелу',
	ckp_ERSON_registration_denied: 'ТСОБТ тіркеуден бас тартылды',
	ckp_ERSON_refinement_in_GO: 'МО-ға пысықтауға',
	ckp_ERSON_registered: 'ТСОБТ-не тіркелген',
	ckp_suspended: 'Тоқтатылды',
	ckp_resumed: 'Жаңартылды',
	ckp_canceled_inspection: 'Тексерудің күші жойылды',
	ckp_completed: 'Аяқталды',
	ckp_checks: 'Тексерулер',
	ckp_foreginers: 'Шетелдіктер',
	ckp_download_pdf: 'PDF жүктеу',
	ckp_from: 'бастап',
	ckp_to: 'дейін',
	ckp_check_title: 'Тексерулер бойынша ақпарат',
	ckp_abbreviations:
		'ҚСжАЕК - Құқықтық статистика және арнайы есепке алу жөніндегі комитеті\n' +
		'ТСОБТ - Тексеру субъектілері мен объектілерінің бірыңғай тізілімі\n' +
		'БМЕИ – Бас мемлекеттік еңбек инспекторы\n' +
		'МО – Мемлекеттік орган\n',
	reviews: {
		title: 'Пікірлер',
		employee_review: 'Қызметкер туралы пікір',
		employee_rating: 'Қызметкердің бағасы',
		employer_rating: 'Жұмыс берушінің бағалауы',
		set_review_employer: 'Жұмыс берушіге пікір қалдыру',
		set_review_employee: 'Қызметкерге пікір қалдыру',
		edit_answer: 'Жауапты өңдеу',
		delete_answer: 'Жауапты жою',
		edit_review: 'Пікірді өңдеу',
		delete_review: 'Пікірді жою',
		employee_answer: 'Қызметкердің жауабы',
		employer_answer: 'Жұмыс берушінің жауабы',
		set_review: 'Пікір қалдыру',
		set_review_employee_agreement: 'Сіз қызметкер туралы пікір қалдыруды қалайсыз ба?',
		set_review_employer_agreement: 'Сіз жұмыс берушіге пікір қалдыруды қалайсыз ба?',
		delete_review_employee_agreement:
			'Қызметкер туралы пікірді жоюды растайсыз ба? Өзгерістер енгізілген жағдайда, осыған дейін қызметкер туралы пікір сұратқан жұмыс берушілерде ескі пікір сақталады.',
		delete_review_employer_agreement: 'Жұмыс беруші туралы пікірді жоюды растайсыз ба?',
		edit_review_employee_agreement: 'Сіз жұмыс беруші туралы пікірді өңдеуді растайсыз ба?',
		edit_review_employer_agreement:
			'Қызметкер туралы пікірді өңдеуді растайсыз ба? Өзгерістер енгізілген жағдайда, осыған дейін қызметкер туралы пікір сұратқан жұмыс берушілерде ескі пікір сақталады.',
		set_answer: 'Жауап қалдыру',
		set_answer_agreement: 'Пікірге жауап қалдыруды растайсыз ба?',
		edit_answer_employee_agreement: 'Жауапты өңдеуді растайсыз ба?',
		edit_answer_employer_agreement:
			'Жауапты өңдеуді растайсыз ба? Өзгерістер енгізілген жағдайда, осыған дейін қызметкер туралы пікір сұратқан жұмыс берушілерде ескі пікір сақталады.',
		delete_answer_agreement:
			'Жауапты жоюды растайсыз ба? Өзгерістер енгізілген жағдайда, осыған дейін қызметкер туралы пікір сұратқан жұмыс берушілерде ескі пікір сақталады.',
		answer: 'Жауап беру',
		my_reviews: 'Маған қатысты пікірлер',
		reviews_about_me: 'Маған арналған пікірлер',
		mark: 'Бағалау',
		count: 'Саны',
		marks: 'Бағалаулар саны',
		avg_ball: 'Орташа балл',
		success_payload: 'Сәтті қол қойылды!',
		review_deleted_employer: 'Пікір жұмыс берушімен жойылған',
		review_deleted_employee: 'Пікір қызметкермен жойылған',
		review_text_null: '(Пікірі жоқ)',
		placeholder_text: 'Мәтінді теріңіз',
		terminate_alert_text:
			'Контрагент туралы пікір қалдыру кезінде пайдаланушы ұсынған ақпараттың шынайылығы үшін толық жауапкершілік арқалайды. Желіде әдейі жалған (шындыққа сәйкес келмейтін) ақпаратты орналастыру немесе тарату заң жүзінде жауапкершілікке әкеледі. Атап айтқанда, Қазақстан Республикасы Әкімшілік құқық бұзушылық туралы кодексінің 456-2-бабында жалған ақпаратты тарату үшін әкімшілік жауапкершілік көзделген. Қоғамдық тәртіпке қауіп төндіретін немесе азаматтарға, ұйымдарға не мемлекетке елеулі залал келтіретін әдейі жалған ақпаратты тарату — Қазақстан Республикасы Қылмыстық кодексінің 274-бабы бойынша қылмыстық жауапкершілікке әкеп соғады.',
		view_alert_text_employee:
			'Қызметкер туралы пікір қалдыру барысында пайдаланушы ұсынған ақпараттың шынайылығы үшін толық жауапкершілік арқалайды. Желіде әдейі жалған (шындыққа сәйкес келмейтін) ақпаратты орналастыру немесе тарату заң жүзінде жауапкершілікке әкеледі. Атап айтқанда, Қазақстан Республикасы Әкімшілік құқық бұзушылық туралы кодексінің 456-2-бабында жалған ақпаратты тарату үшін әкімшілік жауапкершілік көзделген. Қоғамдық тәртіпке қауіп төндіретін немесе азаматтарға, ұйымдарға не мемлекетке елеулі залал келтіретін әдейі жалған ақпаратты тарату — Қазақстан Республикасы Қылмыстық кодексінің 274-бабы бойынша қылмыстық жауапкершілікке әкеп соғады.',
		view_alert_text_employer:
			'Жұмыс беруші туралы пікір қалдыру барысында пайдаланушы ұсынған ақпараттың шынайылығы үшін толық жауапкершілік арқалайды. Желіде әдейі жалған (шындыққа сәйкес келмейтін) ақпаратты орналастыру немесе тарату заң жүзінде жауапкершілікке әкеледі. Атап айтқанда, Қазақстан Республикасы Әкімшілік құқық бұзушылық туралы кодексінің 456-2-бабында жалған ақпаратты тарату үшін әкімшілік жауапкершілік көзделген. Қоғамдық тәртіпке қауіп төндіретін немесе азаматтарға, ұйымдарға не мемлекетке елеулі залал келтіретін әдейі жалған ақпаратты тарату — Қазақстан Республикасы Қылмыстық кодексінің 274-бабы бойынша қылмыстық жауапкершілікке әкеп соғады.',
		star1: 'Өте нашар',
		star2: 'Нашар',
		star3: 'Қанағаттанарлық',
		star4: 'Жақсы',
		star5: 'Өте жақсы',
	},
	administration: {
		title: 'Әкімшілік ету',
		query: 'Сұраныс',
		set_access: 'Қолжетімділік беру',
		sign_changes: 'Өзгерістерге қол қою',
		view_register_emp_contracts: 'Еңбек шарттарын қарау және тіркеу',
		view_staffing_schedule: 'Штат кестесін қарау',
		register_staffing_schedule: 'Штат кестесін тіркеу',
		requested_with_view_staffing_schedule: '(Штат кестесін қараумен бірге сұралады)',
		canAccess: 'Қолжетімділік бар',
		request_send: 'ұраныс жіберілді',
		noAccess: 'Қолжетімділік жоқ',
		request: 'Сұрау',
		revoke: 'Кері қайтару',
		default_alert: 'Сұраныс 3 жұмыс күні ішінде қарастырылады, содан кейін оны қайта жіберуге болады.',
		isSelected_alert: 'Өзгерістерді сақтау үшін ЭЦҚ арқылы қол қою қажет',
		you_set_access: 'Сіз қолжетімділікті бердіңіз',
		you_revoke_access: 'із қолжетімділікті кері қайтардыңыз ',
		set_request_from_you: 'Сізден қолжетімділік сұралды',
		get_access_warning:
			'Для запроса прав доступа по иной организации из филиальной сети, перейдите на страницу «Администрирование»',
	},
	sickLeave: {
		title: 'Еңбекке уақытша жарамсыздық парақтары',
		open_date: 'Ашылу күні',
		closed_date: 'Жабылу күні',
		med_org: 'Медициналық ұйымның атауы',
		open: 'Ашық',
		continue: 'Ұзарған',
		close: 'Жабық',
		deleted: 'Жойылған',
		number: 'Еңбекке уақытша жарамсыздық парағы {{number}}',
		information: 'Мазмұны',
		date_end_work: 'Жұмысқа шықпаған кезең',
		start_date_work: 'Жұмысқа кірісу уақыты',
		diagnosis: 'Диагноз',
		type_temporary_disability: 'Уақытша еңбекке жарамсыздық түрі',
		mode_type: 'Режим түрі',
		send_employer: 'Жұмыс берушіге жіберу',
		choose_employer: 'Жұмыс берушіні таңдаңыз',
		approve_personal_data: 'Жеке деректерді өңдеуге келісім беремін',
		employee_alert:
			'Бұл бөлімде ҚР Денсаулық сақтау министрлігінің ақпараттық жүйесінен алынған электрондық еңбекке жарамсыздық парақтары көрсетіледі. Уақытша еңбекке жарамсыздық туралы жұмыс берушіні хабардар ету үшін деректерді оның жеке кабинетінен жіберуге болады.',
		employer_alert:
			'Бұл бөлімде ҚР Денсаулық сақтау министрлігінің ақпараттық жүйесінен алынған қызметкерлердің электрондық еңбекке жарамсыздық парақтары көрсетіледі. Олар қызметкерлер тарапынан уақытша еңбекке жарамсыздық туралы хабарлау мақсатында жеке кабинет немесе HR Enbek мобильді қосымшасы арқылы жіберіледі.',
		sent_employers: 'Жұмыс берушіге(лерге) жіберілді',
		not_sent_employers: 'Жұмыс берушіге(лерге) жіберілмеген',
		title_sent_employer: 'Жұмыс берушіге(лерге) жіберілді',
		title_export: 'Сіз деректерді жүктеп алғыңыз келетін, кезеңді таңдаңыз.',
		search_placeholder: 'Қызметкердің ЖСН-ін, аты-жөнін, әкесінің атын енгізіңіз',
	},
	ecollective_contract: {
		approved_status: 'Келісілді',
		rejected_status: 'Келісілмеген',
		pending_status: 'Келісуді күтуде',
		labor_inspectorate_officer: 'Еңбек инспекциясының қызметкері',
		comment_from_the_labor_inspectorate: 'Еңбек инспекциясының түсіндірмесі',
	},
	requirement_labor_resources: {
		title: 'Еңбек ресурстарына қажеттілік',
		agroProducer: 'Ауыл шаруашылығы тауар өндірушісінің паспорты',
		cropCultivation: 'Ауыл шаруашылығы дақылдарын өсіру',
		animalHusbandry: 'Мал ұстау',
		land_fund: 'Жер қоры',
		sowing_area: 'Егіс алқабы',
		livestock_headcount: 'Мал басы',
		area_ha: 'Аумағы, га',
		cadastral_number: 'Кадастрлық нөмір',
		crop: 'Дақыл',
		animals: 'Жануарлар',
		headcount: 'Мал басы',
		work_name: 'Жұмыс атауы',
		profession_name: 'Мамандық атаулары',
		standart_number: 'Нормаланған саны, адам',
		sowingArea: 'Егіс алаңы, га',
		stages_of_agricultural_work: 'Ауыл шаруашылығы жұмыстарының кезеңдері',
		labor_intensity_person_hours: 'Еңбек сыйымдылығы, адам-сағат',
		optimal_agrotechnical_terms: 'Оптималды агротехникалық мерзімдер',
		regulated_number_of_workers_persons: 'Нормаланған саны, адам',
		works: 'Жұмыстар',
		total: 'Барлығы',
		norm_count_season: 'Мерзімдік нормаланған жұмысшы саны, адам',
		worker_count: 'Жұмысшылар саны',
		empty_alert: 'Жүйеде сіз туралы ақпарат жоқ немесе сіз ауыл шаруашылығы өнімін өндіруші емессіз.',
		calculator: 'Калькулятор',
		cultivationCrops: 'Возделывание культур',
		livestockManagement: 'Содержание скота',
		form: {
			culture: 'Культура',
			region: 'Область',
			district: 'Район',
			square_crops: 'Площадь посевов, га',
			animal_category: 'Категория животного',
			head: 'Поголовье, голов',
			choose_culture: 'Выберите культуру',
			choose_region: 'Выберите область',
			choose_district: 'Выберите район',
			choose_category: 'Выберите категорию',
			square: 'Площадь',
			count: 'Количество',
		},
		calculate: 'Есептеу',
	},
	faq: {
		agreement: 'Келісімдер',
		choose_theme_question: 'Сұрақ тақырыбын таңдау',
		labelKz: 'қазақ тілінде',
		labelRu: 'орыс тілінде',
		export: 'Жүктеу',
		gen_agreement: 'Бас келісімдер',
		reg_agreement: 'Өңірлік келісімдер',
	},
	staff_alert:
		'"Штаттық кесте" функционалы ұйымның құрылымын, штат құрамын және қызметкерлер санын басқаруға арналған. Бұл функционал еңбекақыны, үстемелерді, қосымша төлемдерді көрсетуге, сондай-ақ тіркелген еңбек шарттарына сәйкес қызметкерлерді жұмыс орындарына тағайындауға мүмкіндік береді.',
	staff_alert_note:
		'<br/><strong>Ескерту</strong>: <i>Заңнама штаттық кестені Еңбек шарттарын есепке алудың бірыңғай жүйесіне міндетті түрде енгізуді талап етпейді, бұл құралды жұмыс берушілер өз қалауы бойынша пайдалана алады.</i>',
	medical_card: {
		lmk_series: 'ЖМК сериясы',
		workplace: 'Жұмыс орны',
		position: 'Қызметі',
		doctor_total: 'Жұмысқа рұқсат (терапевттің қорытындысы)',
		period: 'Рұқсат кезеңі',
		doctor: 'Дәрігер',
		medical_org: 'Медициналық ұйым',
		target_group: 'Нысаналы топ',
		status_approved: 'РҰҚСАТ ЕТІЛДІ ',
		status_disapproved: 'РҰҚСАТ ЕТІЛМЕДІ',
		status_expired: 'МЕРЗІМІ ӨТТІ',
	},
	contract_alert:
		'Еңбек шартын тіркей отырып, <strong>Қазақстан Республикасы Еңбек кодексінің 23-бабы 2-тармағы 24) тармақшасының</strong> нормаларын сақтайтыныңызды растайсыз.',
	login_employer: 'Жұмыс беруші ретінде кіру',
	login_employee: 'Қызметкер ретінде кіру',
	show_all_notifications: 'Барлық хабарламаларды көрсету',
	hint_page_role: 'Бұл жерде есептік жазбаға тіркелген барлық кәсіпорындардың хабарландырулары көрсетіледі.',
	flData_alert_add_contract:
		'<i>Сіз кәмелетке толмаған азаматпен электрондық қосымша келісім жасауды жоспарлап отырсыз. Кәмелетке толмағандарды жұмысқа орналастыруға тыйым салынған жұмыстардың тізімімен танысуыңызды сұраймыз.</i>',
	alert_term_contract:
		'<i>Сіз кәмелетке толмаған баламен электрондық еңбек шартын бұзғалы жатырсыз. Егер кәмелетке толмаған баланың өкілі өзгерсе, жаңа өкілдің ЖСН-ін енгізу қажет.</i>',
	flData_Checkbox: 'Таныстым ',
	flData_Checkbox_ref:
		'Он сегіз жасқа толмаған қызметкерлердің еңбегін пайдалануға тыйым салынатын жұмыстардың тізімімен',
	fl16_alert:
		'<i>Қазақстан Республикасының Еңбек кодексінің 31-бабы 3-тармағына сәйкес, он алты жасқа толмаған кәмелетке толмаған азаматпен қатар, еңбек шартын оның заңды өкілдерінің бірі қол қоюы тиіс. Сізден электрондық еңбек шартын жасау үшін заңды өкіл екеніңізді растауды сұраймыз. "Өкілдің деректерін растау" батырмасын басқан кезде Сізге деректерге қол жеткізуге сұрау салынған SMS-хабарлама жіберіледі.\n' +
		'Сізден келісім беруді сұраймыз.</i>',
	errorTeenager16:
		'Электрондық еңбек шартына қол қою мүмкін емес: шарттың жобасы кәмелетке толмаған адам үшін жасалған.',
	errorTeenager14:
		'<i>Қазақстан Республикасының Еңбек кодексінің 31-бабы 2-тармағының 3) тармақшасына сәйкес, еңбек шарты он төрт жасқа толмаған адамдармен кинематография ұйымдарында, театрларда, театрлық және концерттік ұйымдарда, цирктерде шығармаларды жасауға және (немесе) орындауға қатысу үшін олардың денсаулығы мен адамгершілік дамуына зиян келтірмей, белгіленген шарттарды сақтай отырып жасалуы мүмкін.<i>',
	fl16_button: 'Өкілдің деректерін растау',
	approve_teenager: 'Келісу',
	approve_title:
		'Электрондық еңбек шартына қол қою үшін кәмелетке толмаған баланың СМС көмегімен келісімі қажет. Келісім алу үшін кәмелетке толмаған баланың телефон нөмірін енгізіңіз',
	send_sms_button: 'СМС жіберу',
	representative: 'Кәмелетке толмаған баланың өкілі',
	isRepresentative: 'Мен осы қызметкердің қамқоршысымын',
	success_get_representatives:
		'Деректерді алу сұранысы сәтті жіберілді. Жеке деректерді өңдеуге келісімді растау қажет.',
	isChildren: 'Балалары бойынша ЕШ',
	representative_role: 'Өкіл',
	error_bin_or_iin: 'Жұмыс берушінің БСН/ЖСН табылмады',
	info_contract_form: 'Мәтіндік жолақтарды толтырыңыз!',
	info_status_request: 'Өкілдің деректерін растау мәртебесі сәтті жаңартылды.',
	representative_requests: 'Өкілдің сұраулары',
	successfully_subscribed: 'Сәтті қол қойылды!',
	level: 'Саты',
	experience: 'Өтіл',
	unit: 'Деңгей',
	send_appointment_error: 'Сізде жұмыс орындарында тағайындаулар жоқ',
	empty_table: 'Мәліметтер жоқ!',
	period: ' Жарамдылық мерзімі',
	not_accept_permission_irs: 'Сізде шетелдік жұмыс күшін тартуға рұқсатыңыз жоқ',
	iin_fio_position_number_placeholder: 'Іздеу үшін ЖСН, аты-жөні, лауазымы, рұқсат нөмірі немесе күнін енгізіңіз',
	checkDocument: {
		sickLeave: 'Электронды еңбекке уақытша жарамсыздық парағы',
		medOrgName: 'Медициналық ұйымның атауы',
		periodFreeWorkTitle: 'Жұмыстан босату кезеңі',
		periodFreeWorkDesc: '{{sinceReleasWrk }} бастап {{tillReleasWrk }} дейін',
		document_note_sl:
			'Электрондық құжат hr.enbek.kz еңбек ресурстары порталы арқылы қалыптастырылған және қағаз түріндегі құжатпен тең дәрежеде. Электрондық құжаттың түпнұсқалығын смартфон камерасы арқылы QR-кодты сканерлеу арқылы тексеруге болады.',
	},
	table_empty_data: 'Данные отсутствуют',
	please_wait: 'Подождите пожалуйста',
	timing_work: 'Жұмыс уақытының хронометражы',
	timingWork: {
		title: 'Жұмыс уақытының хронометражы',
		alert: 'Сізде жазбалар жоқ. Мәліметтерді енгізу үшін “Күнді қосу” батырмасын басыңыз',
		add_day: 'Күнді қосу',
		search: 'Іздеу',
		download: 'Жүктеп алу',
		trash: 'Жою',
		error: 'Көрсетілген күнге қатысты мәліметтер табылмады',
		table: {
			work: 'Жұмыс',
			comment: 'Анықтама',
			begin: 'Басталу <br /> уақыты',
			end: 'Аяқталу <br /> уақыты',
			enter: 'Енгізу',
			add: 'Жазба қосу',
			required: 'Міндетті',
			workFunction: 'Жұмыс/Функция',
		},
		download_title: 'Сіз таңдалған күнді жүктеп алудасыз. Мәліметтер Excel файлына жүктеледі.',
		handleDownloadConfirm: {
			success: 'Файл сәтті жүктелді!',
			error: 'Файлды жүктеу кезінде қате пайда болды',
			error_no_data: 'Есепті жүктеу үшін жеткілікті мәлімет жоқ',
		},
		handleDeleteConfirm: {
			success: 'Күн сәтті жойылды!',
			error: 'Күнді жою үшін жеткілікті мәлімет жоқ',
			error_no_data: 'Жазба қосу үшін жеткілікті мәлімет жоқ',
			error_no_org: 'Ұйым туралы ақпарат табылмады',
			error_no_employee: 'Қызметкер туралы ақпарат табылмады',
			error_no_dept: 'Белсенді бөлімше табылмады',
		},
		onAddWork: {
			success: 'Жазба сәтті қосылды!',
			error: 'Жазбаны қосу кезінде қате пайда болды',
		},
		onUpdateWork: {
			success: 'Жазба сәтті жаңартылды!',
			error: 'Жазбаны жаңарту кезінде қате пайда болды',
		},
		alert_no_data_employer: 'Сіздің ұйымыңыз бойынша жұмыскерлер енгізген жазбалар жоқ',
		alert_no_allowed: 'Бұл функционал қазіргі уақытта қолжетімсіз.',
		active: 'Белсенділер',
		dismissed: 'Босатылғандар',
		table_employees: {
			iin: 'ЖСН',
			fio: 'Т.А.Ә.',
			establishedPost: 'Лауазымы',
			funcStruct: 'Құрылымдық бөлімше',
			lastContribution: 'Соңғы енгізу күні',
		},
		alert_employee:
			'<i><p><strong>Құрметті пайдаланушы!</strong></p></i>' +
			'<i>Аталған функционал қазіргі уақытта пилоттық режимде іске асырылуда. Бұл бөлім әзірлеу сатысында, сондықтан барлық пайдаланушылар үшін уақытша қолжетімді емес.</i>' +
			'<i><br/>Функционал толық іске қосылғаннан кейін Сізге қосымша хабарлаймыз.</i>' +
			'<i><br/>Түсіністік танытқаныңыз үшін рақмет!</i>',
		button_request: 'Функционалға қолжетімділікті сұрату',
		placeholder_search: 'ЖСН немесе қызметкердің тегін енгізіңіз',
		reset: 'Тастау',
		count_employees: 'Қызметкерлер саны: {{count}}',
		update_companies_list_title:
			'Еңбек шарттарын есепке алудың бірыңғай жүйесімен салыстыру жүргізіледі. Салыстыру аяқталғаннан кейін белсенді және жұмыстан шыққан қызметкерлер тізімдері жаңартылады. Қызметкерлер тізімін жаңартуға сенімдісіз бе?',
		hint:
			'Бұл өріске орындалған жұмыстың қосымша сандық және/немесе сапалық сипаттамаларын нақтылау үшін еркін түрде ақпарат енгізіледі.\n' +
			'Сандық сипаттамаларға мысалдар: 5-құжат, 4-өтініш, 7-іс және т.б.\n' +
			'Сапалық сипаттамаларға мысал: «жұмыс басқа мекемеге шығумен орындалды».',
		tabName: 'Функциялар анықтамалығы',
	},
	nomination: {
		send_mtszn: 'Отправить в МТСЗН',
		title: '«Парыз» номинациясы',
		nomination: 'Номинация',
		date_pass: 'Ұсыну күні',
		sum: 'Сомасы',
		empty:
			'Сіз 2008 жылғы 23 қаңтардағы Қазақстан Республикасы Президентінің № 523 Жарлығына сәйкес өткізілетін «Парыз» конкурсына қатысу үшін өтінім бере аласыз.',
		create: {
			title: '«Парыз» бизнестің әлеуметтік жауапкершілігі конкурсына қатысуға өтінім беру',
			category: 'Кәсіпкерлік субъектісі санатыа',
		},
		view: {
			title: '«Парыз» бизнестің әлеуметтік жауапкершілігі конкурсына қатысуға өтінім',
			date_pass: 'Ұсыну күні: {{date}}}',
		},
		status: {
			signed: 'Қаралуда',
			approved: 'ЖАО тарапынан қарау аяқталды',
			completed: 'Еңбек инспекциясы тарапынан қарау аяқталды',
			сomputed: 'Қаралуда',
			rejected: 'ЖАО бас тартты',
		},
		request: 'Өтінімдер',
		search: 'БСН немесе ұйымның атауы',
		org_name: 'Ұйымның атауы',
		criterion: 'Критерий',
		is_data: 'АЖ деректері',
		reason_decline: 'Бас тарту себебі',
		reason_decline_hint: 'Бас тарту себебін көрсету қажет',
		reason_decline_placeholder: 'Жұмыс беруші «Парыз» номинациясының талаптарына сәйкес келмейді',
		nominations: 'Номинациялар',
		mio_data: 'ЖАО деректері',
		form_doc: 'Есепті қалыптастыру',
		balls: 'Ұпайлар',
		orgCount: '{{count}} кәсіпорын',
		downloadReport: 'Есепті жүктеу',
		provided: 'Ұсынылған',
		not_provided: 'Ұсынылмаған',
		total_kz: 'Барлық Қазақстан',
		total_list: 'Жалпы тізімде',
		by_category_list: 'Жекелеген санаттар бойынша (ірі, шағын-орта)',
		nominated_orgs: 'Кәсіпорындарды ұсыну',
		sign_form_doc: 'Есепті қол қойып, қалыптастыру',
		place: '{{place}} орын',
		add_place: 'Орынды қосу',
		large_orgs: 'Ірі кәсіпорындар',
		small_orgs: 'Шағын және орта кәсіпорындар',
		formed_report: 'Қалыптастырылған есептер',
		report_date: 'Есептің күні',
		fio_report: 'Есепті қалыптастырған тұлғаның ТАӘ',
		view_report: 'Есепті көру',
		report_not_done: 'Есеп дайын емес',
		mio_alert:
			'Ақпараттық жүйелерде жоқ өтінімдегі мәліметтерді тексеру үшін, растайтын құжаттарды тікелей жұмыс берушіден сұрату қажет',
		fioDirector: 'Басшының ТАӘ',
		foundationDate: 'Құрылған күні',
		alert_info: '«Парыз-2025» бизнесінің әлеуметтік жауапкершілігі бойынша конкурсқа өтінімдер қабылдау аяқталды.',
	},
	success: 'Сәтті - өңделді',
	error_retrieving_data: 'Деректерді алу қатесі туындады: ',
	contracts_civil_low: {
		title: 'АҚС шарттар',
		register: 'АҚС шартты тіркеу',
		edit: '{{date}} №{{number}} АҚС шартты редакциялау',
		view: '{{date}} №{{number}} АҚС шарт',
		registerNewContract: 'Жаңа АҚС шартты тіркеу',
		registerAlert: 'Қызмет көрсетуге арналған азаматтық-құқықтық сипаттағы шарттар ғана тіркелуге жатады',
		infoContract: 'АҚС шарт туралы ақпарат',
		numberContract: 'АҚС шарттың нөмірі',
		conclusionDate: 'Шарт жасалған күн',
		descServiceKz: 'Көрсетілетін қызметтің қазақ тіліндегі сипаттамасы',
		descServiceRu: 'Көрсетілетін қызметтің орыс тіліндегі сипаттамасы',
		enterDescService: 'Көрсетілетін қызметтің сипаттамасын енгізіңіз',
		totalPriceContract: 'Шарт бойынша жалпы сома (теңгемен)',
		enterPrice: 'Соманы енгізіңіз',
		paymentSchedule: 'Төлем кестесі',
		hintPriceContract:
			'АҚС шарт жасалған соманы теңгемен көрсетіңіз. Егер шарт басқа валютада жасалған болса, қол қою сәтіндегі бағам бойынша соманы теңгемен көрсетіңіз',
		hintPosition: 'Көрсетілетін қызмет бойынша кәсіптің баламасын көрсету қажет',
		deleteContract: 'Қате рәсімделген АҚС шартты жою',
		closeContract: 'АҚС шартты жабу',
		deleteModalTitle: 'Сіз АҚС шартты жойғалы отырсыз',
		deleteModalDesc:
			'Сіз АҚС шартты жоюды шынымен қалайсыз ба? Жойылған шартты қалпына келтіру мүмкін емес. Сіз сенімдісіз бе?',
		deleteModalButtonSuccess: 'Түсінікті, жоюды растаңыз',
		deleteAddModalTitle: 'Сіз АҚС шартқа қосымша келісімді жойғалы отырсыз',
		deleteAddModalDesc:
			'Сіз АҚС шартқа қосымша келісімді жоюды шынымен қалайсыз ба? Жойылған қосымша келісімді қалпына келтіру мүмкін емес. Сіз сенімдісіз бе?',
		terminateModalTitle: 'Сіз АҚС шартты бұзғалы отырсыз',
		terminateModalDesc:
			'Сіз АҚС шартты бұзуды шынымен қалайсыз ба? Азаматтық-құқықтық сипаттағы шарт бұзылғаннан кейін оны жоюға, түзетуге және оған қосымша келісімдер жасауға жол берілмейді. Сіз сенімдісіз бе?',
		terminateModalButtonSuccess: 'Түсінікті, бұзуды растаңыз',
		registerAdd: '{{date}} №{{number}} АҚС шартқа қосымша келісім жасау',
		editAdd: '{{date}} №{{number}} АҚС шартқа қосымша келісімді редакциялау',
		infoAddContract: 'Қосымша келісім туралы ақпарат',
		newCondition: 'АҚС шарттың жаңа талаптары',
		terminateTitle: '{{date}} {{number}} АҚС шартты тоқтату/бұзу',
		infoTerminateContract: 'Тоқтату/бұзу туралы ақпарат',
		emptyTable:
			'Сізде тіркелген азаматтық-құқықтық сипаттағы шарттар жоқ. Жаңа шартты тіркеу үшін "АҚС шартты тіркеу" батырмасын басыңыз',
		addContractAlert:
			'Өрістер АҚС шарттан немесе соңғы қосымша келісімнен алдын ала толтырылады. Өзгерістер енгізу қажет',
		sameDataError:
			'Қосымша келісімге қол қою үшін "Шарттың жаңа талаптары" бөліміндегі өрістердің кем дегенде біреуін өзгерту қажет',
		term_reason: 'Тоқтату/бұзу негізі',
		term_date: 'Тоқтату/бұзу күні',
		term_reason_contract: 'Шартты тоқтату/бұзу негізі',
		employer_data: 'Тапсырыс берушінің деректері',
		employee_data: 'Орындаушының деректері',
		employee_iin: 'Орындаушының ЖСН-і',
		employee_fio: 'Орындаушының Т.А.Ә.',
		employer: 'Тапсырыс беруші',
		employee: 'Орындаушы',
		start_contract_date: 'Қызмет көрсетуді бастау күні',
		work_country: 'Қызмет көрсетілетін ел',
		region_work: 'Қызмет көрсетілетін өңір',
		distrcit_work: 'Қызмет көрсетілетін аудан',
		work_address: 'Қызмет көрсетілетін мекенжай',
		job_address: 'Қызмет көрсетілетін орын',
		position_by_knz: 'ҰКЖ бойынша кәсіп',
		position_kz: 'Қазақ тіліндегі кәсібі',
		position_ru: ' Орыс тіліндегі кәсібі',
		position_placeholder: 'Кәсібін енгізіңіз',
		hint_position_knz:
			'Ұлттық кәсіптер жіктеуішіне негізделген анықтамалықтан қол жетімді кәсіптердің нұсқаларын алу үшін кәсіптің алғашқы 3 әрпін енгізуді бастаңыз',
		position: 'Кәсіп',
	},
	mismatch: {
		title: 'Жұмыскерлер бойынша алшақтықтар',
		header_text:
			'<strong>Алшақтықтар статистикасы</strong> <i>(Мәліметтер әр 1–2 тәулікте бір рет жаңартылады. Соңғы жаңарту: {{date}})</i>',
		dashboard: {
			desc_1: 'Еңбек шарттары (ЕШ) бойынша барлығы / олардың ішінен штат кестесіне тағайындалмағандары',
			desc_1_empty: 'Штаттық кесте тіркелмеген',
			hint_1:
				'Тіркелген еңбек шарттары бойынша барлық жұмыскерлер / олардың ішінен HR Enbek порталындағы штат кестесіне тағайындалмағандары',
			desc_2:
				'Еңбек шарттары бойынша барлық жұмыскерлер  / олардың ішінен соңғы 3 айда міндетті зейнетақы жарналары (МЗЖ) түспегендері',
			desc_2_empty: 'Белсенді тіркелген еңбек шарттары жоқ',
			hint_2:
				'Тіркелген еңбек шарттары бойынша барлық жұмыскерлер  / олардың ішінен соңғы 3 айда міндетті зейнетақы жарналары түспегендері (ағымдағы ай есепке алынбайды)',
			desc_3:
				'Азаматтық-құқықтық сипаттағы шарттар (АҚС) бойынша барлық жұмыскерлер / олардың ішінен соңғы 3 айда МЗЖ түспегендері',
			desc_3_empty: 'Белсенді тіркелген азаматтық-құқықтық сипаттағы шарттар жоқ',
			hint_3:
				'Тіркелген азаматтық-құқықтық сипаттағы шарттар бойынша барлығы / олардың ішінен соңғы 3 айда міндетті зейнетақы жарналары түспегендері (ағымдағы ай есепке алынбайды)',
			desc_4: 'МЗЖ бойынша жұмыскерлер саны / олардың ішінен шартсыздары (ЕШ / АҚС)',
			desc_4_empty: 'Соңғы 3 айда міндетті зейнетақы жарналары жоқ',
			hint_4:
				'Соңғы 3 айда міндетті зейнетақы жарналары төленген жұмыскерлер саны (ағымдағы ай есепке алынбайды) / олардың ішінен шартсыздары (еңбек шарты / азаматтық-құқықтық сипаттағы шарт)',
		},
		table_title: 'Алшақтықтар бар жұмыскерлер тізімі',
		reset_filter: 'Фильтрді алып тастау',
		download_list: 'Тізімді жүктеу',
		employee: 'Жұмыскерлер',
		staff: 'ШК-ға тағайындалған',
		staff_hint: 'Жұмыскерлер HR Enbek порталында тіркелген штат кестесіне тағайындалған',
		contract: 'ЕШ бар',
		contract_hint: 'Жұмыскерлерде тіркелген еңбек шарты бар',
		gph: 'АҚС бар',
		gph_hint: 'Жұмыскерлерде тіркелген азаматтық-құқықтық сипаттағы шарт бар',
		opv: 'МЗЖ бар',
		opv_hint: 'Жұмыскерлер үшін соңғы 3 айда міндетті зейнетақы жарналары төленген (ағымдағы ай есепке алынбайды)',
		empty_array: 'Жұмыскерлер бойынша алшақтықтар анықталған жоқ',
		search_placeholder: 'ЖСН немесе АТЖ бойынша іздеу',
	},
}
